const { addFilter } = wp.hooks;

import { __ } from "@wordpress/i18n";

/*

link To Arguments Terms
*/

const linkToArgTermsPro = {
	noUrl: { label: "No URL", value: "" },
	termUrl: { label: "Term URL", value: "termUrl" },

	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter("linkToArgTerms", "combo-blocks/linkToArgTerms", function (options) {
	return linkToArgTermsPro;
});

const tableTdAttr = {
	scope: { label: "Scope", id: "scope", value: "col" },
	colspan: { label: "Colspan", id: "colspan", value: "" },
	rowspan: { label: "Rowspan", id: "rowspan", value: "" },
	custom: { label: "Custom", id: "custom", value: "" },
};

addFilter(
	"postgridtableTdAttr",
	"combo-blocks/postgridtableTdAttr",
	function (options) {
		return tableTdAttr;
	}
);

var postAuthorFieldArgsPro = {
	id: { label: "ID", value: "ID" },
	url: { label: "URL", value: "url" },
	registered: { label: "Registered", value: "registered" },
	display_name: { label: "Display name", value: "display_name" },
	first_name: { label: "First name", value: "first_name" },
	last_name: { label: "Last name", value: "last_name" },
	description: { label: "Description", value: "description" },
	avatar: { label: "Avatar", value: "avatar" },
	custom: { label: "Custom Field", value: "custom" },
};
addFilter(
	"postAuthorFieldUserField",
	"combo-blocks/linkToArgTerms",
	function (options) {
		return postAuthorFieldArgsPro;
	}
);

const pgDateCountdownTypesPro = {
	fixed: { label: "Fixed", value: "fixed" },
	everGreen: { label: "Ever Green", value: "everGreen" },
	scheduled: { label: "Scheduled", value: "scheduled" },
};

addFilter(
	"pgDateCountdownTypes",
	"combo-blocks/pgDateCountdownTypes",
	function (options) {
		return pgDateCountdownTypesPro;
	}
);

/*

isProFeature
*/

addFilter("isProFeature", "combo-blocks/isProFeature", function (options) {
	return false;
});

/*

icon Positon Args
*/

var cssPropsPro = {
	alignContent: { id: "alignContent", label: "Align Content" },
	alignItems: { id: "alignItems", label: "Align Items" },
	alignSelf: { id: "alignSelf", label: "Align Self" },
	animationName: { id: "animationName", label: "Animation Name" },
	aspectRatio: { id: "aspectRatio", label: "Aspect Ratio" },
	backdropFilter: {
		id: "backdropFilter",
		label: "Backdrop Filter",
	},
	backfaceVisibility: {
		id: "backfaceVisibility",
		label: "Backface Visibility",
	},
	backgroundAttachment: {
		id: "backgroundAttachment",
		label: "Background Attachment",
	},
	backgroundBlendMode: {
		id: "backgroundBlendMode",
		label: "Background Blend Mode",
	},
	backgroundClip: {
		id: "backgroundClip",
		label: "Background Clip",
	},
	backgroundColor: { id: "backgroundColor", label: "Background Color" },
	backgroundImage: {
		id: "backgroundImage",
		label: "Background Image",
	},
	backgroundOrigin: { id: "backgroundOrigin", label: "Background Origin" },
	backgroundPosition: {
		id: "backgroundPosition",
		label: "Background Position",
	},
	backgroundRepeat: { id: "backgroundRepeat", label: "Background Repeat" },
	backgroundSize: { id: "backgroundSize", label: "Background Size" },
	border: { id: "border", label: "Border" },
	borderBottom: { id: "borderBottom", label: "Border Bottom" },
	borderCollapse: {
		id: "borderCollapse",
		label: "Border Collapse",
	},
	borderImage: { id: "borderImage", label: "Border Image" },
	borderLeft: { id: "borderLeft", label: "Border Left" },
	borderRadius: { id: "borderRadius", label: "Border Radius" },
	borderRight: { id: "borderRight", label: "Border Right" },
	borderSpacing: { id: "borderSpacing", label: "Border Spacing" },
	borderTop: { id: "borderTop", label: "Border Top" },
	bottom: { id: "bottom", label: "Bottom" },
	boxShadow: { id: "boxShadow", label: "Box Shadow" },
	boxSizing: { id: "boxSizing", label: "Box Sizing" },
	captionSide: { id: "captionSide", label: "Caption Side" },
	clear: { id: "clear", label: "Clear" },
	clip: { id: "clip", label: "Clip" },
	color: { id: "color", label: "Color" },
	columnCount: { id: "columnCount", label: "Column Count" },
	columnGap: { id: "columnGap", label: "Column gap" },
	columnRule: { id: "columnRule", label: "Column Rule" },
	content: { id: "content", label: "Content" },
	counterIncrement: {
		id: "counterIncrement",
		label: "Counter Increment",
	},
	counterReset: { id: "counterReset", label: "Counter Reset" },
	counterSet: { id: "counterSet", label: "Counter Set" },
	cursor: { id: "cursor", label: "Cursor" },
	direction: { id: "direction", label: "Direction" },
	display: { id: "display", label: "Display" },
	emptyCells: { id: "emptyCells", label: "Empty Cells" },
	filter: { id: "filter", label: "Filter" },
	flexBasis: { id: "flexBasis", label: "Flex Basis" },
	flexDirection: { id: "flexDirection", label: "Flex Direction" },
	flexFlow: { id: "flexFlow", label: "Flex Flow" },
	flexGrow: { id: "flexGrow", label: "Flex Grow" },
	flexShrink: { id: "flexShrink", label: "Flex Shrink" },
	flexWrap: { id: "flexWrap", label: "Flex Wrap" },
	float: { id: "float", label: "Float" },
	fontFamily: { id: "fontFamily", label: "Font Family" },
	fontSize: { id: "fontSize", label: "Font Size" },
	fontStretch: { id: "fontStretch", label: "Font Stretch" },
	fontStyle: { id: "fontStyle", label: "Font Style" },
	fontVariantCaps: {
		id: "fontVariantCaps",
		label: "Font VariantCaps",
	},
	fontWeight: { id: "fontWeight", label: "Font Weight" },
	gap: { id: "gap", label: "Gap" },
	gridAutoColumns: { id: "gridAutoColumns", label: "Grid Auto Columns" },
	gridAutoFlow: { id: "gridAutoFlow", label: "Grid Auto Flow" },
	gridColumnEnd: { id: "gridColumnEnd", label: "Grid Column End" },
	gridColumnStart: { id: "gridColumnStart", label: "Grid Column Start" },
	gridRowEnd: { id: "gridRowEnd", label: "Grid Row End" },
	gridRowStart: { id: "gridRowStart", label: "Grid Row Start" },
	gridTemplateColumns: {
		id: "gridTemplateColumns",
		label: "Grid Template Columns",
	},
	gridTemplateRows: { id: "gridTemplateRows", label: "Grid Template Rows" },
	height: { id: "height", label: "Height" },
	justifyContent: { id: "justifyContent", label: "Justify Content" },
	left: { id: "left", label: "Left" },
	letterSpacing: { id: "letterSpacing", label: "Letter Spacing" },
	lineHeight: { id: "lineHeight", label: "Line Height" },
	listStyle: { id: "listStyle", label: "List Style" },
	margin: { id: "margin", label: "Margin" },
	marginBottom: { id: "marginBottom", label: "Margin Bottom" },
	marginLeft: { id: "marginLeft", label: "Margin Left" },
	marginRight: { id: "marginRight", label: "Margin Right" },
	marginTop: { id: "marginTop", label: "Margin Top" },
	maskImage: {
		id: "maskImage",
		label: "Mask Image",
	},
	maskMode: {
		id: "maskMode",
		label: "Mask Mode",
	},
	maskOrigin: {
		id: "maskOrigin",
		label: "Mask Origin",
	},
	maskPosition: {
		id: "maskPosition",
		label: "Mask Position",
	},
	maskRepeat: {
		id: "maskRepeat",
		label: "Mask Repeat",
	},
	maskSize: {
		id: "maskSize",
		label: "Mask Size",
	},
	maxHeight: { id: "maxHeight", label: "Max Height" },
	maxWidth: { id: "maxWidth", label: "Max Width" },
	minHeight: { id: "minHeight", label: "Min Height" },
	minWidth: { id: "minWidth", label: "Min Width" },
	objectFit: { id: "objectFit", label: "Object Fit" },
	opacity: { id: "opacity", label: "Opacity" },
	order: { id: "order", label: "Order" },
	outline: { id: "outline", label: "Outline" },
	overflow: { id: "overflow", label: "Overflow" },
	overflowX: { id: "overflowX", label: "OverflowX" },
	overflowY: { id: "overflowY", label: "OverflowY" },
	padding: { id: "padding", label: "Padding" },
	paddingBottom: { id: "paddingBottom", label: "Padding Bottom" },
	paddingLeft: { id: "paddingLeft", label: "Padding Left" },
	paddingRight: { id: "paddingRight", label: "Padding Right" },
	paddingTop: { id: "paddingTop", label: "Padding Top" },
	perspective: { id: "perspective", label: "Perspective" },
	position: { id: "position", label: "Position" },
	right: { id: "right", label: "Right" },
	rowGap: { id: "rowGap", label: "Row Gap" },
	tableLayout: { id: "tableLayout", label: "Table Layout" },
	textAlign: { id: "textAlign", label: "Text Align" },
	textDecoration: {
		id: "textDecoration",
		label: "Text Decoration",
	},
	textIndent: { id: "textIndent", label: "Text Indent" },
	textJustify: { id: "textJustify", label: "Text Justify" },
	textOverflow: { id: "textOverflow", label: "Text Overflow" },
	textShadow: { id: "textShadow", label: "Text Shadow" },
	textTransform: { id: "textTransform", label: "Text Transform" },
	top: { id: "top", label: "Top" },
	transform: { id: "transform", label: "Transform" },
	transformOrigin: {
		id: "transformOrigin",
		label: "Transform Origin",
	},
	transformStyle: {
		id: "transformStyle",
		label: "Transform Style",
	},
	transition: { id: "transition", label: "Transition" },
	verticalAlign: { id: "verticalAlign", label: "Vertical Align" },
	visibility: { id: "visibility", label: "Visibility" },
	width: { id: "width", label: "Width" },
	wordBreak: { id: "wordBreak", label: "Word Break" },
	wordSpacing: { id: "wordSpacing", label: "Word Spacing" },
	wordWrap: { id: "wordWrap", label: "Word Wrap" },
	writingMode: { id: "writingMode", label: "Writing Mode" },
	zIndex: { id: "zIndex", label: "Z-Index" },
	"-webkit-text-fill-color": {
		id: "-webkit-text-fill-color",
		label: "Webkit Text Fill Color",
	},
};

addFilter("cssProps", "combo-blocks/cssProps", function (options) {
	return cssPropsPro;
});

const sudoScourceArgsPro = {
	styles: { label: "Idle", value: "styles" },
	hover: { label: "Hover", value: "hover" },
	after: { label: "After", value: "after" },
	before: { label: "Before", value: "before" },
	active: { label: "Active", value: "active" },
	focus: { label: "Focus", value: "focus" },
	"focus-within": {
		label: "Focus-within",
		value: "focus-within",
	},
	target: { label: "target", value: "target" },
	visited: { label: "Visited", value: "visited" },
	selection: { label: "Selection", value: "selection" },
	":marker": { label: "Marker", value: ":marker" },
	"nth-child(even)": {
		label: "nth-child(even)",
		value: "nth-child(even)",
	},
	"nth-child(odd)": {
		label: "nth-child(odd)",
		value: "nth-child(odd)",
	},
	"nth-child(1)": {
		label: "nth-child(1)",
		value: "nth-child(1)",
	},
	"nth-child(2)": {
		label: "nth-child(2)",
		value: "nth-child(2)",
	},
	"nth-child(3)": {
		label: "nth-child(3)",
		value: "nth-child(3)",
	},
	"nth-child(4)": {
		label: "nth-child(4)",
		value: "nth-child(4)",
	},
	"nth-child(5)": {
		label: "nth-child(5)",
		value: "nth-child(5)",
	},

	"first-child": { label: "First-child", value: "first-child" },
	"last-child": { label: "Last-child", value: "last-child" },
	"first-letter": {
		label: "First-letter",
		value: "first-letter",
	},
	"first-line": { label: "First-line", value: "first-line" },
	"hover::before": { label: "hover::before", value: "hover::before" },
	"hover::after": { label: "hover::after", value: "hover::after" },
	"hover::marker": {
		label: "hover::marker",
		value: "hover::marker",
	},
	"hover::first-letter": {
		label: "hover::first-letter",
		value: "hover::first-letter",
	},
	"hover:first-child": {
		label: "hover:first-child",
		value: "hover:first-child",
	},
	"hover:last-child": {
		label: "hover:last-child",
		value: "hover:last-child",
	},
	"hover:first-line": {
		label: "hover:first-line",
		value: "hover:first-line",
	},
	"hover:first-line": {
		label: "hover:first-line",
		value: "hover:first-line",
	},
	"hover:nth-child(odd)": {
		label: "hover:nth-child(odd)",
		value: "hover:nth-child(odd)",
	},
	"hover:nth-child(even)": {
		label: "hover:nth-child(even)",
		value: "hover:nth-child(even)",
	},
	"hover div:nth-child(1)": {
		label: "hover div:nth-child(1)",
		value: "hover div:nth-child(1)",
	},
	"hover div:nth-child(2)": {
		label: "hover div:nth-child(2)",
		value: "hover div:nth-child(2)",
	},

	"-webkit-slider-thumb": {
		label: "-webkit-slider-thumb",
		value: "-webkit-slider-thumb",
	},
	"-moz-range-thumb": {
		label: "-moz-range-thumb",
		value: "-moz-range-thumb",
	},
	checked: { label: "checked", value: "checked" },
	"checked:after": {
		label: "checked:after",
		value: "checked:after",
	},
	"checked:before": {
		label: "checked:before",
		value: "checked:before",
	},
	"has(> input:checked)": {
		label: "has(> input:checked)",
		value: "has(> input:checked)",

	},
	"has(> input[type=radio]:checked)": {
		label: "has(> input[type=radio]:checked)",
		value: "has(> input[type=radio]:checked)",

	},
	"has(> input[type=checkbox]:checked)": {
		label: "has(> input[type=checkbox]:checked)",
		value: "has(> input[type=checkbox]:checked)",

	},
};

addFilter("sudoScourceArgs", "combo-blocks/sudoScourceArgs", function (options) {
	return sudoScourceArgsPro;
});

const altTextSrcArgsPro = {
	none: { label: "No Alt Text", value: "" },
	imgAltText: { label: "Image Alt Text", value: "imgAltText" },
	imgTitle: { label: "Image Title", value: "imgTitle" },
	imgCaption: { label: "Image Caption", value: "imgCaption" },
	imgDescription: { label: "Image Description", value: "imgDescription" },
	imgSlug: { label: "Image Slug", value: "imgSlug" },
	postTitle: { label: "Post Title", value: "postTitle" },
	postSlug: { label: "Post Slug", value: "postSlug" },
	excerpt: { label: "Post Excerpt", value: "excerpt" },
	customField: { label: "Post Custom Field", value: "customField" },
	custom: { label: "Custom", value: "custom" },
};

addFilter("altTextSrcArgs", "combo-blocks/altTextSrcArgs", function (options) {
	return altTextSrcArgsPro;
});

var transitionPropertiesPro = {
	all: { value: "all", label: "All" },

	"background-color": { value: "background-color", label: "Background Color" },
	color: { value: "color", label: "Color" },
	"box-shadow": { value: "box-shadow", label: "Box Shadow" },
	"font-size": { value: "font-size", label: "Font Size" },
	right: { value: "right", label: "Right" },
	top: { value: "top", label: "Top" },
	width: { value: "width", label: "Width" },
	height: { value: "height", label: "Height" },
	"font-weight": { value: "font-weight", label: "Font Weight" },
	left: { value: "left", label: "Left" },
	"z-index": { value: "z-index", label: "Z-Index" },
	margin: { value: "margin", label: "Margin" },
	padding: { value: "padding", label: "Padding" },
	"max-height": { value: "max-height", label: "Max Height" },
	"max-width": { value: "max-width", label: "Max Width" },
	"min-height": { value: "min-height", label: "Min Height" },
	"min-width": { value: "min-width", label: "Min Width" },
	opacity: { value: "opacity", label: "Opacity" },
	"align-content": { value: "align-content", label: "Align Content" },
	"align-items": { value: "align-items", label: "Align Items" },
	"align-self": { value: "align-self", label: "Align Self" },
	"backface-visibility": {
		value: "backface-visibility",
		label: "Backface Visibility",
	},
	//background: { value: 'background', label: 'Background' },
	"background-attachment": {
		value: "background-attachment",
		label: "Background Attachment",
	},
	"background-blendMode": {
		value: "background-blendMode",
		label: "Background Blend Mode",
	},
	"background-clip": { value: "background-clip", label: "Background Clip" },
	"background-image": { value: "background-image", label: "Background Image" },
	"background-origin": {
		value: "background-origin",
		label: "Background Origin",
	},
	"background-repeat": {
		value: "background-repeat",
		label: "Background Repeat",
	},
	"background-position": {
		value: "background-position",
		label: "Background Position",
	},
	"background-size": { value: "background-size", label: "Background Size" },
	border: { value: "border", label: "Border" },
	"border-collapse": { value: "border-collapse", label: "Border Collapse" },
	"border-image": { value: "border-image", label: "Border Image" },
	"border-radius": { value: "border-radius", label: "Border Radius" },
	"border-spacing": { value: "border-spacing", label: "Border Spacing" },
	"backdrop-filter": { value: "backdrop-filter", label: "Backdrop Filter" },
	bottom: { value: "bottom", label: "Bottom" },
	"box-sizing": { value: "box-sizing", label: "Box Sizing" },
	clear: { value: "clear", label: "Clear" },
	clip: { value: "clip", label: "Clip" },
	"clip-path": { value: "clip-path", label: "Clip Path" },
	"column-count": { value: "column-count", label: "Column Count" },
	content: { value: "content", label: "Content" },

	cursor: { value: "cursor", label: "Cursor" },
	display: { value: "display", label: "Display" },
	direction: { value: "direction", label: "Direction" },
	float: { value: "float", label: "Float" },
	filter: { value: "filter", label: "Filter" },
	"font-family": { value: "font-family", label: "Font Family" },
	"font-stretch": { value: "font-stretch", label: "Font Stretch" },
	"font-style": { value: "font-style", label: "Font Style" },
	"user-select": { value: "user-select", label: "User Select" },
	"font-variant-caps": {
		value: "font-variant-caps",
		label: "Font VariantCaps",
	},
	"letter-spacing": { value: "letter-spacing", label: "Letter Spacing" },
	"line-height": { value: "line-height", label: "Line Height" },
	"list-style": { value: "list-style", label: "ListStyle" },
	outline: { value: "outline", label: "Outline" },
	overflow: { value: "overflow", label: "Overflow" },
	"overflow-x": { value: "overflow-x", label: "OverflowX" },
	"overflow-y": { value: "overflow-y", label: "OverflowY" },
	perspective: { value: "perspective", label: "Perspective" },
	position: { value: "position", label: "Position" },
	"text-align": { value: "text-align", label: "Text Align" },
	transform: { value: "transform", label: "Transform" },
	transition: { value: "transition", label: "Transition" },
	"vertical-align": { value: "vertical-align", label: "Vertical Align" },
	visibility: { value: "visibility", label: "Visibility" },
	"text-decoration": { value: "text-decoration", label: "Text Decoration" },
	"text-indent": { value: "text-indent", label: "Text Indent" },
	"text-justify": { value: "text-justify", label: "Text Justify" },
	"text-overflow": { value: "text-overflow", label: "Text Overflow" },
	"text-shadow": { value: "text-shadow", label: "Text Shadow" },
	"text-transform": { value: "text-transform", label: "Text Transform" },
	"word-break": { value: "word-break", label: "Word Break" },
	"word-spacing": { value: "word-spacing", label: "Word Spacing" },
	"word-wrap": { value: "word-wrap", label: "Word Wrap" },
	"writing-mode": { value: "writing-mode", label: "Writing Mode" },
};

addFilter(
	"transitionProperties",
	"combo-blocks/transitionProperties",
	function (options) {
		return transitionPropertiesPro;
	}
);

// terms list

const termsQueryPramsBasic = {
	taxonomy: {
		value: "category",
		multiple: false,
		id: "taxonomy",
		label: "Taxonomy",
		description: "Select Taxonomy to Query",
		longDescription:
			"Taxonomy name, or array of taxonomy names, to which results should be limited.",
	},
	orderby: {
		value: "name",
		multiple: false,
		id: "orderby",
		label: "Order By",
		description: "Search keyword, ex: hello",
	},
	order: {
		value: "ASC",
		multiple: false,
		id: "order",
		label: "Order",
		description: "Whether to order terms in ascending or descending order.",
	},
	hide_empty: {
		value: true,
		multiple: false,
		id: "hide_empty",
		label: "Hide Empty",
		description: "Accepts true or false value.",
		longDescription:
			"Whether to hide terms not assigned to any posts. Accepts 1|true or 0|false.",
	},
	number: {
		value: false,
		multiple: false,
		id: "number",
		label: "Number",
		description: "Accepts 0 (all) or any positive number.",
		longDescription:
			"Maximum number of terms to return. Accepts ''|0 (all) or any positive number. Default ''|0 (all). Note that $number may not return accurate results when coupled with $object_ids.",
	},
	include: {
		value: "category",
		multiple: false,
		id: "include",
		label: "Include",
		description: "Comma-separated string of term IDs to include.",
		longDescription:
			"Array or comma/space-separated string of term IDs to include. Default empty array.",
		placeholder: "Comma-separated string of term IDs to include.",
	},
	exclude: {
		value: "",
		multiple: false,
		id: "exclude",
		label: "Exclude",
		description: "Comma-separated string of term IDs to exclude.",
		longDescription:
			"Array or comma/space-separated string of term IDs to exclude. If $include is non-empty, $exclude is ignored. Default empty array.",
		placeholder: "Comma-separated string of term IDs to exclude.",
	},

	// Category Parameters
	exclude_tree: {
		value: "",
		multiple: false,
		id: "exclude_tree",
		label: "Exclude Tree",
		description: "Comma-separated string of term IDs to exclude.",
		longDescription:
			"Array or comma/space-separated string of term IDs to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array.",
		placeholder: "Comma-separated string of term IDs to exclude.",
	},

	count: {
		value: false,
		multiple: false,
		id: "count",
		label: "count",
		description:
			"Whether to return a term count. If true, will take precedence over $fields.",
	},
	offset: {
		value: "",
		multiple: false,
		id: "offset",
		label: "Offset",
		description: "The number by which to offset the terms query.",
		longDescription: "The number by which to offset the terms query.",
	},
	// fields: {
	// 	value: "all",
	// 	multiple: false,
	// 	id: "fields",
	// 	label: "Fields",
	// 	description: "Post query by Category IDs" /*/,
	// },
	name: {
		value: "",
		multiple: false,
		id: "name",
		label: "Name",
		description: "Name or array of names to return term(s) for.",
		longDescription: "Comma-separated names to return term(s) for.",
	},

	// Tag Parameters

	slug: {
		value: "",
		multiple: false,
		id: "slug",
		label: "Slug",
		description: "Slug or array of slugs to return term(s) for.",
		longDescription: "Comma-separated slugs to return term(s) for.",
	},
	hierarchical: {
		value: true,
		multiple: false,
		id: "hierarchical",
		label: "Hierarchical",
		description: "Whether to include terms that have non-empty descendants.",
		longDescription:
			"Whether to include terms that have non-empty descendants (even if $hide_empty is set to true).",
	},
	search: {
		value: "",
		multiple: false,
		id: "search",
		label: "Search",
		description: "Search criteria to match terms.",
		longDescription:
			"Search criteria to match terms. Will be SQL-formatted with wildcards before and after.",
	},
	name__like: {
		value: "",
		multiple: false,
		id: "name__like",
		label: "Name like",
		description:
			"Retrieve terms with criteria by which a term is LIKE $name__like.",
		longDescription:
			"Retrieve terms with criteria by which a term is LIKE $name__like.",
	},
	description__like: {
		value: "",
		multiple: false,
		id: "description__like",
		label: "Description like",
		description:
			"Retrieve terms where the description is LIKE $description__like.",
		longDescription:
			"Retrieve terms where the description is LIKE $description__like.",
	},
	pad_counts: {
		value: false,
		multiple: false,
		id: "pad_counts",
		label: "Pad counts",
		description:
			'Whether to pad the quantity of a term’s children in the quantity of each term’s "count" object variable.',
		longDescription:
			'Whether to pad the quantity of a term’s children in the quantity of each term’s "count" object variable. Default false.',
	},
	get: {
		value: "",
		multiple: false,
		id: "get",
		label: "Get",
		description:
			"Whether to return terms regardless of ancestry or whether the terms are empty.",
		longDescription:
			"Whether to return terms regardless of ancestry or whether the terms are empty. Accepts 'all' or '' (disabled). Default ''.",
	},

	child_of: {
		value: "",
		multiple: false,
		id: "child_of",
		label: "Child of",
		description: "Term ID to retrieve child terms of.",
		longDescription:
			"Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0.",
	},

	parent: {
		value: "",
		multiple: false,
		id: "parent",
		label: "Parent",
		description:
			"Add {ID} to add Parent term ID to retrieve direct-child terms of.",
		longDescription: "Parent term ID to retrieve direct-child terms of.",
	},

	childless: {
		value: false,
		multiple: false,
		id: "childless",
		label: "Childless",
		description: "True to limit results to terms that have no children.",
		longDescription:
			"True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false.",
	},

	// // Date Parameters
	cache_domain: {
		value: "core",
		multiple: false,
		id: "cache_domain",
		label: "Cache domain",
		description:
			"Unique cache key to be produced when this query is stored in an object cache.",
		longDescription:
			"Unique cache key to be produced when this query is stored in an object cache. Default 'core'.",
	},
	update_term_meta_cache: {
		value: true,
		multiple: false,
		id: "update_term_meta_cache",
		label: "Update term meta Cache",
		description:
			"Whether to prime meta caches for matched terms. Default true.",
	},
	// meta_query: {
	// 	value: [],
	// 	multiple: false,
	// 	id: "meta_query",
	// 	label: "Meta query",
	// 	description: "Post query by month",
	// },
	meta_key: {
		value: "",
		multiple: false,
		id: "meta_key",
		label: "Meta key",
		description: "Comma-separated keys to return term(s) for.",
		longDescription: "Meta key or keys to filter by.",
	},
	meta_value: {
		value: "",
		multiple: false,
		id: "meta_value",
		label: "Meta value",
		description: "Comma-separated keys to return term(s) for.",
		longDescription: "Meta value or values to filter by.",
	},
};

addFilter("termsQueryPrams", "combo-blocks/term-list", function (options) {
	return termsQueryPramsBasic;
});
// terms list

// icon position Start

// category
const iconPositonArgsPro = {
	none: { label: "Choose Position", value: "" },
	beforeFronttext: { label: "Before Front text", value: "beforeFronttext" },
	afterFronttext: { label: "After Front text", value: "afterFronttext" },
	beforeItems: { label: "Before Items", value: "beforeItems" },
	afterItems: { label: "After Items", value: "afterItems" },
	beforeItem: { label: "Before Each Items", value: "beforeItem" },
	afterItem: { label: "After Each Items", value: "afterItem" },
};

addFilter("iconPositonArgs", "combo-blocks/iconPositonArgs", function (options) {
	return iconPositonArgsPro;
});

// icon position End

/*

link To Arguments

*/

const linkToArgsPro = {
	noUrl: { label: "No URL", value: "" },

	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter("linkToArgs", "combo-blocks/linkToArgs", function (options) {
	return linkToArgsPro;
});

/*

link To Arguments

*/

// Wrapper Tag Start
const flexWrapItemWrapperTagArgsPro = {
	none: { label: "Choose Tag", value: "" },
	h1: { label: "H1", value: "h1" },
	h2: { label: "H2", value: "h2" },
	h3: { label: "H3", value: "h3" },
	h4: { label: "H4", value: "h4" },
	h5: { label: "H5", value: "h5" },
	h6: { label: "H6", value: "h6" },
	span: { label: "SPAN", value: "span" },
	div: { label: "DIV", value: "div" },
	p: { label: "P", value: "p" },
	a: { label: "A", value: "a" },
};

addFilter(
	"postGridFlexWrapItemTags",
	"combo-blocks/flex-wrap-item",
	function (options) {
		return flexWrapItemWrapperTagArgsPro;
	}
);
// Wrapper Tag End

// wordpress-org plugin and theme Fields

const pluginFieldListPro = {
	name: { id: "name", label: "Plugin Name", prefix: "Plugin Name: " },
	version: { id: "version", label: "Version", prefix: "Version:" },
	author: { id: "author", label: "Author", prefix: "Author" },
	homepage: {
		id: "homepage",
		label: "Homepage",
		prefix: "Homepage:",
		isLinked: true,
		linkText: "Homepage",
	},
	download_link: {
		id: "download_link",
		label: "Download Link",
		prefix: "Download Link",
		isLinked: true,
		linkText: "Download",
	},
	rating: { id: "rating", label: "Rating", prefix: "Rating", type: "star" },

	requires: {
		id: "requires",
		label: "Require WP Version",
		prefix: "WP Version: ",
	},
	tested: {
		id: "tested",
		label: "Tested WP Version",
		prefix: "WP Tested Version: ",
	},
	requires_php: {
		id: "requires_php",
		label: "Require PHP Version",
		prefix: "PHP Version: ",
	},
	author_profile: {
		id: "author_profile",
		label: "Author Profile",
		prefix: "Author Profile",
	},

	contributors: {
		id: "contributors",
		label: "Contributors",
		prefix: "Contributors",
		isLinked: true,
	},

	requires_plugins: {
		id: "requires_plugins",
		label: "Require Plugins",
		prefix: "Require Plugins: ",
	},

	ratings: {
		id: "ratings",
		label: "Ratings",
		prefix: "Ratings",
		type: "star",
	},
	num_ratings: {
		id: "num_ratings",
		label: "Num Ratings",
		prefix: "Num Ratings",
		type: "star",
	},
	support_threads: {
		id: "support_threads",
		label: "Support Threads",
		prefix: "Support Threads",
	},
	support_threads_resolved: {
		id: "support_threads_resolved",
		label: "Support Threads Resolved",
		prefix: "Support Threads Resolved",
	},
	active_installs: {
		id: "active_installs",
		label: "Active Install",
		prefix: "Active Install: ",
	},
	last_updated: {
		id: "last_updated",
		label: "Last Update",
		prefix: "Last Update: ",
	},
	added: {
		id: "added",
		label: "Creation Time",
		prefix: "Creation Time: ",
	},

	tags: { id: "tags", label: "Tags", prefix: "Tags:" },

	banners: {
		id: "banners",
		label: "Thumbnail",
		prefix: "Thumbnail",
		size: "high",
		isLinked: false,
	},
};

addFilter(
	"wordpressOrgPluginFieldList",
	"combo-blocks/wordpress-org",
	function (options) {
		return pluginFieldListPro;
	}
);

const themeFieldListPro = {
	name: { id: "name", label: "Name", prefix: "Theme Name: " },
	version: { id: "version", label: "Version", prefix: "Version:" },
	author: { id: "author", label: "Author", prefix: "Author" },
	screenshot_url: { id: "screenshot_url", label: "Screenshot" },
	ratings: { id: "ratings", label: "Ratings", prefix: "Ratings" },

	rating: { id: "rating", label: "Rating", prefix: "Rating", type: "star" },
	homepage: {
		id: "homepage",
		label: "Homepage",
		prefix: "Homepage:",
		isLinked: true,
		linkText: "Homepage",
	},
	download_link: {
		id: "download_link",
		label: "Download Link",
		prefix: "Download Link",
		isLinked: true,
		linkText: "Download",
	},

	requires: {
		id: "requires",
		label: "Require WP Version",
		prefix: "WP Version: ",
	},
	requires_php: {
		id: "requires_php",
		label: "Require PHP Version",
		prefix: "PHP Version: ",
	},

	preview_url: {
		id: "preview_url",
		label: "Preview URL",
		prefix: "Preview URL",
		isLinked: true,
		linkText: "Preview",
	},
	num_ratings: {
		id: "num_ratings",
		label: "Number of Ratings",
	},
	reviews_url: {
		id: "reviews_url",
		label: "Reviews URL",
		isLinked: true,
		linkText: "Reviews",
	},
	last_updated: {
		id: "last_updated",
		label: "Last Update",
		prefix: "Last Update: ",
	},
	creation_time: {
		id: "creation_time",
		label: "Creation Time",
		prefix: "Creation Time: ",
	},

	tags: { id: "tags", label: "Tags", prefix: "Tags: " },

	is_commercial: {
		id: "is_commercial",
		label: "Is Commercial",
		prefix: "Is Commercial",
	},
	external_support_url: {
		id: "external_support_url",
		label: "External Support URL",
		prefix: "External Support URL",
		isLinked: true,
		linkText: "Support URL",
	},
	external_repository_url: {
		id: "external_repository_url",
		label: "External Sepository URL",
		prefix: "External Sepository URL",
		isLinked: true,
		linkText: "Repository",
	},
};

addFilter(
	"wordpressOrgThemeFieldList",
	"combo-blocks/wordpress-org",
	function (options) {
		return themeFieldListPro;
	}
);

// wordpress-org plugin and theme Fields

// class picker filter

var customTagsPro = {
	currentYear: {
		label: "Current Year",
		id: '{currentYear["y"]}',
		value: "2023",
	},
	currentMonth: {
		label: "Current Month",
		id: '{currentMonth["m"]}',
		value: "07",
	},
	currentDay: { label: "Current Day", id: '{currentDay["d"]}', value: "01" },
	currentDate: {
		label: "Current Date",
		id: '{currentDate["d- m - Y"]}',
		value: "01-01-2023",
	},
	currentTime: {
		label: "Current Time",
		id: '{currentTime["h: i:sa"]}',
		value: "06:00:00:am",
	},
	postPublishDate: {
		label: "Post Publish Date",
		id: '{postPublishDate["d-m-Y"]}',
		value: "01-01-2023",
	},
	postModifiedDate: {
		label: "Post Modified Date",
		id: '{postModifiedDate["d - m - Y"]}',
		value: "01-01-2023",
	},
	termId: { label: "Term Id", id: "{termId}", value: "123" },
	termTitle: {
		label: "Term Title",
		id: "{termTitle}",
		value: "Hello Term Title",
	},
	termDescription: {
		label: "Term Description",
		id: "{termDescription}",
		value: "Hello term description",
	},
	termPostCount: {
		label: "Term Post Count",
		id: "{termPostCount}",
		value: "123",
	},
	postTagTitle: {
		label: "Post Tag Title",
		id: "{postTagTitle}",
		value: "sports",
	},
	postTagsTitle: {
		label: "Post Tags Title",
		id: '{postTagsTitle["3, -"]}',
		value: "football , cricket",
	},
	postCategoryTitle: {
		label: "Post Category Title",
		id: "{postCategoryTitle}",
		value: "sports",
	},
	postCategoriesTitle: {
		label: "Post Categories Title",
		id: '{postCategoriesTitle["3"]}',
		value: "football , cricket",
	},
	postTermTitle: {
		label: "Post Term Title",
		id: '{postTermTitle["taxonomy"]}',
		value: "sports",
	},
	postTermsTitle: {
		label: "Post Terms Title",
		id: '{postTermsTitle["taxonomy, 3"]}',
		value: "football , cricket",
	},
	postSlug: { label: "Post Slug", id: "{postSlug}", value: "post-slug" },
	postId: { label: "Post ID", id: "{postID}", value: "123" },
	postStatus: { label: "Post Status", id: "{postStatus}", value: "published" },
	authorId: { label: "Author Id", id: "{authorId}", value: "123" },
	authorName: {
		label: "Author Name",
		id: "{authorName}",
		value: "hello author",
	},
	authorFirstName: {
		label: "Author FirstName",
		id: "{authorFirstName}",
		value: "first name",
	},
	authorLastName: {
		label: "Author Last Name",
		id: "{authorLastName}",
		value: "last name",
	},
	authorDescription: {
		label: "Author Description",
		id: "{authorDescription}",
		value: "Hello author description",
	},
	excerpt: { label: "Post Excerpt", id: "{excerpt}", value: "hello excerpt" },
	rankmathTitle: {
		label: "Rankmath Title",
		id: "{rankmathTitle}",
		value: "Rank Math Title",
	},
	// rankmathPermalink: {
	// 	label: "Rankmath Permalink",
	// 	id: '{rankmathPermalink}',
	// 	value: "",
	// },
	rankmathDescription: {
		label: "Rankmath Description",
		id: "{rankmathDescription}",
		value: "Rank Math Description",
	},
	rankmathFocusKeyword: {
		label: "Rankmath Focus Keyword",
		id: "{rankmathFocusKeyword}",
		value: "Rank Math Focus Keyword",
	},
	// rankmathFocusKeywords: {
	// 	label: "Rankmath Focus Keywords",
	// 	id: '{rankmathFocusKeywords[", "]}',
	// 	value: "",
	// },
	rankmathOrgname: {
		label: "Rankmath Org name",
		id: "{rankmathOrgname}",
		value: "Rank Math Org Name",
	},
	rankmathOrgurl: {
		label: "Rankmath Org URL",
		id: "{rankmathOrgurl}",
		value: "https://hello.world",
	},
	rankmathOrglogo: {
		label: "Rankmath Org logo",
		id: "{rankmathOrglogo}",
		value: "",
	},
	siteTitle: { label: "Site Title", id: "{siteTitle}", value: "WordPress" },
	siteDescription: {
		label: "Site Description",
		id: "{siteDescription}",
		value: "Hello site description",
	},
	// siteTagline: { label: "Site Tagline", id: '{siteTagline}', value: "" },
	postMeta: {
		label: "Post Meta",
		id: '{postMeta["metaKey"]}',
		value: "meta value",
	},
	separator: { label: "Separator", id: '{separator[" - "]}', value: "-" },
	searchTerms: {
		label: "Search Terms",
		id: "{searchTerms}",
		value: "hello search terms",
	},
	tutorLmsTotalEnrolled: {
		label: __("Tutor LMS Total Enrolled", "combo-blocks-pro"),
		id: "{tutorLmsTotalEnrolled}",
		value: "123",

	},
	tutorLmsCourseDuration: {
		label: __("Tutor LMS - Course Duration", "combo-blocks-pro"),
		id: "{tutorLmsCourseDuration}",
		value: "12",

	},
	tutorLmsLastUpdated: {
		label: __("Tutor LMS - Last Updated", "combo-blocks-pro"),
		id: "{tutorLmsLastUpdated}",
		value: "123",

	},
	tutorLmsCourseLevel: {
		label: __("Tutor LMS - Course Level", "combo-blocks-pro"),
		id: "{tutorLmsCourseLevel}",
		value: "2",

	},
	tutorLmsCourseProgressTotal: {
		label: __("Tutor LMS - Course Progress Total", "combo-blocks-pro"),
		id: "{tutorLmsCourseProgressTotal}",
		value: "60",

	},
	tutorLmsCourseProgressCompleted: {
		label: __("Tutor LMS - Course Progress Completed", "combo-blocks-pro"),
		id: "{tutorLmsCourseProgressCompleted}",
		value: "40",

	},
	tutorLmsCourseLessonCount: {
		label: __("Tutor LMS - Course lesson count", "combo-blocks-pro"),
		id: "{tutorLmsCourseLessonCount}",
		value: "123",

	},



	// counter: { label: "Counter", id: '{counter}', value: "" },
};

addFilter(
	"postGridClassPickerFilter",
	"combo-blocks/component/classPicker",
	function (options) {
		return customTagsPro;
	}
);

// class picker filter

/*
Post Taxonomies Block Filter Hook Start 
*/

// post taxonomies Icon

var postTaxonomiesIconPositionPro = {
	none: { label: "Choose Position", value: "" },
	beforeFronttext: { label: "Before Front text", value: "beforeFronttext" },
	afterFronttext: {
		label: "After Front text",
		value: "afterFronttext",
	},
	beforeItems: { label: "Before Items", value: "beforeItems" },
	afterItems: { label: "After Items", value: "afterItems" },
	beforeItem: {
		label: "Before Each Items",
		value: "beforeItem",
	},
	afterItem: { label: "After Each Items", value: "afterItem" },
};

addFilter(
	"postGridPostTaxonomiesIconPosition",
	"combo-blocks/post-taxonomies",
	function (options) {
		return postTaxonomiesIconPositionPro;
	}
);

// post-taxonomies link to

const postTaxonomiesLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	termUrl: { label: "Term URL", value: "termUrl" },

	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridPostTaxonomiesLinkTo",
	"combo-blocks/post-taxonomies",
	function (options) {
		return postTaxonomiesLinkToPro;
	}
);

/*
Post Tags Block Filter Hook Start 
*/

// post-tags icon position

var postTagsIconPositionPro = {
	none: { label: "Choose Position", value: "" },
	beforeFronttext: { label: "Before Front text", value: "beforeFronttext" },
	afterFronttext: {
		label: "After Front text",
		value: "afterFronttext",
	},
	beforeItems: { label: "Before Items", value: "beforeItems" },
	afterItems: { label: "After Items", value: "afterItems" },
	beforeItem: {
		label: "Before Each Items",
		value: "beforeItem",
	},
	afterItem: { label: "After Each Items", value: "afterItem" },
};

addFilter(
	"postGridPostTagsIconPosition",
	"combo-blocks/post-tags",
	function (options) {
		return postTagsIconPositionPro;
	}
);

// post-tags link to

const postTagsLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	termUrl: { label: "Term URL", value: "termUrl" },

	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter("postGridPostTagsLinkTo", "combo-blocks/post-tags", function (options) {
	return postTagsLinkToPro;
});

/*
Post Date Block Filter Hook Start 
*/

// post-date icon position

var postDateIconPositionPro = {
	none: { label: "Choose Position", value: "" },
	beforePostDate: { label: "Before Post Date", value: "beforePostDate" },
	afterPostDate: {
		label: "After Post Date",
		value: "afterPostDate",
	},
	beforePrefix: {
		label: "Before Prefix",
		value: "beforePrefix",
	},
	afterPrefix: { label: "After Prefix", value: "afterPrefix" },
	beforePostfix: {
		label: "Before PostFix",
		value: "beforePostfix",
	},
	afterPostfix: {
		label: "After PostFix",
		value: "afterPostfix",
	},
};

addFilter(
	"postGridPostDateIconPosition",
	"combo-blocks/post-date",
	function (options) {
		return postDateIconPositionPro;
	}
);

// post-date link to

const postDateLinkToPro = {
	none: { label: "Choose", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	archiveDate: { label: "Date Archive", value: "archiveDate" },
	archiveYear: { label: "Year Archive", value: "archiveYear" },
	archiveMonth: { label: "Month Archive", value: "archiveMonth" },

	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter("postGridPostDateLinkTo", "combo-blocks/post-date", function (options) {
	return postDateLinkToPro;
});

/*
Number Counter Block Filter Hook Start 
*/

// number-counter icon position

const numberCounterIconPositionPro = {
	none: { label: "Choose Position", value: "" },

	beforePrefix: {
		label: "Before Prefix",
		value: "beforePrefix",
	},
	afterPrefix: { label: "After Prefix", value: "afterPrefix" },
	beforePostfix: {
		label: "Before PostFix",
		value: "beforePostfix",
	},
	afterPostfix: {
		label: "After PostFix",
		value: "afterPostfix",
	},
};

addFilter(
	"postGridNumberCounterIconPosition",
	"combo-blocks/number-counter",
	function (options) {
		return numberCounterIconPositionPro;
	}
);

/*
Form Wrap Block Filter Hook Start 
*/

// form wrap form type

var formWrapFormTypePro = {
	contactForm: {
		label: "Contact Form",
		description: "Contact Form",
		args: { id: "contactForm" },
	},
	loginForm: {
		label: "Login Form",
		description: "Login Form",
		args: { id: "loginForm" },
	},
	registerForm: {
		label: "Register Form",
		description: "Register Form",
		args: { id: "registerForm" },
	},

	passwordResetFrom: {
		label: "Password Reset From",
		description: "Password Reset From",
		args: { id: "passwordResetFrom", updateUrl: "" },
	},
	// passwordUpdateFrom: {
	// 	label: "Update Password From",
	// 	description: "Update Password From",
	// 	args: { id: "passwordUpdateFrom", resetUrl: '' },
	// },

	userProfileUpdate: {
		label: "User Profile Update Form",
		description: "User Profile Update Form",
		args: { id: "userProfileUpdate" },
	},
	// wpSearchForm: {
	// 	label: "WordPress Search Form",
	// 	description: "WordPress Search Form",
	// 	args: { id: "wpSearchForm" },
	// },

	postSubmitForm: {
		label: "Post Submit Form",
		description: "Post Submit Form",
		args: { id: "postSubmitForm" },
	},
	termSubmitForm: {
		label: "Term Submit Form",
		description: "Term Submit Form",
		args: { id: "termSubmitForm" },
	},
	commentSubmit: {
		label: "Comment Submit Form",
		description: "Post Comment Submit Form",
		args: { id: "commentSubmit" },
	},
	// fileUploadForm: { label: 'File Upload Form', description: 'File Upload Form', args: { id: 'fileUploadForm', } },
	optInForm: {
		label: "Opt-In Form",
		description: "Opt-In Form",
		args: { id: "optInForm" },
	},
	// quizForm: {
	// 	label: "quizForm",
	// 	description: "quizForm",
	// 	args: { id: "quizForm" },
	// },

	customForm: {
		label: "Custom Form",
		description: "Custom Form",
		args: { id: "customForm" },
	},
	// postFilter: {
	// 	label: "Post Filter",
	// 	description: "Post Filter",
	// 	args: { id: "postFilter" },
	//
	// },
	// appointmentForm: {
	// 	label: "Appointment Form",
	// 	description: "Appointment Form",
	// 	args: { id: "appointmentForm" },
	//
	// },
};
addFilter(
	"postGridFormWrapFormType",
	"combo-blocks/form-wrap",
	function (options) {
		return formWrapFormTypePro;
	}
);

var onSubmitArgsPro = {
	submitConfirm: {
		label: __("Submit Confirm", "combo-blocks-pro"),
		description: "confirm form submit",
		args: { id: "submitConfirm", messages: [] },
	},
	recaptchaValidation: {
		label: __("Recaptcha Validation", "combo-blocks-pro"),
		description: "Validate reCaptcha responses.",
		args: { id: "recaptchaValidation" },
	},
	simpleMath: {
		label: __("Simple Math", "combo-blocks-pro"),
		description: "Simple Math",
		args: { id: "simpleMath", type: "", conditions: [] },
	},
};

addFilter(
	"postGridFormWrapOnSubmitArgs",
	"combo-blocks/form-wrap",
	function (options) {
		return onSubmitArgsPro;
	}
);

// form wrap on process

const formWrapOnProcessPro = {
	sendMail: {
		label: "Send Mail",
		description: "Send Mail",
		args: { id: "sendMail", mailTo: "", bcc: "" },
		formTypeScope: ["contactForm", "commentSubmit", "optInForm"],
	},
	emailBcc: {
		label: "Send BCC",
		description: "Send BCC",
		args: { id: "emailBcc", message: "" },
		formTypeScope: ["contactForm", "commentSubmit", "optInForm"],
	},
	emailCopyUser: {
		label: "Email Copy User",
		description: "Email Copy User",
		args: { id: "emailCopyUser", message: "" },
		formTypeScope: ["contactForm", "commentSubmit", "optInForm"],
	},
	autoReply: {
		label: "Auto Reply",
		description: "Auto Reply",
		args: { id: "autoReply", message: "" },
		formTypeScope: ["contactForm", "commentSubmit", "optInForm"],
	},

	createWCOrder: {
		label: "Create WooCommerce Order",
		description: "Create WooCommerce Order",
		args: { id: "createWCOrder", orderStatus: "", orderNote: "" },
		formTypeScope: ["contactForm", "optInForm", "customForm"],
	},
	createZendeskTicket: {
		label: "Create Zendesk Ticket",
		description: "Create Zendesk Ticket",
		args: { id: "createZendeskTicket", priority: "", },
		formTypeScope: ['contactForm', 'customForm'],
	},


	sendSlackWebhook: {
		label: "Slack Webhook",
		description: "Create Slack Webhook",
		args: { id: "sendSlackWebhook", text: "", webhookUrl: "", channel: "", username: "", iconEmoji: "", },
		formTypeScope: ['contactForm', 'customForm'],
	},
	twilioSendMessage: {
		label: "Twilio Send Message",
		description: "Twilio Send Message",
		args: { id: "twilioSendMessage", phoneNumber: "", },
		formTypeScope: ['contactForm', 'customForm'],
	},
	createEntry: {
		label: "Create Entry",
		description: "Create Entry",
		args: { id: "createEntry", saveTo: "post", saveToPrams: {} },
		formTypeScope: ['contactForm', 'loginForm', 'passwordResetFrom', 'registerForm', 'userProfileUpdate', 'postSubmitForm', 'commentSubmit', 'termSubmitForm', 'optInForm', 'customForm'],

	},
	doAction: {
		label: "Do Action",
		description: "Do Action",
		args: { id: "doAction", actionName: "" },
		formTypeScope: [
			"contactForm",
			"loginForm",
			"passwordResetFrom",
			"registerForm",
			"userProfileUpdate",
			"postSubmitForm",
			"commentSubmit",
			"termSubmitForm",
			"optInForm",
			"customForm",
		],
	},
	webhookRequest: {
		label: "Webhook Request",
		description: "Webhook Request",
		args: {
			id: "webhookRequest",
			name: "",
			url: "",
			requestHeader: true,
			method: "",
			format: "JSON",
			fields: [],
		},
		formTypeScope: [
			"contactForm",
			"loginForm",
			"passwordResetFrom",
			"registerForm",
			"userProfileUpdate",
			"postSubmitForm",
			"commentSubmit",
			"termSubmitForm",
			"optInForm",
			"customForm",
		],
	},
	validatedField: {
		label: "Validated Field",
		description: "Validated Field",
		args: { id: "validatedField", field: "", conditions: [] },
		formTypeScope: ["contactForm", "loginForm"],
	},

	applyFilters: {
		label: "Apply filters",
		description: "Apply filters",
		args: {
			id: "applyFilters",
			filterName: "",
			successMessage: "",
			failedMessage: "",
		},
		formTypeScope: [
			"contactForm",
			"loginForm",
			"passwordResetFrom",
			"registerForm",
			"userProfileUpdate",
			"postSubmitForm",
			"commentSubmit",
			"termSubmitForm",
			"optInForm",
			"customForm",
		],
	},
	droboxUpload: {
		label: "Uplaod file to Drobox",
		description: "Uplaod file to Drobox",
		args: { id: "droboxUpload", path: "" },
		formTypeScope: ["contactForm", "customForm"],
	},
	// googleDriveUpload: {
	// 	label: "Uplaod file to Google Drive",
	// 	description: "Uplaod file to Google Drive",
	// 	args: { id: "googleDriveUpload", path: "" },
	// 	formTypeScope: ["contactForm", "customForm"],
	// },
	recaptchaValidation: {
		label: "Recaptcha Validation",
		description: "Validate reCaptcha responses.",
		args: { id: "recaptchaValidation" },
		formTypeScope: ["contactForm", "loginForm"],
	},

	loggedInUser: {
		label: "Logged in user",
		description: "Logged in user",
		args: { id: "loggedInUser", message: "" },
		formTypeScope: ["loginForm"],
	},
	resetPassword: {
		label: "Reset Password",
		description: "Reset Password",
		args: { id: "resetPassword", message: "" },
		formTypeScope: ["passwordResetFrom"],
	},
	registerUser: {
		label: "Register user",
		description: "Register user",
		args: { id: "registerUser", message: "" },
		formTypeScope: ["registerForm"],
	},
	tutorRegisterInstructor: {
		label: "Tutor LMS Register Instructor",
		description: "Tutor LMS Register as Instructor",
		args: { id: "tutorRegisterInstructor", message: "" },
		formTypeScope: ['registerForm'],
	},
	updateUserProfile: {
		label: "Update User Profile",
		description: "Update User Profile",
		args: { id: "updateUserProfile", message: "" },
		formTypeScope: ["userProfileUpdate"],
	},
	postSubmit: {
		label: "Create Post",
		description: "Create Post",
		args: { id: "postSubmit", postType: "" },
		formTypeScope: ["postSubmitForm"],
	},
	commentSubmit: {
		label: "Comment Submit",
		description: "Comment Submit",
		args: { id: "commentSubmit", loginRequired: false },
		formTypeScope: ["commentSubmit"],
	},
	termSubmit: {
		label: "Term Submit",
		description: "Term Submit",
		args: { id: "termSubmit", taxonomy: "" },
		formTypeScope: ["termSubmitForm"],
	},

	// For All type form
	// createEntry: {
	// 	label: "Create Entry",
	// 	description: "Create Entry",
	// 	args: { id: "createEntry", message: "" },
	// },

	fluentcrmAddContact: {
		label: "FluentCRM - Add Contact",
		description: "Add to FluentCRM Contacts list",
		args: { id: "fluentcrmAddContact", lists: [], tags: [], message: "" },
		formTypeScope: ["optInForm"],
	},
	mailpickerAddContact: {
		label: "MailPicker - Add Contact",
		description: "Add to MailPicker subscriber list",
		args: {
			id: "mailpickerAddContact",
			lists: [],
			tags: [],
			message: "",
		},
		formTypeScope: ["optInForm"],
	},


	acumbamailAddContact: {
		label: "Acumbamail - Add Contact",
		description: "Add to Acumbamail subscriber list",
		args: { id: "acumbamailAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm", 'contactForm'],
	},
	brevoAddContact: {
		label: "brevo - Add Contact",
		description: "Add to brevo subscriber list",
		args: { id: "brevoAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm"],
	},
	klaviyoAddContact: {
		label: "Klaviyo - Add Contact",
		description: "Add to klaviyo subscriber list",
		args: { id: "klaviyoAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm"],
	},
	omnisendAddContact: {
		label: "omnisend - Add Contact",
		description: "Add to omnisend subscriber list",
		args: { id: "omnisendAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm"],
	},

	mailerliteAddContact: {
		label: "Mailer Lite - Add Contact",
		description: "Add to mailerlite subscriber list",
		args: {
			id: "mailerliteAddContact",
			lists: "",
			tags: "",
			message: "",
		},
		formTypeScope: ["optInForm"],
	},

	mailmodoAddContact: {
		label: "Mailmodo - Add Contact",
		description: "Add to mailmodo subscriber list",
		args: { id: "mailmodoAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm"],
	},
	mailjetAddContact: {
		label: "Mailjet - Add Contact",
		description: "Add to mailjet subscriber list",
		args: { id: "mailjetAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm"],
	},

	emailoctopusAddContact: {
		label: "Email Octopus - Add Contact",
		description: "Add to Email Octopus subscriber list",
		args: {
			id: "emailoctopusAddContact",
			lists: "",
			tags: "",
			message: "",
		},
		formTypeScope: ["optInForm"],
	},
	senderAddContact: {
		label: "Sender - Add Contact",
		description: "Add to Sender subscriber list",
		args: { id: "senderAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm"],
	},

	moosendAddContact: {
		label: "Moo Send - Add Contact",
		description: "Add to Moo Send subscriber list",
		args: { id: "moosendAddContact", lists: "", tags: "", message: "" },
		formTypeScope: ["optInForm"],
	},

	mailchimpAddContact: {
		label: "Mail Chimp - Add Contact",
		description: "Add to Mail Chimp subscriber list",
		args: {
			id: "mailchimpAddContact",
			lists: "",
			tags: "",
			message: "",
			status: "subscribed",
		},
		formTypeScope: ["optInForm"],
	},
};

addFilter(
	"postGridFormWrapOnProcess",
	"combo-blocks/form-wrap",
	function (options) {
		return formWrapOnProcessPro;
	}
);

// form wrap after submit

const formWrapAfterSubmitPro = {
	showResponse: {
		label: "Show Response",
		description: "Show Response Message",
		args: { id: "showResponse", message: "" },
	},
	delay: {
		label: "Delay",
		description: "Delay",
		args: { id: "delay", time: 1000 },
	},
	showText: {
		label: "Show Text",
		description: "Show Text",
		args: { id: "showText", successMessage: "", failedMessage: "" },
	},
	refreshPage: {
		label: "Refresh Page",
		description: "Refresh Page",
		args: { id: "refreshPage", delay: "" },
	},

	//loggedOut: { label: 'Logged Out', description: 'Logged out current user', args: { id: 'loggedOut', message: '' } },
	//loggedIn: { label: 'Logged In', description: 'Logged in user', args: { id: 'loggedIn', message: '' } },
	loggedOut: {
		label: "Logged Out",
		description: "Logged out current user",
		args: { id: "loggedOut", redirect: "" },
	},

	hideForm: {
		label: "Hide Form",
		description: "Hide Form",
		args: { id: "hideForm", message: "" },
	},
	showQuizResult: {
		label: "Show Quiz Result",
		description: "Show Quiz Result",
		args: { id: "showQuizResult", message: "" },
	},
	clearForm: {
		label: "Clear Form",
		description: "Clear Form",
		args: { id: "clearForm", message: "" },
	},
	redirectToURL: {
		label: "Redirect To URL",
		description: "Redirect To URL",
		args: { id: "redirectToURL", value: "" },
	},
	buildGETRequest: {
		label: "build GET Request",
		description: "Build URL for GET request",
		args: { id: "buildGETRequest", value: "" },
	},
	filterPosts: {
		label: "Filter Posts",
		description: "Filter posts via post grid",
		args: { id: "filterPosts", value: "" },
	},
	hidePopup: {
		label: "Hide Popup",
		description: "Hide Popup",
		args: { id: "hidePopup", delay: 0, message: "" },
	},

	//delay: { label: 'Delay', description: 'Delay', args: { id: 'delay', delay: 1000 } },
};

addFilter(
	"postGridFormWrapAfterSubmit",
	"combo-blocks/form-wrap",
	function (options) {
		return formWrapAfterSubmitPro;
	}
);

// form wrap visible args

const formWrapVisibleArgsPro = {
	userLogged: {
		label: "User Logged",
		description: "Show when user logged-in(any user)",
		args: { id: "userLogged", value: "" },
	},
	userNotLogged: {
		label: "User Not Logged",
		description: "Show when user Not logged-in.",
		args: { id: "userNotLogged", value: "" },
	},
	userRoles: {
		label: "User Roles",
		description: "Show when user has specific roles.",
		args: { id: "userRoles", roles: [] },
	},

	isYears: {
		label: "is Years",
		description: "Show when specific Years",
		args: { id: "isYears", value: "", values: "", compare: "=" },
	},
	isMonths: {
		label: "is Months",
		description: "Show when specific months",
		args: { id: "isMonths", value: "", values: [], compare: "=" },
	},
	weekDays: {
		label: "is Week day",
		description: "Show when specific week days",
		args: { id: "weekDays", value: "", values: [], compare: "=" },
	},
	isHours: {
		label: "is Hours",
		description: "Show when specific hours",
		args: { id: "isHours", value: "", values: [], compare: "=" },
	},
	//isMinutes: { label: 'is Minutes', description: 'Show when specific Minutes', args: { id: 'isMinutes', value: '', values: [], compare: '=' } },
	isDate: {
		label: "is Date",
		description: "Show when specific date",
		args: { id: "isDate", value: "", values: [], compare: "=" },
	},

	// submitCount: { label: 'Submit Count', description: 'Visible under specific submit count', args: { id: 'submitCount', value: '' } },
};

addFilter(
	"postGridFormWrapVisibleArgs",
	"combo-blocks/form-wrap",
	function (options) {
		return formWrapVisibleArgsPro;
	}
);

/*
Popup Block Filter Hook Start 
*/

// popup visible args

const popupVisibleArgsPro = {
	initial: {
		label: "Initial",
		description: "Visble as soon as possible",
		args: { id: "initial", value: 5 },
	},
	delay: {
		label: "Delay",
		description: "Delay certain amount of time after page load.",
		args: { id: "delay", value: 1000 },
	},
	scrollPercent: {
		label: "Scroll Percent",
		description: "After certain amount(parcent) of scroll",
		args: { id: "scrollPercent", min: "30", max: 50 },
	},
	scrollFixed: {
		label: "Scroll Fixed",
		description: "After fixed amount of scroll",
		args: { id: "scrollFixed", min: "30", max: 50 },
	},
	scrollEnd: {
		label: "Scroll End",
		description: "Scroll to end of page",
		args: { id: "scrollEnd", min: "30", max: 50 },
	},
	scrollElement: {
		label: "Scroll Element",
		description: "Scroll to certain element by class or id",
		args: { id: "scrollElement", value: "" },
	},
	clickFirst: {
		label: "Click First",
		description: "After first click on page",
		args: { id: "clickFirst", value: 1 },
	},
	clickCount: {
		label: "Click Count",
		description: "After certain amount of click on page",
		args: { id: "clickCount", value: 5 },
	},
	clickRight: {
		label: "Click Right",
		description: "on right click",
		args: { id: "clickRight", value: 0 },
	},
	onExit: {
		label: "On Exit",
		description: "before close browser tab.",
		args: { id: "onExit", value: 1 },
	},
	clickElement: {
		label: "Click Element",
		description: "After click an element by id or class",
		args: { id: "clickElement", value: "" },
	},
	dateCountdownExpired: {
		label: "Date Countdown Expired",
		description: "After expired from date countdown block",
		args: { id: "dateCountdownExpired", value: "", once: false },
	},

	keyPress: {
		label: "Key Press",
		description: "Key Press to close.",
		args: { id: "keyPress", value: "esc" },
	},
	wooAddToCart: {
		label: "Woo-Commerce Add to Cart",
		description: "Popup open when added to cart",
		args: { id: "wooAddToCart", value: "esc" },
	},
	mouseOutElement: {
		label: "Mouse Out Element",
		description: "if visitor come from external website.",
		args: { id: "mouseOutElement", value: "" },
	},
	mouseOverElement: {
		label: "Mouse Over Element",
		description: "if visitor come from external website.",
		args: { id: "mouseOverElement", value: "" },
	},
	// inactiveXSec: {
	// 	label: "Inactive X Second",
	// 	description: "if visitor come from external website.",
	// 	args: { id: "inactiveXSec", value: "" },
	//
	// },

	// ADBlocker: {
	// 	label: "Ad blocker Popup",
	// 	description: "if visitor come from external website.",
	// 	args: { id: "ADBlocker", value: "" },
	// },
};

addFilter("postGridPopupVisibleArgs", "combo-blocks/popup", function (options) {
	return popupVisibleArgsPro;
});

// popup entrance animation

const popupEntranceAnimatePro = {
	backInDown: { label: "backInDown", value: "backInDown" },
	backInLeft: { label: "backInLeft", value: "backInLeft" },
	backInRight: { label: "backInRight", value: "backInRight" },
	backInUp: { label: "backInUp", value: "backInUp" },
	bounceIn: { label: "bounceIn", value: "bounceIn" },
	bounceInDown: {
		label: "bounceInDown",
		value: "bounceInDown",
	},
	bounceInLeft: {
		label: "bounceInLeft",
		value: "bounceInLeft",
	},
	bounceInRight: {
		label: "bounceInRight",
		value: "bounceInRight",
	},
	bounceInUp: { label: "bounceInUp", value: "bounceInUp" },
	fadeIn: { label: "fadeIn", value: "fadeIn" },
	fadeInDown: { label: "fadeInDown", value: "fadeInDown" },
	fadeInDownBig: {
		label: "fadeInDownBig",
		value: "fadeInDownBig",
	},
	fadeInLeft: { label: "fadeInLeft", value: "fadeInLeft" },
	fadeInLeftBig: {
		label: "fadeInLeftBig",
		value: "fadeInLeftBig",
	},
	fadeInRight: { label: "fadeInRight", value: "fadeInRight" },
	fadeInRightBig: {
		label: "fadeInRightBig",
		value: "fadeInRightBig",
	},
	fadeInUp: { label: "fadeInUp", value: "fadeInUp" },
	fadeInUpBig: { label: "fadeInUpBig", value: "fadeInUpBig" },
	fadeInTopLeft: {
		label: "fadeInTopLeft",
		value: "fadeInTopLeft",
	},
	fadeInTopRight: {
		label: "fadeInTopRight",
		value: "fadeInTopRight",
	},
	fadeInBottomRight: {
		label: "fadeInBottomRight",
		value: "fadeInBottomRight",
	},
	fadeInBottomLeft: {
		label: "fadeInBottomLeft",
		value: "fadeInBottomLeft",
	},
	rotateIn: { label: "rotateIn", value: "rotateIn" },
	rotateInDownLeft: {
		label: "rotateInDownLeft",
		value: "rotateInDownLeft",
	},
	rotateInDownRight: {
		label: "rotateInDownRight",
		value: "rotateInDownRight",
	},
	rotateInUpLeft: {
		label: "rotateInUpLeft",
		value: "rotateInUpLeft",
	},
	rotateInUpRight: {
		label: "rotateInUpRight",
		value: "rotateInUpRight",
	},
	zoomIn: { label: "zoomIn", value: "zoomIn" },
	zoomInDown: { label: "zoomInDown", value: "zoomInDown" },
	zoomInLeft: { label: "zoomInLeft", value: "zoomInLeft" },
	zoomInRight: { label: "zoomInRight", value: "zoomInRight" },
	zoomInUp: { label: "zoomInUp", value: "zoomInUp" },
	slideInDown: { label: "slideInDown", value: "slideInDown" },
	slideInLeft: { label: "slideInLeft", value: "slideInLeft" },
	slideInRight: {
		label: "slideInRight",
		value: "slideInRight",
	},
	slideInUp: { label: "slideInUp", value: "slideInUp" },
};

addFilter(
	"postGridPopupEntranceAnimation",
	"combo-blocks/popup",
	function (options) {
		return popupEntranceAnimatePro;
	}
);

// popup close animation

const popupCloseAnimatePro = {
	backOutDown: { label: "backOutDown", value: "backOutDown" },
	backOutLeft: { label: "backOutLeft", value: "backOutLeft" },
	backOutRight: {
		label: "backOutRight",
		value: "backOutRight",
	},
	backOutUp: { label: "backOutUp", value: "backOutUp" },
	bounceOut: { label: "bounceOut", value: "bounceOut" },
	bounceOutDown: {
		label: "bounceOutDown",
		value: "bounceOutDown",
	},
	bounceOutLeft: {
		label: "bounceOutLeft",
		value: "bounceOutLeft",
	},
	bounceOutRight: {
		label: "bounceOutRight",
		value: "bounceOutRight",
	},
	bounceOutUp: { label: "bounceOutUp", value: "bounceOutUp" },
	fadeOut: { label: "fadeOut", value: "fadeOut" },
	fadeOutDown: { label: "fadeOutDown", value: "fadeOutDown" },
	fadeOutDownBig: {
		label: "fadeOutDownBig",
		value: "fadeOutDownBig",
	},
	fadeOutLeft: { label: "fadeOutLeft", value: "fadeOutLeft" },
	fadeOutLeftBig: {
		label: "fadeOutLeftBig",
		value: "fadeOutLeftBig",
	},
	fadeOutRight: {
		label: "fadeOutRight",
		value: "fadeOutRight",
	},
	fadeOutRightBig: {
		label: "fadeOutRightBig",
		value: "fadeOutRightBig",
	},
	fadeOutUp: { label: "fadeOutUp", value: "fadeOutUp" },
	fadeOutUpBig: {
		label: "fadeOutUpBig",
		value: "fadeOutUpBig",
	},
	fadeOutTopLeft: {
		label: "fadeOutTopLeft",
		value: "fadeOutTopLeft",
	},
	fadeOutTopRight: {
		label: "fadeOutTopRight",
		value: "fadeOutTopRight",
	},
	fadeOutBottomRight: {
		label: "fadeOutBottomRight",
		value: "fadeOutBottomRight",
	},
	fadeOutBottomLeft: {
		label: "fadeOutBottomLeft",
		value: "fadeOutBottomLeft",
	},
	rotateOut: { label: "rotateOut", value: "rotateOut" },
	rotateOutDownLeft: {
		label: "rotateOutDownLeft",
		value: "rotateOutDownLeft",
	},
	rotateOutDownRight: {
		label: "rotateOutDownRight",
		value: "rotateOutDownRight",
	},
	rotateOutUpLeft: {
		label: "rotateOutUpLeft",
		value: "rotateOutUpLeft",
	},
	rotateOutUpRight: {
		label: "rotateOutUpRight",
		value: "rotateOutUpRight",
	},
	zoomOut: { label: "zoomOut", value: "zoomOut" },
	zoomOutDown: { label: "zoomOutDown", value: "zoomOutDown" },
	zoomOutLeft: { label: "zoomOutLeft", value: "zoomOutLeft" },
	zoomOutRight: {
		label: "zoomOutRight",
		value: "zoomOutRight",
	},
	zoomOutUp: { label: "zoomOutUp", value: "zoomOutUp" },
	slideOutDown: {
		label: "slideOutDown",
		value: "slideOutDown",
	},
	slideOutLeft: {
		label: "slideOutLeft",
		value: "slideOutLeft",
	},
	slideOutRight: {
		label: "slideOutRight",
		value: "slideOutRight",
	},
	slideOutUp: { label: "slideOutUp", value: "slideOutUp" },
};

addFilter("postGridPopupCloseAnimation", "combo-blocks/popup", function (options) {
	return popupCloseAnimatePro;
});

/*
Icon/Button/Link Block Filter Hook Start 
*/

// icon link to

const iconLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	// termUrl: { label: "Term URL", value: "termUrl" },

	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter("postGridIconLinkTo", "combo-blocks/icon", function (options) {
	return iconLinkToPro;
});

// icon text source

const iconTextSourcePro = {
	siteTitle: { label: "Site Title", value: "siteTitle" },
	tagline: { label: "Tag line", value: "tagline" },
	siteUrl: { label: "Site URL", value: "siteUrl" },
	currentYear: { label: "Current Year", value: "currentYear" },
	currentDate: { label: "Current Date", value: "currentDate" },
	postTitle: { label: "Post Title", value: "postTitle" },
};

addFilter("postGridIconTextSource", "combo-blocks/icon", function (options) {
	return iconTextSourcePro;
});

/*
Date Countdown Block Filter Hook Start 
*/

// date-countdown expiredArgs

const dateCountdownExpiredArgsPro = {
	redirectURL: {
		label: "Redirect URL",
		description: "Redirect to a URL as soon as possible.",
		args: { id: "redirectURL", value: "", delay: "" },
	},
	wcHideCartButton: {
		label: "Hide Cart Button",
		description: "On Expired Cart Button will be hide.",
		args: { id: "wcHideCartButton" },
	},
	showExpiredMsg: {
		label: "Show Expired Message",
		description: "Visible as soon as possible",
		args: { id: "showExpiredMsg" },
	},
	hideCountdown: {
		label: "Hide Countdown",
		description: "Countdown will be hide.",
		args: { id: "hideCountdown" },
	},
	showElement: {
		label: "Show Element",
		description: "Visible as soon as possible.",
		args: { id: "showElement", value: "" },
	},
	showPopup: {
		label: "Show Popup",
		description: "Popup will be visible.",
		args: { id: "showPopup" },
	},
};

addFilter(
	"postGridDateCountdownExpiredArgs",
	"combo-blocks/date-countdown",
	function (options) {
		return dateCountdownExpiredArgsPro;
	}
);

// date-countdown startDate

var dateCountdownStartDateSourcePro = {
	none: { label: "Choose", value: "" },
	wc_sale_price_date_from: {
		label: "Sale Start Date",
		value: "wc_sale_price_date_from",
	},
};

addFilter(
	"postGridDateCountdownStartDate",
	"combo-blocks/date-countdown",
	function (options) {
		return dateCountdownStartDateSourcePro;
	}
);

// date-countdown endDate

var dateCountdownEndDateSourcePro = {
	none: { label: "Choose", value: "" },
	wc_sale_price_date_to: {
		label: "Sale End Date",
		value: "wc_sale_price_date_to",
	},
};

addFilter(
	"postGridDateCountdownEndDate",
	"combo-blocks/date-countdown",
	function (options) {
		return dateCountdownEndDateSourcePro;
	}
);

// // icon text source

// const iconTextSourcePro = {
// 	siteTitle: { label: "Site Title", value: "siteTitle" },
// 			tagline: { label: "Tag line", value: "tagline" },
// 			siteUrl: { label: "Site URL", value: "siteUrl" },
// 			currentYear: { label: "Current Year", value: "currentYear" },
// 			currentDate: { label: "Current Date", value: "currentDate", },
// 			postTitle: { label: "Post Title", value: "postTitle", },
// };

// addFilter(
// 	"postGridIconTextSource",
// 	"combo-blocks/icon",
// 	function (options) {
// 		return iconTextSourcePro;
// 	}
// );

/*
Image Block Filter Hook Start 
*/

// alt text

const imageAltTextSrcPro = {
	none: { label: "No Alt Text", value: "" },
	imgAltText: { label: "Image Alt Text", value: "imgAltText" },
	imgTitle: { label: "Image Title", value: "imgTitle" },
	imgCaption: { label: "Image Caption", value: "imgCaption" },
	imgDescription: { label: "Image Description", value: "imgDescription" },
	imgSlug: { label: "Image Slug", value: "imgSlug" },
	postTitle: { label: "Post Title", value: "postTitle" },
	postSlug: { label: "Post Slug", value: "postSlug" },
	excerpt: { label: "Post Excerpt", value: "excerpt" },
	customField: {
		label: "Post Custom Field",
		value: "customField",
	},
	custom: { label: "Custom", value: "custom" },
};

addFilter("postGridImageAltText", "combo-blocks/image", function (options) {
	return imageAltTextSrcPro;
});

// title text

const imageTitleTextSrcPro = {
	none: { label: "No Alt Text", value: "" },
	imgAltText: { label: "Image Alt Text", value: "imgAltText" },
	imgTitle: { label: "Image Title", value: "imgTitle" },
	imgCaption: { label: "Image Caption", value: "imgCaption" },
	imgDescription: { label: "Image Description", value: "imgDescription" },
	imgSlug: { label: "Image Slug", value: "imgSlug" },
	postTitle: { label: "Post Title", value: "postTitle" },
	postSlug: { label: "Post Slug", value: "postSlug" },
	excerpt: { label: "Post Excerpt", value: "excerpt" },
	customField: {
		label: "Post Custom Field",
		value: "customField",
	},
	custom: { label: "Custom", value: "custom" },
};

addFilter("postGridImageTitleText", "combo-blocks/image", function (options) {
	return imageTitleTextSrcPro;
});

// link to

const imageLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	// authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter("postGridImageLinkTo", "combo-blocks/image", function (options) {
	return imageLinkToPro;
});

/*
Featured Image Block Filter Hook Start 
*/

// alt text

const featuredImageAltTextSrcPro = {
	none: { label: "No Alt Text", value: "" },
	imgAltText: { label: "Image Alt Text", value: "imgAltText" },
	imgTitle: { label: "Image Title", value: "imgTitle" },
	imgCaption: { label: "Image Caption", value: "imgCaption" },
	imgDescription: { label: "Image Description", value: "imgDescription" },
	imgSlug: { label: "Image Slug", value: "imgSlug" },
	postTitle: { label: "Post Title", value: "postTitle" },
	postSlug: { label: "Post Slug", value: "postSlug" },
	excerpt: { label: "Post Excerpt", value: "excerpt" },
	customField: {
		label: "Post Custom Field",
		value: "customField",
	},
	custom: { label: "Custom", value: "custom" },
};

addFilter(
	"postGridFeaturedImageAltText",
	"combo-blocks/post-featured-image",
	function (options) {
		return featuredImageAltTextSrcPro;
	}
);

// title text

const featuredImageTitleTextSrcPro = {
	none: { label: "No Alt Text", value: "" },
	imgAltText: { label: "Image Alt Text", value: "imgAltText" },
	imgTitle: { label: "Image Title", value: "imgTitle" },
	imgCaption: { label: "Image Caption", value: "imgCaption" },
	imgDescription: { label: "Image Description", value: "imgDescription" },
	imgSlug: { label: "Image Slug", value: "imgSlug" },
	postTitle: { label: "Post Title", value: "postTitle" },
	postSlug: { label: "Post Slug", value: "postSlug" },
	excerpt: { label: "Post Excerpt", value: "excerpt" },
	customField: {
		label: "Post Custom Field",
		value: "customField",
	},
	custom: { label: "Custom", value: "custom" },
};

addFilter(
	"postGridFeaturedImageTitleText",
	"combo-blocks/post-featured-image",
	function (options) {
		return featuredImageTitleTextSrcPro;
	}
);

// link to

const FeaturedImageLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridFeaturedImageLinkTo",
	"combo-blocks/post-featured-image",
	function (options) {
		return FeaturedImageLinkToPro;
	}
);

/*
Total Sale Block Filter Hook Start 
*/

// woo-total-sale link to

const wooTotalSaleLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	// archiveDate: { label: "Date Archive", value: "archiveDate" },
	// archiveYear: { label: "Year Archive", value: "archiveYear" },
	// archiveMonth: { label: "Month Archive", value: "archiveMonth" },

	// authorUrl: { label: "Author URL", value: "authorUrl" },
	// authorLink: { label: "Author Link", value: "authorLink" },
	// authorMail: { label: "Author Mail", value: "authorMail" },
	// authorMeta: { label: "Author Meta", value: "authorMeta" },
	// customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridWooTotalSaleLinkTo",
	"combo-blocks/woo-total-sale",
	function (options) {
		return wooTotalSaleLinkToPro;
	}
);

/*
Woo Star Rate Block Filter Hook Start 
*/

// woo-star-rate radio options

const wooStarRateRadioOptionsPro = {
	pgNone: { label: "None", value: "" },
	pg01: {
		label: "123 customer reviews",
		value: "{review_count} customer reviews",
	},
	pg02: { label: "4.50/5.00", value: "{average_rating}/5.00" },
	pg03: {
		label: "4.50 out of 5.00",
		value: "{average_rating} out of 5.00",
	},
	pg04: {
		label: "4.50(123 reviews)",
		value: "{average_rating}({review_count} reviews)",
	},
	pg05: {
		label: "Custom",
		value: "custom",
	},
};

addFilter(
	"postGridWooStarRateRadioOptions",
	"combo-blocks/woo-star-rate",
	function (options) {
		return wooStarRateRadioOptionsPro;
	}
);

/*
Star Rate Block Filter Hook Start 
*/

// star-rate radio options

const starRateRadioOptionsPro = {
	pgNone: { label: "None", value: "" },
	pg01: {
		label: "123 customer reviews",
		value: "{rating_count} customer reviews",
	},
	pg02: { label: "4.50/5.00", value: "{average_rating}/5.00" },
	pg03: {
		label: "4.50 out of 5.00",
		value: "{average_rating} out of 5.00",
	},
	pg04: {
		label: "4.50(123 reviews)",
		value: "{average_rating}({rating_count} reviews)",
	},
	pg05: {
		label: "Custom",
		value: "custom",
	},
};

addFilter(
	"postGridStarRateRadioOptions",
	"combo-blocks/star-rate",
	function (options) {
		return starRateRadioOptionsPro;
	}
);

/*
Form Field Checkbox Block Filter Hook Start 
*/

// form-field-checkbox param source

const formFieldCheckboxParamSourcePro = {
	none: { label: "None", value: "" },
	taxonomy: { label: "Taxonomy", value: "taxonomy" },
	posts: { label: "Posts", value: "posts" },
	users: { label: "Users", value: "users" },
	countryNames: {
		label: "Country Names",
		value: "countryNames",
	},
	countryCodes: {
		label: "Country Codes",
		value: "countryCodes",
	},
	gender: { label: "Gender", value: "gender" },
	ageGroupsNum: {
		label: "Age Groups - Age",
		value: "ageGroupsNum",
	},
	ageGroupsKids: {
		label: "Age Groups - Kids",
		value: "ageGroupsKids",
	},
};

addFilter(
	"postGridFormFieldCheckboxParamSource",
	"combo-blocks/form-field-checkbox",
	function (options) {
		return formFieldCheckboxParamSourcePro;
	}
);

/*
Form Field Radio Block Filter Hook Start 
*/

// form-field-radio param source

const formFieldRadioParamSourcePro = {
	none: { label: "None", value: "" },
	taxonomy: { label: "Taxonomy", value: "taxonomy" },
	posts: { label: "Posts", value: "posts" },
	users: { label: "Users", value: "users" },
	countryNames: {
		label: "Country Names",
		value: "countryNames",
	},
	countryCodes: {
		label: "Country Codes",
		value: "countryCodes",
	},
	gender: { label: "Gender", value: "gender" },
	ageGroupsNum: {
		label: "Age Groups - Age",
		value: "ageGroupsNum",
	},
	ageGroupsKids: {
		label: "Age Groups - Kids",
		value: "ageGroupsKids",
	},
};

addFilter(
	"postGridFormFieldRadioParamSource",
	"combo-blocks/form-field-radio",
	function (options) {
		return formFieldRadioParamSourcePro;
	}
);

/*
Form Field Select Block Filter Hook Start 
*/

// form-field-select param source

const formFieldSelectParamSourcePro = {
	none: { label: "None", value: "" },
	taxonomy: { label: "Taxonomy", value: "taxonomy" },
	posts: { label: "Posts", value: "posts" },
	users: { label: "Users", value: "users" },
	countryNames: {
		label: "Country Names",
		value: "countryNames",
	},
	countryCodes: {
		label: "Country Codes",
		value: "countryCodes",
	},
	gender: { label: "Gender", value: "gender" },
	ageGroupsNum: {
		label: "Age Groups - Age",
		value: "ageGroupsNum",
	},
	ageGroupsKids: {
		label: "Age Groups - Kids",
		value: "ageGroupsKids",
	},
};

addFilter(
	"postGridFormFieldSelectParamSource",
	"combo-blocks/form-field-select",
	function (options) {
		return formFieldSelectParamSourcePro;
	}
);

/*
Post Comment Count Block Filter Hook Start 
*/

// post-comment-count icon position

const postCommentCountIconPositionPro = {
	none: { label: "Choose Position", value: "" },
	beforeCommentCount: {
		label: "Before Comment Count",
		value: "beforeCommentCount",
	},
	afterCommentCount: {
		label: "After Comment Count",
		value: "afterCommentCount",
	},
	beforePrefix: {
		label: "Before Prefix",
		value: "beforePrefix",
	},
	afterPrefix: { label: "After Prefix", value: "afterPrefix" },
	beforePostfix: {
		label: "Before PostFix",
		value: "beforePostfix",
	},
	afterPostfix: {
		label: "After PostFix",
		value: "afterPostfix",
	},
};

addFilter(
	"postGridPostCommentCountIconPosition",
	"combo-blocks/post-comment-count",
	function (options) {
		return postCommentCountIconPositionPro;
	}
);

// post-comment-count link to

const postCommentCountLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	archiveDate: { label: "Date Archive", value: "archiveDate" },
	archiveYear: { label: "Year Archive", value: "archiveYear" },
	archiveMonth: { label: "Month Archive", value: "archiveMonth" },

	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridPostCommentCountLinkTo",
	"combo-blocks/post-comment-count",
	function (options) {
		return postCommentCountLinkToPro;
	}
);

/*
Woo Product Info Block Filter Hook Start 
*/

// woo-product-info icon position

const wooProductInfoElementsArgsPro = {
	none: { label: "Choose Position", value: "" },
	beforeCommentCount: {
		label: "Before Comment Count",
		value: "beforeCommentCount",
	},
	afterCommentCount: {
		label: "After Comment Count",
		value: "afterCommentCount",
	},
	beforePrefix: {
		label: "Before Prefix",
		value: "beforePrefix",
	},
	afterPrefix: { label: "After Prefix", value: "afterPrefix" },
	beforePostfix: {
		label: "Before PostFix",
		value: "beforePostfix",
	},
	afterPostfix: {
		label: "After PostFix",
		value: "afterPostfix",
	},
};

addFilter(
	"postGridWooProductInfoElementsArgs",
	"combo-blocks/woo-product-info",
	function (options) {
		return wooProductInfoElementsArgsPro;
	}
);

/*
Post author field block Filter Hook Start 
*/

// post-author-fields excerpt link to

const userFieldsPro = {
	id: { label: "ID", value: "ID" },
	url: { label: "URL", value: "url" },
	registered: { label: "Registered", value: "registered" },
	display_name: { label: "Display name", value: "display_name" },
	first_name: { label: "First name", value: "first_name" },
	last_name: { label: "Last name", value: "last_name" },
	description: { label: "Description", value: "description" },
	avatar: { label: "Avatar", value: "avatar" },
	custom: { label: "Custom Field", value: "custom" },
};

addFilter(
	"postAuthorFieldUserField",
	"combo-blocks/post-author-fields",
	function (options) {
		return userFieldsPro;
	}
);

/*
Post Excerpt Block Filter Hook Start 
*/

// post-excerpt excerpt link to

const postExcerptLinkToPro = {
	none: { label: "Choose", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridPostExcerptLinkTo",
	"combo-blocks/post-excerpt",
	function (options) {
		return postExcerptLinkToPro;
	}
);

// post-excerpt read more link to

const postExcerptReaMoreLinkToPro = {
	none: { label: "Choose", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridPostExcerptReadMoreLinkTo",
	"combo-blocks/post-excerpt",
	function (options) {
		return postExcerptReaMoreLinkToPro;
	}
);

/*
	// Terms List Block Filter Hook Start 
*/

// // terms-list icon position

const termsListIconPositionPro = {
	none: { label: "Choose Position", value: "" },
	beforeFronttext: { label: "Before Front text", value: "beforeFronttext" },
	afterFronttext: {
		label: "After Front text",
		value: "afterFronttext",
	},
	// beforeItems: { label: "Before Items", value: "beforeItems", },
	// afterItems: { label: "After Items", value: "afterItems", },
	beforeItem: {
		label: "Before Each Items",
		value: "beforeItem",
	},
	afterItem: { label: "After Each Items", value: "afterItem" },
};

addFilter(
	"postGridTermsListIconPosition",
	"combo-blocks/terms-list",
	function (options) {
		return termsListIconPositionPro;
	}
);

/*
	// Terms Field Block Filter Hook Start 
*/

// // terms-query-item link to

const termsQueryItemLinkToPro = {
	none: { label: "Choose", value: "" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	termUrl: { label: "Term URL", value: "termUrl" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridTermsQueryItemLinkTo",
	"combo-blocks/terms-query-item",
	function (options) {
		return termsQueryItemLinkToPro;
	}
);

// * terms-query-item term field

const termsQueryItemTermFieldPro = {
	termId: { label: "Term ID", value: "termId" },
	name: { label: "Name", value: "name" },
	slug: {
		label: "Slug",
		value: "slug",
	},
	description: { label: "Description", value: "description" },
	count: {
		label: "Count",
		value: "count",
	},
	wooCategoryThumb: {
		label: "WooCommerce Category Thumbnail",
		value: "wooCategoryThumb",
	},
	meta: {
		label: "Meta",
		value: "meta",
	},
};

addFilter(
	"postGridTermsQueryTermField",
	"combo-blocks/terms-query-item",
	function (options) {
		return termsQueryItemTermFieldPro;
	}
);

/*
	// Post Title Block Filter Hook Start 
*/

// // post-title link to

const postTitleLinkToPro = {
	none: { label: "Choose", value: "" },
	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridPostTitleLinkTo",
	"combo-blocks/post-title",
	function (options) {
		return postTitleLinkToPro;
	}
);

const postTitleLimitByPro = {
	none: { label: "Choose..", value: "" },
	word: { label: "Word", value: "word" },
	character: { label: "Character", value: "character" },
};

addFilter(
	"postGridPostTitleLimitBy",
	"combo-blocks/post-title",
	function (options) {
		return postTitleLimitByPro;
	}
);

/*
Post Categories Block Filter Hook Start 
*/

// post-categories Icon

var postCategoriesIconPositionPro = {
	none: { label: "Choose Position", value: "" },
	beforeFronttext: { label: "Before Front text", value: "beforeFronttext" },
	afterFronttext: {
		label: "After Front text",
		value: "afterFronttext",
	},
	beforeItems: { label: "Before Items", value: "beforeItems" },
	afterItems: { label: "After Items", value: "afterItems" },
	beforeItem: {
		label: "Before Each Items",
		value: "beforeItem",
	},
	afterItem: { label: "After Each Items", value: "afterItem" },
};

addFilter(
	"postGridPostCategoriesIconPosition",
	"combo-blocks/post-categories",
	function (options) {
		return postCategoriesIconPositionPro;
	}
);

// post-categories link to

const postCategoriesLinkToPro = {
	noUrl: { label: "No URL", value: "" },
	termUrl: { label: "Term URL", value: "termUrl" },

	postUrl: { label: "Post URL", value: "postUrl" },
	homeUrl: { label: "Home URL", value: "homeUrl" },
	authorUrl: { label: "Author URL", value: "authorUrl" },
	authorLink: { label: "Author Link", value: "authorLink" },
	authorMail: { label: "Author Mail", value: "authorMail" },
	authorMeta: { label: "Author Meta", value: "authorMeta" },
	customField: { label: "Custom Field", value: "customField" },
	customUrl: { label: "Custom URL", value: "customUrl" },
};

addFilter(
	"postGridPostCategoriesLinkTo",
	"combo-blocks/post-categories",
	function (options) {
		return postCategoriesLinkToPro;
	}
);

/*
Number Counter Block Filter Hook Start 
*/
// number-counter source

const numberCounterSourcePro = {
	none: { label: __("Choose", "combo-blocks-pro"), value: "" },
	wooTotalSale: {
		label: __("WooCommerce Total Sale", "combo-blocks-pro"),
		value: "wooTotalSale",

	},
	tutorTotalInstructors: {
		label: __("Tutor Total Instructors", "combo-blocks-pro"),
		value: "tutorTotalInstructors",

	},
	tutorTotalStudents: {
		label: __("Tutor Total Students", "combo-blocks-pro"),
		value: "tutorTotalStudents",

	},
	tutorTotalAssignments: {
		label: __("Tutor Total Assignments", "combo-blocks-pro"),
		value: "tutorTotalAssignments",

	},
	tutorTotalEnrolments: {
		label: __("Tutor Total Enrolments", "combo-blocks-pro"),
		value: "tutorTotalEnrolments",

	},
	tutorTotalCourse: {
		label: __("Tutor Total Course", "combo-blocks-pro"),
		value: "tutorTotalCourse",

	},
	tutorTotalEnrolledCourse: {
		label: __("Tutor Total Enrolled Course", "combo-blocks-pro"),
		value: "tutorTotalEnrolledCourse",

	},
	tutorTotalQuestion: {
		label: __("Tutor Total Question", "combo-blocks-pro"),
		value: "tutorTotalQuestion",

	},
	tutorTotalReview: {
		label: __("Tutor Total Review", "combo-blocks-pro"),
		value: "tutorTotalReview",

	},



	post_meta: {
		label: __("Post Meta", "combo-blocks-pro"),
		value: "post_meta",

	},
};

addFilter(
	"postGridNumberCounterSource",
	"combo-blocks/number-counter",
	function (options) {
		return numberCounterSourcePro;
	}
);

/*
Breadcrumb Block Filter Hook Start 
*/
// element source

const breadcrumbElementsSourcePro = [
	{
		id: "text",
		label: "Text",
		customText: "You are here: ",
		url: "",

		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			text: "You are here: ",
			showSeparator: true,
			isLink: false,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "homePage",
		label: "Home Page Link",
		customText: "%s",
		url: "",

		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			isLink: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "frontPage",
		label: "Front Page Link",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "postsPage",
		label: "Posts Page Link",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "postTitle",
		label: "Post Title",
		customText: "",
		url: "",

		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			isLink: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postAuthor",
		label: "Post Author",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "postDate",
		label: "Post Date",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			format: "Y-m-d",
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postDay",
		label: "Post Day",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			format: "",
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postMonth",
		label: "Post Month",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			format: "",
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "postYear",
		label: "Post Year",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			format: "",
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "postId",
		label: "Post Id",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postCategory",
		label: "Post Category",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postTag",
		label: "Post Tag",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "termTitle",
		label: "Term Title",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "wcShop",
		label: "WooCommerce Shop",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "wcAccount",
		label: "WooCommerce Account",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "searchText",
		label: "Search Text",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "archiveTitle",
		label: "Archive Title",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "404Text",
		label: "404 Text",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "dateText",
		label: "Date Text",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			format: "Y-m-d",
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "monthText",
		label: "Month Text",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			format: "Y-m",
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "yearText",
		label: "Year Text",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			format: "Y",
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "authorName",
		label: "Author Name",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postAncestors",
		label: "Post Ancestors",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			count: "",
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postCategories",
		label: "Post Categories",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			maxCount: 3,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "postTags",
		label: "Post Tags",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			maxCount: 3,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "postTerm",
		label: "Post Term",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			taxonomy: "",
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "postTerms",
		label: "Post Terms",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			taxonomy: "",
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "termParents",
		label: "Term Parents",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
			count: 0,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "termAncestors",
		label: "Term Ancestors",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			taxonomy: "",
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},

	{
		id: "wcCart",
		label: "WooCommerce Cart",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
	{
		id: "wcCheckout",
		label: "WooCommerce Checkout",
		customText: "%s",
		url: "",
		siteIcon: {
			library: "fontAwesome",
			srcType: "class",
			/*class, html, img, svg */ iconSrc: "",
		},
		options: {
			showSeparator: true,
		},
		styles: {
			color: { Desktop: "" },
			backgroundColor: { Desktop: "" },
			padding: { Desktop: "" },
			margin: { Desktop: "" },
		},
	},
];

addFilter(
	"postGridBreadcrumbElementsSource",
	"combo-blocks/breadcrumb",
	function (options) {
		return breadcrumbElementsSourcePro;
	}
);

/*
Progress Bar Block Filter Hook Start 
*/
// progress-bar source

const progressBarSourcePro = {
	normal: {
		label: "Normal",
		value: "normal",
	},
	total_sale: {
		label: "Total Sale",
		value: "total_sale",
	},
	stock_quantity: {
		label: "Stock Quantity",
		value: "stock_quantity",
	},
};

addFilter(
	"postGridProgressBarSource",
	"combo-blocks/progress-bar",
	function (options) {
		return progressBarSourcePro;
	}
);

/*
Woo Product Info Item Block Filter Hook Start 
*/
// woo-product-info-item objectTypes

const wooProductInfoItemObjectTypesPro = {
	weight: { label: "Weight", value: "weight" },
	length: { label: "Length", value: "length" },
	width: { label: "Width", value: "width" },
	height: { label: "Height", value: "height" },
	dimensions: { label: "Dimensions", value: "dimensions" },
	taxonomy: { label: "Taxonomy", value: "taxonomy" },
	meta: { label: "Custom Meta", value: "meta" },
};

addFilter(
	"postGridWooProductInfoItemObjectTypes",
	"combo-blocks/woo-product-info-item",
	function (options) {
		return wooProductInfoItemObjectTypesPro;
	}
);

/*
Post Query Block Filter Hook Start 
*/
// post-query queryPrams

const postQueryQueryPramsPro = {
	postType: {
		value: ["post"],
		multiple: false,
		id: "postType",
		label: "Post types",
		description: "Select Post Types to Query",
	},
	s: {
		value: "",
		multiple: false,
		id: "s",
		label: "Keyword",
		description: "Search keyword, ex: hello",
	},
	postStatus: {
		value: [],
		val: [],

		multiple: false,
		id: "postStatus",
		label: "Post status",
		description: "Query post by post status",
	},
	order: {
		value: "",
		multiple: false,
		id: "order",
		label: "Order",
		description: "Post query order",
	},
	orderby: {
		value: [],
		val: [],

		multiple: false,
		id: "orderby",
		label: "Orderby",
		description: "Post query orderby",
	},
	metaKey: {
		value: "",
		multiple: false,
		id: "metaKey",
		label: "Meta fields key",
		description: "Post query by meta fields key",
	},
	// Category Parameters
	cat: {
		value: "",
		multiple: false,
		id: "cat",
		label: "Category ID",
		description: "Post query by Category ID",
	},
	categoryName: {
		value: "",
		multiple: false,
		id: "categoryName",
		label: "Category Name",
		description: "Post query by Category Name",
	},
	categoryAnd: {
		value: [],
		val: [],

		multiple: false,
		id: "categoryAnd",
		label: "Category And",
		description: "Post query by Category IDs",

	},
	categoryIn: {
		value: [],
		val: [],

		multiple: false,
		id: "categoryIn",
		label: "Category In",
		description: "Post query by Category IDs",

	},
	categoryNotIn: {
		value: [],
		val: [],

		multiple: false,
		id: "categoryNotIn",
		label: "Category Not In",
		description: "Post query by excluded Category IDs",

	},
	// Tag Parameters
	tag: {
		val: "",
		multiple: false,
		id: "tag",
		label: "Tags",
		description: "Post query by Tag slug",
	},
	tagId: {
		val: "",
		multiple: false,
		id: "tagId",
		label: "Tag Id",
		description: "Post query by Tag ID",
	},
	tagAnd: {
		val: [],
		multiple: false,
		id: "tagAnd",
		label: "Tag And",
		description: "Post query by Tag Ids",

	},
	tagIn: {
		val: [],
		multiple: false,
		id: "tagIn",
		label: "Tag In",
		description: "Post query by Tag ids",

	},
	tagNotIn: {
		val: [],
		multiple: false,
		id: "tagNotIn",
		label: "Tag Not In",
		description: "Post query by excluded Tag ids",
	},
	tagSlugAnd: {
		val: [],
		multiple: false,
		id: "tagSlugAnd",
		label: "Tag Slug And",
		description: "Post query by Tags slug",

	},
	tagSlugIn: {
		val: [],
		multiple: false,
		id: "tagSlugIn",
		label: "Tag Slug In",
		description: "Post query by excluded Tags slug",

	},
	taxQuery: {
		value: [],
		val: [],
		multiple: false,
		id: "taxQuery",
		label: "Tax Query",
		description: "Taxonomies query arguments",

	},
	taxQueryRelation: {
		val: "OR",
		multiple: false,
		id: "taxQueryRelation",
		label: "Tax Query Relation",
		description: "Taxonomies query relation",
	},
	// // Date Parameters
	dateQuery: {
		value: [],
		val: [],

		multiple: false,
		id: "dateQuery",
		label: "Date Query",
		description: "Post query by date",

	},
	year: {
		val: "",
		multiple: false,
		id: "year",
		label: "Year",
		description: "Post query by year",
	},
	monthnum: {
		val: "",
		multiple: false,
		id: "monthnum",
		label: "Month",
		description: "Post query by month",
	},
	w: {
		val: "",
		multiple: false,
		id: "w",
		label: "Week",
		description: "Post query by week",
	},
	day: {
		val: "",
		multiple: false,
		id: "day",
		label: "Day",
		description: "Post query by day",
	},
	hour: {
		val: "",
		multiple: false,
		id: "hour",
		label: "Hour",
		description: "Post query by hour",
	},
	minute: {
		val: "",
		multiple: false,
		id: "minute",
		label: "Miniute",
		description: "Post query by miniute",
	},
	second: {
		val: "",
		multiple: false,
		id: "second",
		label: "Second",
		description: "Post query by second",
	},
	m: {
		val: "",
		multiple: false,
		id: "m",
		label: "Month",
		description: "Post query by month",
	},
	// // Author Parameters
	author: {
		val: "",
		multiple: false,
		id: "author",
		label: "Author",
		description: "Post query by Author ID",
	},
	authorName: {
		val: "",
		multiple: false,
		id: "authorName",
		label: "Author Name",
		description: "Post query by Author Name",
	},
	authorIn: {
		val: [],
		multiple: false,
		id: "authorIn",
		label: "Author In",
		description: "Post query by Author IDs",

	},
	authorNotIn: {
		val: [],
		multiple: false,
		id: "authorNotIn",
		label: "Author Not In",
		description: "Post query by exluded Author IDs",

	},
	p: {
		val: "",
		multiple: false,
		id: "p",
		label: "Post id",
		description: "Post query by single post id",
	},
	name: {
		val: "",
		multiple: false,
		id: "name",
		label: "Name",
		description: "Post query by post slug",
	},
	pageId: {
		val: "",
		multiple: false,
		id: "pageId",
		label: "Page Id",
		description: "Post query by single page id",
	},
	pagename: {
		val: "",
		multiple: false,
		id: "pagename",
		label: "Page name",
		description: "Post query by page slug",
	},
	postParent: {
		val: "",
		multiple: false,
		id: "postParent",
		label: "Post Parent",
		description: "Add {ID} to Post query by post parent id",

	},
	postParentIn: {
		val: [],
		multiple: false,
		id: "postParentIn",
		label: "Post Parent In",
		description: "Post query by post parent ids",

	},
	postParentNotIn: {
		val: [],
		multiple: false,
		id: "postParentNotIn",
		label: "Post Parent Not In",
		description: "Post query by excluded post parent ids",
	},
	postIn: {
		val: [],
		multiple: false,
		id: "postIn",
		label: "Post In",
		description: "Post query by multiple post ids, comma separated.",

	},
	postNotIn: {
		val: [],
		multiple: false,
		id: "postNotIn",
		label: "Post Not In",
		description: "Post query by excluded post ids",

	},
	postNameIn: {
		val: [{ slug: "" }],
		multiple: false,
		id: "postNameIn",
		label: "Post Name In",
		description: "Post query by post slugs",

	},
	hasPassword: {
		val: "",
		multiple: false,
		id: "hasPassword",
		label: "Has Password",
		description: "Post query for posts with passwords",
	},
	postPassword: {
		val: "",
		multiple: false,
		id: "postPassword",
		label: "Post Password",
		description: "Post query for posts with particular passwords",

	},
	commentCount: {
		val: { compare: "=", value: 10 },
		multiple: false,
		id: "commentCount",
		label: "Comment Count",
		description: "Post query by comment count",
	},
	nopaging: {
		val: "",
		multiple: false,
		id: "nopaging",
		label: "No Paging",
		description: "Enable show all posts or use pagination",
	},
	postsPerPage: {
		val: "",
		multiple: false,
		id: "postsPerPage",
		label: "Posts Per Page",
		description: "Number of post to show per page",
	},
	paged: {
		val: "",
		multiple: false,
		id: "paged",
		label: "Paged",
		description: "Pagination start with",
	},
	offset: {
		val: "",
		multiple: false,
		id: "offset",
		label: "Offset",
		description: "Number of post to displace or pass over",
	},
	postsPerArchivePage: {
		val: "",
		multiple: false,
		id: "postsPerArchivePage",
		label: "Posts Per Archive Page",
		description: "",
	},
	ignoreStickyPosts: {
		val: "",
		multiple: false,
		id: "ignoreStickyPosts",
		label: "Ignore Sticky Posts",
		description: "Ignore post from post query",

	},
	metaKey: {
		val: "",
		multiple: false,
		id: "metaKey",
		label: "Meta Key",
		description: "Post query by custom field key",
	},
	metaValue: {
		val: "",
		multiple: false,
		id: "metaValue",
		label: "Meta Value",
		description: "Post query by custom field value",
	},
	metaValueNum: {
		val: "",
		multiple: false,
		id: "metaValueNum",
		label: "Meta Value Num",
		description: "Post query by custom field value for number types",
	},
	metaCompare: {
		val: "",
		multiple: false,
		id: "metaCompare",
		label: "Meta Compare",
		description: "Meta query compare",
	},
	metaQuery: {
		value: [],
		val: [],

		multiple: false,
		id: "metaQuery",
		label: "Meta Query",
		description: "Advance meta fields query",

	},
	perm: {
		val: "readable",
		multiple: false,
		id: "perm",
		label: "Perm",
		description: "User permission parameter",
	},
	postMimeType: {
		val: [],
		multiple: false,
		id: "postMimeType",
		label: "Post Mime Type",
		description: "Post query by allwed post mime types",
	},
	cacheResults: {
		val: false,
		multiple: false,
		id: "cacheResults",
		label: "Cache Results",
		description: "Enable Post information cache",
	},
	updatePostMetaCache: {
		val: false,
		multiple: false,
		id: "updatePostMetaCache",
		label: "Update Post Meta Cache",
		description: "Enable Post meta information cache",
	},
	updatePostTermCache: {
		val: false,
		multiple: false,
		id: "updatePostTermCache",
		label: "Update Post Term Cache",
		description: "Enable Post term information cache",
	},
};

addFilter(
	"PGpostQueryPramsArgs",
	"combo-blocks/post-query",
	function (options) {
		return postQueryQueryPramsPro;
	}
);

/*
Visible Args Block Filter Hook Start 
*/

var visibleArgsPro = {
	userLogged: {
		label: "User Logged",
		description: "Show when user logged-in(any user)",
		args: { id: "userLogged", value: "" },
	},
	userNotLogged: {
		label: "User Not Logged",
		description: "Show when user Not logged-in.",
		args: { id: "userNotLogged", value: "" },
	},
	userRoles: {
		label: "User Roles",
		description: "Show when user has specific roles.",
		args: { id: "userRoles", roles: [], compare: "include" },
	},
	userIds: {
		label: "User Ids",
		description: "Show when user has specific ids.",
		args: { id: "userIds", value: "", values: [], compare: "=" },
	},
	// isDevice: {
	// 	label: "Device",
	// 	description: "",
	// 	args: { id: "isDevice", value: "", values: [], compare: "include" },
	// },
	// isBrowsers: {
	// 	label: "Is Browsers",
	// 	description: "",
	// 	args: { id: "isBrowsers", value: "", values: [], compare: "include" },
	// },
	isCategory: {
		label: "isCategory",
		description: "",
		args: { id: "isCategory", value: "" },
	},
	isTag: {
		label: "isTag",
		description: "",
		args: { id: "isTag", value: "" },
	},
	isPage: {
		label: "isPage",
		description: "",
		args: { id: "isPage", value: "" },
	},
	isSingle: {
		label: "isSingle",
		description: "",
		args: { id: "isSingle", value: "" },
	},
	isHome: {
		label: "Is Home",
		description: "",
		args: { id: "isHome", value: "" },
	},

	isFrontPage: {
		label: "Is Front page",
		description: "",
		args: { id: "isFrontPage", value: "" },
	},
	isBlog: {
		label: "Is Posts Page",
		description: "",
		args: { id: "isBlog", value: "" },
	},
	isCommentsOpen: {
		label: "Is Comments Open",
		description: "",
		args: { id: "isCommentsOpen", value: "" },
	},
	isPostArchive: {
		label: "Is Post Archive",
		description: "",
		args: { id: "isPostArchive", value: "", values: [], compare: "" },
	},
	isArchive: {
		label: "Is Archive",
		description: "",
		args: { id: "isArchive", value: "" },
	},
	isYears: {
		label: "is Years",
		description: "Show when specific Years",
		args: { id: "isYears", value: "", values: "", compare: "=" },
	},
	isMonths: {
		label: "is Months",
		description: "Show when specific months",
		args: { id: "isMonths", value: "", values: [], compare: "=" },
	},
	weekDays: {
		label: "is Week day",
		description: "Show when specific week days",
		args: { id: "weekDays", value: "", values: [], compare: "=" },
	},
	isHours: {
		label: "is Hours",
		description: "Show when specific hours",
		args: { id: "isHours", value: "", values: [], compare: "=" },
	},
	//isMinutes: { label: 'is Minutes', description: 'Show when specific Minutes', args: { id: 'isMinutes', value: '', values: [], compare: '=' } },
	isDates: {
		label: "is Dates",
		description: "Show when specific date",
		args: { id: "isDates", value: "", values: [], compare: "=" },
	},

	urlString: {
		label: "URL String",
		description: "If URL contain certain string.",
		args: { id: "urlString", value: "" },
	},
	urlPrams: {
		label: "URL Prams",
		description:
			"If URL contain certain parameter(ex: domain.com/some-page?key=value)",
		args: { id: "urlPrams", value: "" },
	},
	urlPramsVal: {
		label: __("URL Prams Value", "combo-blocks-pro"),
		description:
			__("If URL contain certain parameter(ex: domain.com/some-page?key=value)", "combo-blocks-pro"),
		args: { id: "urlPramsVal", key: "", value: "" },
	},


	referrerExist: {
		label: "Referrer Exist",
		description: "",
		args: { id: "referrerExist", value: "" },
	},

	isUserMeta: {
		label: "User Meta",
		description: "",
		args: { id: "isUserMeta", metaKey: "", value: "", values: [], compare: "=" },

	},
	isPostMeta: {
		label: "Post Meta",
		description: "",
		args: { id: "isPostMeta", metaKey: "", value: "", values: [], compare: "=" },

	},
	// isPlatforms: {
	// 	label: "Is Platform",
	// 	description: "",
	// 	args: { id: "isPlatforms", value: "", values: [], compare: "=" },
	//
	// },

	// isCountries: {
	// 	label: "Is Country",
	// 	description: "",
	// 	args: { id: "isCountries", value: "", values: [], compare: "include" },
	//
	// },

	userCapabilities: {
		label: "User Capability",
		description: "",
		args: {
			id: "userCapabilities",
			value: "",
			values: [],
			compare: "exist",
		},
	},

	postsIds: {
		label: "Post Ids",
		description: "",
		args: { id: "postsIds", value: "", values: [], compare: "include" },
	},
	termIds: {
		label: "Term Ids",
		description: "",
		args: { id: "termIds", value: "", values: [], compare: "include" },
	},
	authorIds: {
		label: "Author Ids",
		description: "",
		args: { id: "authorIds", value: "", values: [], compare: "include" },
	},

	isSticky: {
		label: "Is Sticky",
		description: "",
		args: { id: "isSticky", value: "" },
	},
	isPostHierarchical: {
		label: "Is Post Hierarchical",
		description: "",
		args: { id: "isPostHierarchical", value: "" },
	},

	isPageTemplate: {
		label: "Is Page Template",
		description: "",
		args: { id: "isPageTemplate", value: "", values: [], compare: "" },
	},

	isTax: {
		label: "Is Tax",
		description: "",
		args: { id: "isTax", value: "", values: [], compare: "" },
	},
	isAuthor: {
		label: "Is Author",
		description: "",
		args: { id: "isAuthor", value: "", values: [], compare: "" },
	},
	isMultiAuthor: {
		label: "Is Multi Author",
		description: "",
		args: { id: "isMultiAuthor", value: "" },
	},
	isDate: {
		label: "Is Date",
		description: "",
		args: { id: "isDate", value: "" },
	},
	isYear: {
		label: "Is Year",
		description: "",
		args: { id: "isYear", value: "" },
	},
	isMonth: {
		label: "Is Month",
		description: "",
		args: { id: "isMonth", value: "" },
	},
	isDay: {
		label: "Is Day",
		description: "",
		args: { id: "isDay", value: "" },
	},
	isTime: {
		label: "Is Time",
		description: "",
		args: { id: "isTime", value: "" },
	},
	isNewDay: {
		label: "Is NewDay",
		description: "",
		args: { id: "isNewDay", value: "" },
	},

	isSearch: {
		label: "Is Search",
		description: "",
		args: { id: "isSearch", value: "", compare: "contain" }, // start with, end with, contain, not contain, =, !=
	},
	is404: {
		label: "Is 404",
		description: "",
		args: { id: "is404", value: "" },
	},
	isAttachment: {
		label: "Is Attachment",
		description: "",
		args: { id: "isAttachment", value: "" },
	},
	isSingular: {
		label: "Is Singular",
		description: "",
		args: { id: "isSingular", value: "" },
	},
	isMainQuery: {
		label: "Is MainQuery",
		description: "",
		args: { id: "isMainQuery", value: "", values: [], compare: "" },
	},
	isFeed: {
		label: "Is Feed",
		description: "",
		args: { id: "isFeed", value: "" },
	},
	isTrackback: {
		label: "Is Trackback",
		description: "",
		args: { id: "isTrackback", value: "" },
	},
	isPreview: {
		label: "Is Preview",
		description: "",
		args: { id: "isPreview", value: "" },
	},
	hasExcerpt: {
		label: "Has Excerpt",
		description: "",
		args: { id: "hasExcerpt", value: "" },
	},
	hasNavMenu: {
		label: "Has NavMenu",
		description: "",
		args: { id: "hasNavMenu", value: "" },
	},
	isRtl: {
		label: "Is Rtl",
		description: "",
		args: { id: "isRtl", value: "" },
	},
	hasPostThumbnail: {
		label: "Has Post Thumbnail",
		description: "",
		args: { id: "hasPostThumbnail", value: "" },
	},
	isUserLoggedIn: {
		label: "Is UserLoggedIn",
		description: "",
		args: { id: "isUserLoggedIn", value: "" },
	},
	isMainSite: {
		label: "Is Main Site",
		description: "",
		args: { id: "isMainSite", siteId: "", networkId: "" },
	},

	hasTerm: {
		label: "Has Term",
		description: "",
		args: { id: "hasTerm", value: "" },
	},
	isTaxonomyHierarchical: {
		label: "Is Taxonomy Hierarchical",
		description: "",
		args: { id: "isTaxonomyHierarchical", value: "" },
	},
	taxonomyExists: {
		label: "Taxonomy Exists",
		description: "",
		args: { id: "taxonomyExists", value: "" },
	},

	hasPostParent: {
		label: "Has Post Parent",
		description: "",
		args: { id: "hasPostParent", value: "" },
	},

	wcisAccountPage: {
		label: "Is WooCommerce Account",
		description: "",
		args: { id: "wcisAccountPage", value: "" },
	},
	wcShop: {
		label: "Is WooCommerce Shop",
		description: "",
		args: { id: "wcShop", value: "" },
	},
	wchasUpSells: {
		label: "WooCommerce - Has Up-sells",
		description: "",
		args: { id: "wchasUpSells", value: "" },
	},
	wchasCrossSells: {
		label: "WooCommerce - Has Cross-sells",
		description: "",
		args: { id: "wchasCrossSells", value: "" },
	},
	wcisCart: {
		label: "WooCommerce - is Cart Page",
		description: "",
		args: { id: "wcisCart", value: "" },
	},
	wcisCheckout: {
		label: "WooCommerce - is checkout page",
		description: "",
		args: { id: "wcisCheckout", value: "" },
	},
	wcisOnSale: {
		label: "WooCommerce - is on sale",
		description: "",
		args: { id: "wcisOnSale", value: "" },
	},
	wcisInStock: {
		label: "WooCommerce - is in stock",
		description: "",
		args: { id: "wcisInStock", value: "" },
	},
	wcproductType: {
		label: "WooCommerce - product Type",
		description: "",
		args: { id: "wcproductType", value: "" },
	},

	hasCookie: {
		label: "Has Cookie",
		description: "If certain cookie exist",
		args: { id: "hasCookie", cookieName: "", value: "", compare: "exist" },
	},

	// queryArgsExist: {
	// 	label: "Query Arg Exist",
	// 	description: "",
	// 	args: { id: "queryArgsExist", value: "" },

	// },
	// userVisitXPages: {
	// 	label: "User has viewed X Page",
	// 	description: "",
	// 	args: { id: "userVisitXPages", value: "" },
	// },

	hasPostComments: {
		label: "Has Post Comments",
		description: "",
		args: { id: "hasPostComments", value: "", count: 0, compare: "=" },
	},
	hasUserComments: {
		label: "Has User Comments",
		description: "",
		args: { id: "hasUserComments", value: "", count: 0, compare: "=" },
	},
	hasUserCommentsOnPost: {
		label: "Has User Comments On Post",
		description: "",
		args: { id: "hasUserCommentsOnPost", value: "", compare: "=" },
	},

	// queryArgEqualX: {
	// 	label: "Query arg equals X",
	// 	description: "",
	// 	args: { id: "queryArgEqualX", value: "" },
	// },
	postTypes: {
		label: "Post Types",
		description: "",
		args: { id: "postTypes", value: "", values: [], compare: "exist" },
	},
	pageTypes: {
		label: "Page Types",
		description: "",
		args: { id: "pageTypes", value: "", values: [], compare: "exist" },
	},

	hasPostTerms: {
		label: "Post has terms",
		description: "",
		args: {
			id: "hasPostTerms",
			value: "",
			taxonomy: "",
			values: [],
			compare: "exist",
		},
	},

	hasPostCategories: {
		label: "Has Post Categories",
		description: "",
		args: { id: "postCategories", value: "", values: [], compare: "exist" },
	},
	hasPostTags: {
		label: "Has Post Tags",
		description: "",
		args: { id: "hasPostTags", value: "", values: [], compare: "exist" },
	},
	hasPostFormat: {
		label: "Has Post Format",
		description: "",
		args: { id: "hasPostFormat", format: "", values: [], compare: "exist" },
	},
	hasMeta: {
		label: "Has Meta",
		description: "",
		args: { id: "hasMeta", value: "", values: [], compare: "exist" },
	},
	hasBlock: {
		label: "Has Block",
		description: "",
		args: { id: "hasBlock", blockName: "", values: [], compare: "exist" },
	},
	hasAction: {
		label: "Has Action",
		description: "",
		args: { id: "hasAction", hookName: "", callback: "", compare: "exist" },
	},
	hasBlocks: {
		label: "Has Blocks",
		description: "",
		args: { id: "hasBlocks", value: "", values: [], compare: "exist" },
	},
	hasFilter: {
		label: "Has Filter",
		description: "",
		args: { id: "hasFilter", value: "", values: [], compare: "exist" },
	},
	hasShortcode: {
		label: "Has Shortcode",
		description: "",
		args: { id: "hasShortcode", tag: "", compare: "exist" },
	},
	hasSiteIcon: {
		label: "Has SiteIcon",
		description: "",
		args: { id: "hasSiteIcon", value: "", values: [], compare: "exist" },
	},
	hasTermMeta: {
		label: "Has TermMeta",
		description: "",
		args: { id: "hasTermMeta", value: "", values: [], compare: "exist" },
	},
	hasCustomLogo: {
		label: "Has CustomLogo",
		description: "",
		args: { id: "hasCustomLogo", value: "", values: [], compare: "exist" },
	},
	hasHeaderImage: {
		label: "Has HeaderImage",
		description: "",
		args: { id: "hasHeaderImage", value: "", values: [], compare: "exist" },
	},
	hasHeaderVideo: {
		label: "Has Header Video",
		description: "",
		args: { id: "hasHeaderVideo", value: "", values: [], compare: "exist" },
	},
	hasCustomHeader: {
		label: "Has Custom Header",
		description: "",
		args: { id: "hasCustomHeader", value: "", values: [], compare: "exist" },
	},
	userCan: {
		label: "User Can",
		description: "",
		args: {
			id: "userCan",
			capability: "",
			args: "",
			values: [],
			compare: "include",
		},
	},
	authorCan: {
		label: "Author Can",
		description: "",
		args: {
			id: "authorCan",
			capability: "",
			args: "",
			values: [],
			compare: "include",
		},
	},
	hasPMproLevels: {
		label: "has PMPro Levels",
		description: "",
		args: { id: "hasPMproLevels", args: "", values: [], compare: "include" },
	},
	tutorLmsIsErolled: {
		label: __("Tutor LMS - Is Enrolled", "combo-blocks-pro"),
		description: "",
		args: { id: "tutorLmsInErolled", value: "", compare: "=" },

	},
	tutorLmsIsPublicCourse: {
		label: __("Tutor LMS - Is Public Course", "combo-blocks-pro"),
		description: "",
		args: { id: "tutorLmsIsPublicCourse", value: "", compare: "=" },

	},
	tutorLmsIsPrivileged: {
		label: __("Tutor LMS - Is Privileged", "combo-blocks-pro"),
		description: "",
		args: { id: "tutorLmsIsPrivileged", value: "", compare: "=" },

	},
	tutorLmsIsPurchasable: {
		label: __("Tutor LMS - Is Purchasable", "combo-blocks-pro"),
		description: "",
		args: { id: "tutorLmsIsPurchasable", value: "", compare: "=" },

	},
	tutorLmsIsCompletedCourse: {
		label: __("Tutor LMS - Is Completed ourse", "combo-blocks-pro"),
		description: "",
		args: { id: "tutorLmsIsCompletedCourse", value: "", compare: "=" },

	},
	tutorLmsCanRetakeCourse: {
		label: __("Tutor LMS - Can user retake course", "combo-blocks-pro"),
		description: "",
		args: { id: "tutorLmsCanRetakeCourse", value: "", compare: "=" },

	},
	tutorLmsIsCourseFullyBooked: {
		label: __("Tutor LMS - Is Course Fully Booked", "combo-blocks-pro"),
		description: "",
		args: { id: "tutorLmsIsCourseFullyBooked", value: "", compare: "=" },

	},


	hasMeprMemberships: {
		label: "has Memberpress Memberships ",
		description: "",
		args: { id: "hasMeprMemberships", args: "", value: "", compare: "include" },
	},

	// visitCount: { label: 'Visit Count', description: 'Display popup based on date', args: { id: 'visitCount', value: '', compair: '' }},
};

addFilter("postGridVisibleArgs", "combo-blocks/visibleArgs", function (options) {
	return visibleArgsPro;
});

var closeTriggerPramsPro = {
	delay: {
		label: "Delay",
		description: "Delay certain amount of time after page load.",
		args: { id: "delay", value: 1000 },
	},
	scrollPercent: {
		label: "Scroll Percent",
		description: "After certain amount(%) of scroll",
		args: { id: "scrollPercent", min: "30", max: 50 },
	},
	scrollFixed: {
		label: "Scroll Fixed",
		description: "After fixed amount of scroll",
		args: { id: "scrollFixed", min: "30", max: 50 },
	},
	scrollEnd: {
		label: "Scroll End",
		description: "Scroll to end of page",
		args: { id: "scrollEnd", min: "30", max: 50 },
	},
	scrollElement: {
		label: "Scroll Element",
		description: "Scroll to certain element by class or id",
		args: { id: "scrollElement", value: "" },
	},
	clickFirst: {
		label: "Click First",
		description: "After first click on page",
		args: { id: "clickFirst", value: 1 },
	},
	clickCount: {
		label: "Click Count",
		description: "After certain amount of click on page",
		args: { id: "clickCount", value: 5 },
	},
	clickRight: {
		label: "Click Right",
		description: "on right click",
		args: { id: "clickRight", value: 0 },
	},
	onExit: {
		label: "On Exit",
		description: "before close browser tab.",
		args: { id: "onExit", value: 1 },
	},
	clickElement: {
		label: "Click Element",
		description: "After click an element by id or class",
		args: { id: "clickElement", value: "" },
	},
	dateCountdownExpired: {
		label: "Date Countdown Expired",
		description: "After expired from date countdown block",
		args: { id: "dateCountdownExpired", value: "", once: false },
	},
	keyPress: {
		label: "Key Press",
		description: "Key Press to close.",
		args: { id: "keyPress", value: "" },
	},
	mouseOutElement: {
		label: "Mouse Out Element",
		description: "if visitor come from external website.",
		args: { id: "mouseOutElement", value: "" },
	},
	mouseOverElement: {
		label: "Mouse Over Element",
		description: "if visitor come from external website.",
		args: { id: "mouseOverElement", value: "" },
	},
	// inactiveXSec: {
	// 	label: "Inactive X Second",
	// 	description: "if visitor come from external website.",
	// 	args: { id: "inactiveXSec", value: "" },
	// },
};

addFilter(
	"postGridPopupCloseTriggerPrams",
	"combo-blocks/popup",
	function (options) {
		return closeTriggerPramsPro;
	}
);

const keysListPro = {
	recaptcha: {
		id: "recaptcha",
		label: "recaptcha",
		args: {
			site_key: "",
			secret_key: "",
			version: "v2Checkbox", // v3, v2Checkbox, v2Invisible
		},
	},
	// hCAPTCHA: {
	// 	id: "hCAPTCHA",
	// 	label: "hCAPTCHA",
	// 	args: {
	// 		site_key: "",
	// 	},
	// },
	dropbox: {
		id: "dropbox",
		label: "Dropbox",
		args: {
			accessToken: "",
		},
	},
	googleDrive: {
		id: "googleDrive",
		label: "Google Drive",
		args: {
			accessToken: "",
		},
	},
	airtable: {
		id: "airtable",
		label: "Airtable",
		args: {
			accessToken: "",
		},
	},
	googleMap: {
		id: "googleMap",
		label: "Google Map",
		args: {
			accessToken: "",
		},
	},
	zendesk: {
		id: "zendesk",
		label: "Zendesk",
		args: {
			apiToken: "",
			subdomain: "",
			email: "",

		},
	},
	twilio: {
		id: "twilio",
		label: "Twilio",
		args: {
			authToken: "",
			accountSid: "",
			phoneNumber: "",

		},
	},
	youtube: {
		id: "youtube",
		label: "Youtube",
		args: {
			apikey: "",
		},
	},

	// gMAP: {
	// 	id: "gMAP",
	// 	label: "Google Map",
	// 	args: {
	// 		apikey: "",
	// 	},
	// },
	openAI: {
		id: "openAI",
		label: "openAI",
		args: {
			apikey: "",
			model: "",
		},
	},
	acumbamail: {
		id: "acumbamail",
		label: "Acumbamail",
		args: {
			apikey: "",
			authToken: "",

		},

	},
	brevo: {
		id: "brevo",
		label: "Brevo",
		args: {
			apikey: "",
		},
	},
	omnisend: {
		id: "omnisend",
		label: "Omnisend",
		args: {
			apikey: "",
		},
	},
	klaviyo: {
		id: "klaviyo",
		label: "Klaviyo",
		args: {
			apikey: "",
		},
	},
	// aweber: {
	// 	id: "aweber",
	// 	label: "Aweber API",
	// 	args: {
	// 		accountId: "",
	// 		accessToken: "",
	// 	},
	// },
	mailerlite: {
		id: "mailerlite",
		label: "Mailer Lite",
		args: {
			apikey: "",
		},
	},
	emailoctopus: {
		id: "emailoctopus",
		label: "Email Octopus",
		args: {
			apikey: "",
		},
	},
	sender: {
		id: "sender",
		label: "Sender",
		args: {
			apikey: "",
		},
	},
	// constantcontact: {
	// 	id: "constantcontact",
	// 	label: "Constant Contact",
	// 	args: {
	// 		accessToken: "",
	// 	},
	//
	// },
	// getresponse: {
	// 	id: "getresponse",
	// 	label: "Get Response",
	// 	args: {
	// 		apikey: "",
	// 	},
	//
	// },
	// drip: {
	// 	id: "drip",
	// 	label: "Drip",
	// 	args: {
	// 		accountId: "",
	// 		apikey: "",
	// 	},
	//
	// },
	mailmodo: {
		id: "mailmodo",
		label: "mailmodo",
		args: {
			apikey: "",
		},
	},
	moosend: {
		id: "moosend",
		label: "Moo Send",
		args: {
			apikey: "",
		},
	},
	// hubspot: {
	// 	id: "hubspot",
	// 	label: "Hub Spot",
	// 	args: {
	// 		apikey: "",
	// 	},
	//
	// },
	mailjet: {
		id: "mailjet",
		label: "Mailjet",
		args: {
			apikeyPublic: "",
			apikeyPrivate: "",
		},
	},
	// mailgun: {
	// 	id: "mailgun",
	// 	label: "Mailgun",
	// 	args: {
	// 		username: "",
	// 		pass: "",
	// 	},
	//
	// },
	// convertkit: {
	// 	id: "convertkit",
	// 	label: "Convert Kit",
	// 	args: {
	// 		apikey: "",
	// 		apiSecret: "",
	// 	},
	//
	// },
	// elasticemail: {
	// 	id: "elasticemail",
	// 	label: "Elastice Mail",
	// 	args: {
	// 		apikey: "",
	// 	},
	//
	// },
	// sendgrid: {
	// 	id: "sendgrid",
	// 	label: "Send Grid",
	// 	args: {
	// 		apikey: "",
	// 	},
	//
	// },
	// mailchimp: {
	// 	id: "mailchimp",
	// 	label: "Mail Chimp",
	// 	args: {
	// 		apikey: "",
	// 		dc: "",
	// 	},
	//
	// },
	// activecampaign: {
	// 	id: "activecampaign",
	// 	label: "Active Campaign",
	// 	args: {
	// 		apikey: "",
	// 		accountName: "",
	// 	},
	//
	// },
	// zoho: {
	// 	id: "zoho",
	// 	label: "Zoho",
	// 	args: {
	// 		apikey: "",
	// 	},

	// },
	// netcore: {
	// 	id: "netcore",
	// 	label: "Net Core",
	// 	args: {
	// 		apikey: "",
	// 	},

	// },
	// postman: {
	// 	id: "postman",
	// 	label: "Postman",
	// 	args: {
	// 		apikey: "",
	// 	},

	// },
};

addFilter("pgAPIKeys", "combo-blocks/dashboard", function (options) {
	return keysListPro;
});

var inputValueSourcesPro = {
	none: { label: "Choose...", value: "" },
	postID: { label: "Post ID", value: "postID" },
	postSlug: { label: "Post Slug", value: "postSlug" },
	postTitle: { label: "Post Title", value: "postTitle" },
	postContent: { label: "Post Content", value: "postContent" },
	postExcerpt: { label: "Post Excerpt", value: "postExcerpt" },
	postModified: { label: "Post Modified", value: "postModified" },
	postModifiedGmt: { label: "Post Modified GMT", value: "postModifiedGmt" },
	postDate: { label: "Post Date", value: "postDate" },
	postDateGmt: { label: "Post Date GMT", value: "postDateGmt" },
	postParent: { label: "Post Parent", value: "postParent" },
	postStatus: { label: "Post Status", value: "postStatus" },
	postPassword: { label: "Post Password", value: "postPassword" },
	postCommentStatus: {
		label: "Post Comment Status",
		value: "postCommentStatus",
	},
	postMenuOrder: { label: "Post Menu Order", value: "postMenuOrder" },
	postCommentCount: { label: "Post Comment Count", value: "postCommentCount" },
	postAuthorID: { label: "Post Author ID", value: "postAuthorID" },
	postTags: { label: "Post Tags", value: "postTags" },
	postTagsIds: { label: "Post Tags Ids (Array)", value: "postTagsIds" },
	postCategoryIds: {
		label: "Post Category Ids (Array)",
		value: "postCategoryIds",
	},
	userId: { label: "User Id", value: "userId" },
	userEmail: { label: "User Email", value: "userEmail" },
	userDisplayName: { label: "User Display Name", value: "userDisplayName" },
	userFirstName: { label: "User First Name", value: "userFirstName" },
	userLastName: { label: "User Last Name", value: "userLastName" },
	userDescription: { label: "User Description", value: "userDescription" },
	userUrl: { label: "User URL", value: "userUrl" },
	userLogin: { label: "User Login", value: "userLogin" },
	userNicename: { label: "User Nicename", value: "userNicename" },
	termName: { label: "Term Name", value: "termName" },
	termDescription: { label: "Term Description", value: "termDescription" },
	termCount: { label: "Term Count", value: "termCount" },
	termSlug: { label: "Term Slug", value: "termSlug" },
	postMeta: { label: "Post Meta", value: "postMeta" },
	termMeta: { label: "Term Meta", value: "termMeta" },
	userMeta: { label: "User Meta", value: "userMeta" },
	GET: { label: "GET", value: "GET" },
};

addFilter(
	"postGridInputValueSources",
	"combo-blocks/inputValueSources",
	function (options) {
		return inputValueSourcesPro;
	}
);

var objectMapOptionsPro = {
	none: { label: "None", value: "" },
	postTerm: { label: "Post Term", value: "postTerm" },
	postMeta: { label: "Post Meta", value: "postMeta" },
	commentMeta: { label: "Comment Meta", value: "commentMeta" },
	termMeta: { label: "Term Meta", value: "termMeta" },
	userMeta: { label: "User Meta", value: "userMeta" },
};

addFilter(
	"postGridObjectMapOptions",
	"combo-blocks/ObjectMapOptions",
	function (options) {
		return objectMapOptionsPro;
	}
);

const usersQueryPramsPro = {
	orderby: {
		value: "",
		multiple: false,
		id: "orderby",
		label: "Order By",
		description: "Field(s) to sort the retrieved users by.",
		longDescription:
			"Field(s) to sort the retrieved users by. May be a single value, an array of values, or a multi-dimensional array with fields as keys and orders ('ASC' or 'DESC') as values.",
	},
	order: {
		value: "ASC",
		multiple: false,
		id: "order",
		label: "Order",
		description:
			"Designates ascending or descending order of users. Order values passed as part of an $orderby array take precedence over this parameter. Accepts 'ASC', 'DESC'. Default 'ASC'.",
		longDescription:
			"Designates ascending or descending order of users. Order values passed as part of an $orderby array take precedence over this parameter. Accepts 'ASC', 'DESC'. Default 'ASC'.",
	},
	offset: {
		value: "",
		multiple: false,
		id: "offset",

		label: "Offset",
		description: "Number of users to offset in retrieved results.",
		longDescription:
			"Number of users to offset in retrieved results. Can be used in conjunction with pagination. Default 0.",
	},
	number: {
		value: "",
		multiple: false,
		id: "number",

		label: "Number",
		description: "Number of users to limit the query for.",
		longDescription:
			"Number of users to limit the query for. Can be used in conjunction with pagination. Value -1 (all) is supported, but should be used with caution on larger sites. Default -1 (all users).",
	},
	include: {
		value: "",
		multiple: false,
		id: "include",

		label: "Include",
		description: "An array of user IDs to include.",
		longDescription: "An array of user IDs to include.",
	},
	exclude: {
		value: "",
		multiple: false,
		id: "exclude",

		label: "Exclude",
		description: "An array of user IDs to exclude.",
		longDescription: "An array of user IDs to exclude.",
	},

	search: {
		value: "",
		multiple: false,
		id: "search",
		label: "Search",
		description:
			"Search keyword. Searches for possible string matches on columns.",
		longDescription:
			"Search keyword. Searches for possible string matches on columns.",
	},
	search_columns: {
		value: "",
		multiple: false,
		id: "search_columns",
		label: "Search Columns",
		description: "Field(s) to sort the retrieved users by.",
		longDescription:
			"Array of column names to be searched. Accepts 'ID', 'user_login', 'user_email', 'user_url', 'user_nicename', 'display_name'.",
	},

	paged: {
		value: "",
		multiple: false,
		id: "paged",

		label: "Paged",
		description:
			"When used with number, defines the page of results to return.",
		longDescription:
			"When used with number, defines the page of results to return. Default 1.",
	},
	count_total: {
		value: "",
		multiple: false,
		id: "count_total",

		label: "Count Total",
		description:
			"Which fields to return. Single or all fields (string), or array of fields.",
		longDescription:
			"Which fields to return. Single or all fields (string), or array of fields.",
	},
	role: {
		value: "",
		multiple: false,
		id: "role",
		label: "Role",
		description:
			"An array or a comma-separated list of role names that users must match to be included in results. Note that this is an inclusive list: users must match *each* role.",
	},
	role__in: {
		value: "",
		multiple: false,
		id: "role__in",
		label: "Role In",
		description:
			"An array of role names. Matched users must have at least one of these roles.",
	},
	role__not_in: {
		value: "",
		multiple: false,
		id: "role__not_in",
		label: "Role Not In",
		description:
			"An array of role names to exclude. Users matching one or more of these roles will not be included in results.",
	},
	blog_id: {
		value: "",
		multiple: false,
		id: "blog_id",
		label: "Blog ID",
		description: "The site ID. Default is the current site.",
	},

	meta_key: {
		value: "",
		multiple: false,
		id: "meta_key",

		label: "Meta key",
		description: "Meta key or keys to filter by.",
		longDescription: "Meta key or keys to filter by.",
	},
	meta_value: {
		value: "",
		multiple: false,
		id: "meta_value",

		label: "Meta Value",
		description: "Meta value or values to filter by.",
		longDescription: "Meta value or values to filter by.",
	},
	meta_type: {
		value: "",
		multiple: false,
		id: "meta_type",

		label: "Meta Type",
		description:
			"MySQL data type that the meta_value column will be CAST to for comparisons.",
		longDescription:
			"MySQL data type that the meta_value column will be CAST to for comparisons.",
	},
	meta_type_key: {
		value: "",
		multiple: false,
		id: "meta_type_key",

		label: "Meta Type Key",
		description:
			"MySQL data type that the meta_key column will be CAST to for comparisons.",
		longDescription:
			"MySQL data type that the meta_key column will be CAST to for comparisons.",
	},
	meta_query: {
		value: "",
		multiple: false,
		id: "meta_query",

		label: "Meta Query",
		description:
			"MySQL data type that the meta_key column will be CAST to for comparisons.",
		longDescription:
			"MySQL data type that the meta_key column will be CAST to for comparisons.",
	},
	capability: {
		value: "",
		multiple: false,
		id: "capability",

		label: "Capability",
		description: "An array or a comma-separated list of capability names.",
		longDescription:
			"An array or a comma-separated list of capability names that users must match to be included in results. Note that this is an inclusive list: users must match *each* capability.",
	},
	capability__in: {
		value: "",
		multiple: false,
		id: "capability__in",

		label: "Capability In",
		description:
			"An array of capability names. Matched users must have at least one of these capabilities.",
		longDescription:
			"An array of capability names. Matched users must have at least one of these capabilities. Does NOT work for capabilities not in the database or filtered via 'map_meta_cap'.",
	},
	capability__not_in: {
		value: "",
		multiple: false,
		id: "capability__not_in",

		label: "Capability Not In",
		description:
			"An array of capability names to exclude. Users matching one or more of these capabilities will not be included in results.",
		longDescription:
			"An array of capability names to exclude. Users matching one or more of these capabilities will not be included in results. Does NOT work for capabilities not in the database or filtered via 'map_meta_cap'.",
	},

	fields: {
		value: "",
		multiple: false,
		id: "fields",

		label: "Fields",
		description: "Whether to count the total number of users found.",
		longDescription:
			"Whether to count the total number of users found. If pagination is not needed, setting this to false can improve performance. Default true.",
	},
	who: {
		value: "",
		multiple: false,
		id: "who",

		label: "Who",
		description: "Deprecated, use $capability instead.",
		longDescription:
			"Deprecated, use $capability instead. Type of users to query. Accepts 'authors'. Default empty (all users).",
	},
	has_published_posts: {
		value: "",
		multiple: false,
		id: "has_published_posts",

		label: "Has Published Posts",
		description:
			"Pass an array of post types to filter results to users who have published posts in those post types.",
		longDescription:
			"Pass an array of post types to filter results to users who have published posts in those post types. true is an alias for all public post types.",
	},
	nicename: {
		value: "",
		multiple: false,
		id: "nicename",

		label: "Nicename",
		description:
			"An array of nicenames to exclude. Users matching one of these nicenames will not be included in results.",
		longDescription:
			"An array of nicenames to exclude. Users matching one of these nicenames will not be included in results.",
	},
	login: {
		value: "",
		multiple: false,
		id: "login",

		label: "Login",
		description: "The user login.",
		longDescription: "The user login.",
	},
	login__in: {
		value: "",
		multiple: false,
		id: "login__in",

		label: "Login In",
		description:
			"An array of logins to include. Users matching one of these logins will be included in results.",
		longDescription:
			"An array of logins to include. Users matching one of these logins will be included in results.",
	},
	login__not_in: {
		value: "",
		multiple: false,
		id: "login__not_in",

		label: "Login Not In",
		description:
			"An array of logins to exclude. Users matching one of these logins will not be included in results.",
		longDescription:
			"An array of logins to exclude. Users matching one of these logins will not be included in results.",
	},
	cache_results: {
		value: "",
		multiple: false,
		id: "cache_results",

		label: "Cache Results",
		description: "Whether to cache user information.",
		longDescription: "Whether to cache user information. Default true.",
	},
};

addFilter(
	"postGridUsersQueryPrams",
	"combo-blocks/usersQuery",
	function (options) {
		return usersQueryPramsPro;
	}
);

var imagesFieldsPro = {

	id: { label: "ID", value: "id" },
	image: { label: "Image", value: "image" },
	title: { label: __("Title", "combo-blocks-pro"), value: "title" },
	caption: { label: __("Caption", "combo-blocks-pro"), value: "caption" },
	description: {
		label: __("Description", "combo-blocks-pro"),
		value: "description",
	},
	link: { label: __("Link", "combo-blocks-pro"), value: "link" },
	filename: {
		label: __("File name", "combo-blocks-pro"),
		value: "filename",
	},
	name: { label: "Slug", value: "name" },
	width: { label: "Width", value: "width" },
	height: { label: "Height", value: "height" },
	custom: {
		label: __("Custom Field", "combo-blocks-pro"),
		value: "custom",
	},
	filesize: {
		label: __("Filesize", "combo-blocks-pro"),
		value: "filesize",
	},
	aperture: { label: "Aperture", value: "aperture" },
	credit: {
		label: __("Credit", "combo-blocks-pro"),
		value: "credit",
	},
	camera: {
		label: __("Camera", "combo-blocks-pro"),
		value: "camera",
	},
	copyright: {
		label: __("Copyright", "combo-blocks-pro"),
		value: "copyright",
	},
	iso: { label: "ISO", value: "iso" },
	shutter_speed: {
		label: "Shutter Speed",
		value: "shutter_speed",
	},
	orientation: {
		label: __("Orientation", "combo-blocks-pro"),
		value: "orientation",
	},
	keywords: {
		label: __("Keywords", "combo-blocks-pro"),
		value: "keywords",
	},
};

addFilter(
	"postGridImagesFieldPrams",
	"combo-blocks/images",
	function (options) {
		return imagesFieldsPro;
	}
);



const animateListArgs = {
	backInDown: { label: __("backInDown", "combo-blocks-pro"), value: "backInDown" },
	backInLeft: { label: __("backInLeft", "combo-blocks-pro"), value: "backInLeft" },
	backInRight: { label: __("backInRight", "combo-blocks-pro"), value: "backInRight" },
	backInUp: { label: __("backInUp", "combo-blocks-pro"), value: "backInUp" },
	bounceIn: { label: __("bounceIn", "combo-blocks-pro"), value: "bounceIn" },
	bounceInDown: {
		label: __("bounceInDown", "combo-blocks-pro"),
		value: "bounceInDown",
	},
	bounceInLeft: {
		label: __("bounceInLeft", "combo-blocks-pro"),
		value: "bounceInLeft",
	},
	bounceInRight: {
		label: __("bounceInRight", "combo-blocks-pro"),
		value: "bounceInRight",
	},
	bounceInUp: { label: __("bounceInUp", "combo-blocks-pro"), value: "bounceInUp" },
	fadeIn: { label: __("fadeIn", "combo-blocks-pro"), value: "fadeIn" },
	fadeInDown: { label: __("fadeInDown", "combo-blocks-pro"), value: "fadeInDown" },
	fadeInDownBig: {
		label: __("fadeInDownBig", "combo-blocks-pro"),
		value: "fadeInDownBig",
	},
	fadeInLeft: { label: __("fadeInLeft", "combo-blocks-pro"), value: "fadeInLeft" },
	fadeInLeftBig: {
		label: __("fadeInLeftBig", "combo-blocks-pro"),
		value: "fadeInLeftBig",
	},
	fadeInRight: { label: __("fadeInRight", "combo-blocks-pro"), value: "fadeInRight" },
	fadeInRightBig: {
		label: __("fadeInRightBig", "combo-blocks-pro"),
		value: "fadeInRightBig",
	},
	fadeInUp: { label: __("fadeInUp", "combo-blocks-pro"), value: "fadeInUp" },
	fadeInUpBig: { label: __("fadeInUpBig", "combo-blocks-pro"), value: "fadeInUpBig" },
	fadeInTopLeft: {
		label: __("fadeInTopLeft", "combo-blocks-pro"),
		value: "fadeInTopLeft",
	},
	fadeInTopRight: {
		label: __("fadeInTopRight", "combo-blocks-pro"),
		value: "fadeInTopRight",
	},
	fadeInBottomRight: {
		label: __("fadeInBottomRight", "combo-blocks-pro"),
		value: "fadeInBottomRight",
	},
	fadeInBottomLeft: {
		label: __("fadeInBottomLeft", "combo-blocks-pro"),
		value: "fadeInBottomLeft",
	},
	rotateIn: { label: __("rotateIn", "combo-blocks-pro"), value: "rotateIn" },
	rotateInDownLeft: {
		label: __("rotateInDownLeft", "combo-blocks-pro"),
		value: "rotateInDownLeft",
	},
	rotateInDownRight: {
		label: __("rotateInDownRight", "combo-blocks-pro"),
		value: "rotateInDownRight",
	},
	rotateInUpLeft: {
		label: __("rotateInUpLeft", "combo-blocks-pro"),
		value: "rotateInUpLeft",
	},
	rotateInUpRight: {
		label: __("rotateInUpRight", "combo-blocks-pro"),
		value: "rotateInUpRight",
	},
	zoomIn: { label: __("zoomIn", "combo-blocks-pro"), value: "zoomIn" },
	zoomInDown: { label: __("zoomInDown", "combo-blocks-pro"), value: "zoomInDown" },
	zoomInLeft: { label: __("zoomInLeft", "combo-blocks-pro"), value: "zoomInLeft" },
	zoomInRight: { label: __("zoomInRight", "combo-blocks-pro"), value: "zoomInRight" },
	zoomInUp: { label: __("zoomInUp", "combo-blocks-pro"), value: "zoomInUp" },
	slideInDown: { label: __("slideInDown", "combo-blocks-pro"), value: "slideInDown" },
	slideInLeft: { label: __("slideInLeft", "combo-blocks-pro"), value: "slideInLeft" },
	slideInRight: {
		label: __("slideInRight", "combo-blocks-pro"),
		value: "slideInRight",
	},
	slideInUp: { label: __("slideInUp", "combo-blocks-pro"), value: "slideInUp" },
	backOutDown: { label: __("backOutDown", "combo-blocks-pro"), value: "backOutDown" },
	backOutLeft: { label: __("backOutLeft", "combo-blocks-pro"), value: "backOutLeft" },
	backOutRight: {
		label: __("backOutRight", "combo-blocks-pro"),
		value: "backOutRight",
	},
	backOutUp: { label: __("backOutUp", "combo-blocks-pro"), value: "backOutUp" },
	bounceOut: { label: __("bounceOut", "combo-blocks-pro"), value: "bounceOut" },
	bounceOutDown: {
		label: __("bounceOutDown", "combo-blocks-pro"),
		value: "bounceOutDown",
	},
	bounceOutLeft: {
		label: __("bounceOutLeft", "combo-blocks-pro"),
		value: "bounceOutLeft",
	},
	bounceOutRight: {
		label: __("bounceOutRight", "combo-blocks-pro"),
		value: "bounceOutRight",
	},
	bounceOutUp: { label: __("bounceOutUp", "combo-blocks-pro"), value: "bounceOutUp" },
	fadeOut: { label: __("fadeOut", "combo-blocks-pro"), value: "fadeOut" },
	fadeOutDown: { label: __("fadeOutDown", "combo-blocks-pro"), value: "fadeOutDown" },
	fadeOutDownBig: {
		label: __("fadeOutDownBig", "combo-blocks-pro"),
		value: "fadeOutDownBig",
	},
	fadeOutLeft: { label: __("fadeOutLeft", "combo-blocks-pro"), value: "fadeOutLeft" },
	fadeOutLeftBig: {
		label: __("fadeOutLeftBig", "combo-blocks-pro"),
		value: "fadeOutLeftBig",
	},
	fadeOutRight: {
		label: __("fadeOutRight", "combo-blocks-pro"),
		value: "fadeOutRight",
	},
	fadeOutRightBig: {
		label: __("fadeOutRightBig", "combo-blocks-pro"),
		value: "fadeOutRightBig",
	},
	fadeOutUp: { label: __("fadeOutUp", "combo-blocks-pro"), value: "fadeOutUp" },
	fadeOutUpBig: {
		label: __("fadeOutUpBig", "combo-blocks-pro"),
		value: "fadeOutUpBig",
	},
	fadeOutTopLeft: {
		label: __("fadeOutTopLeft", "combo-blocks-pro"),
		value: "fadeOutTopLeft",
	},
	fadeOutTopRight: {
		label: __("fadeOutTopRight", "combo-blocks-pro"),
		value: "fadeOutTopRight",
	},
	fadeOutBottomRight: {
		label: __("fadeOutBottomRight", "combo-blocks-pro"),
		value: "fadeOutBottomRight",
	},
	fadeOutBottomLeft: {
		label: __("fadeOutBottomLeft", "combo-blocks-pro"),
		value: "fadeOutBottomLeft",
	},
	rotateOut: { label: __("rotateOut", "combo-blocks-pro"), value: "rotateOut" },
	rotateOutDownLeft: {
		label: __("rotateOutDownLeft", "combo-blocks-pro"),
		value: "rotateOutDownLeft",
	},
	rotateOutDownRight: {
		label: __("rotateOutDownRight", "combo-blocks-pro"),
		value: "rotateOutDownRight",
	},
	rotateOutUpLeft: {
		label: __("rotateOutUpLeft", "combo-blocks-pro"),
		value: "rotateOutUpLeft",
	},
	rotateOutUpRight: {
		label: __("rotateOutUpRight", "combo-blocks-pro"),
		value: "rotateOutUpRight",
	},
	zoomOut: { label: __("zoomOut", "combo-blocks-pro"), value: "zoomOut" },
	zoomOutDown: { label: __("zoomOutDown", "combo-blocks-pro"), value: "zoomOutDown" },
	zoomOutLeft: { label: __("zoomOutLeft", "combo-blocks-pro"), value: "zoomOutLeft" },
	zoomOutRight: {
		label: __("zoomOutRight", "combo-blocks-pro"),
		value: "zoomOutRight",
	},
	zoomOutUp: { label: __("zoomOutUp", "combo-blocks-pro"), value: "zoomOutUp" },
	slideOutDown: {
		label: __("slideOutDown", "combo-blocks-pro"),
		value: "slideOutDown",
	},
	slideOutLeft: {
		label: __("slideOutLeft", "combo-blocks-pro"),
		value: "slideOutLeft",
	},
	slideOutRight: {
		label: __("slideOutRight", "combo-blocks-pro"),
		value: "slideOutRight",
	},
	slideOutUp: { label: __("slideOutUp", "combo-blocks-pro"), value: "slideOutUp" },
};


addFilter(
	"postGridComponentAnimateOn",
	"combo-blocks/animate-on",
	function (options) {
		return animateListArgs;
	}
);



const linkElementsArgsPro = [


	{
		id: 'text', label: 'Text', customText: 'You are here: ', url: '',

		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			text: 'You are here: ',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},


	{
		id: 'homePage', label: 'Home Page Link', customText: '%s', url: '',

		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},

	{
		id: 'frontPage', label: 'Front Page Link', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},

	{
		id: 'postsPage', label: 'Posts Page Link', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},

	{
		id: 'postTitle', label: 'Post Title', customText: '%s', url: '',

		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postAuthor', label: 'Post Author', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},


	{
		id: 'postDate', label: 'Post Date', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			format: 'Y-m-d',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postDay', label: 'Post Day', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			format: '',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postMonth', label: 'Post Month', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			format: '',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},

	{
		id: 'postYear', label: 'Post Year', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			format: '',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postAncestors', label: 'Post Ancestors', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
			count: '',
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postId', label: 'Post Id', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postCategory', label: 'Post Category', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postTag', label: 'Post Tag', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},
	{
		id: 'postCategories', label: 'Post Categories', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
			maxCount: 3,

		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'postTags', label: 'Post Tags', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
			maxCount: 3,

		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},


	{
		id: 'postTerm', label: 'Post Term', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			taxonomy: '',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},

	{
		id: 'postTerms', label: 'Post Terms', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			taxonomy: '',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},




	{
		id: 'termTitle', label: 'Term Title', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'termParents', label: 'Term Parents', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
			count: 0,

		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},
	{
		id: 'termAncestors', label: 'Term Ancestors', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			taxonomy: '',
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},

	},


	{
		id: 'wcShop', label: 'WooCommerce Shop', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},
	{
		id: 'wcAccount', label: 'WooCommerce Account', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},
	{
		id: 'wcCart', label: 'WooCommerce Cart', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},
	{
		id: 'wcCheckout', label: 'WooCommerce Checkout', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},


	{
		id: 'searchText', label: 'Search Text', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},

	{
		id: 'archiveTitle', label: 'Archive Title', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},

	{
		id: '404Text', label: '404 Text', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},


	{
		id: 'dateText', label: 'Date Text', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
			format: 'Y-m-d',
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},
	{
		id: 'monthText', label: 'Month Text', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
			format: 'Y-m',
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},

	{
		id: 'yearText', label: 'Year Text', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
			format: 'Y',
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},

	{
		id: 'authorName', label: 'Author Name', customText: '%s', url: '',
		siteIcon: { library: 'fontAwesome', srcType: "class", /*class, html, img, svg */ iconSrc: '', },
		options: {
			showSeparator: true,
		},
		styles: {
			textAlign: {},
			color: {},
			bgColor: {},
			padding: {},
			margin: {},
			display: {},
		},
	},





];

addFilter('linkElementsArgs', 'combo-blocks/linkElementsArgs', function (options) {

	return linkElementsArgsPro;
});



const metaKeyTypeArgsPro = {
	string: { label: "String", value: "string" },
	object: { label: "Object", value: "object" },
	array: { label: "Array", value: "array" },

	// acfText: { label: "ACF Text", value: "acfText",  },
	// acfTextarea: { label: "ACF Textarea", value: "acfTextarea",  },
	// acfNumber: { label: "ACF Number", value: "acfNumber",  },
	// acfRange: { label: "ACF Range", value: "acfRange",  },
	// acfEmail: { label: "ACF Email", value: "acfEmail",  },
	// acfUrl: { label: "ACF URL", value: "acfUrl",  },
	// acfPassword: { label: "ACF Password", value: "acfPassword",  },
	//acfWysiwyg: { label: 'ACF WYSIWYG', value: 'acfWysiwyg',  },

	acfSelect: { label: "ACF Select", value: "acfSelect" },
	acfCheckbox: { label: "ACF Checkbox", value: "acfCheckbox" },
	acfRadio: { label: "ACF Radio", value: "acfRadio" },

	acfImage: { label: "ACF Image", value: "acfImage" },
	acfFile: { label: "ACF File", value: "acfFile" },
	acfTaxonomy: { label: "ACF Taxonomy", value: "acfTaxonomy" },
	acfPostObject: {
		label: "ACF Post Object",
		value: "acfPostObject",
	},
	acfPageLink: {
		label: "ACF Page Link",
		value: "acfPageLink",
	},
	acfLink: { label: "ACF Link", value: "acfLink" },
	acfUser: { label: "ACF User", value: "acfUser" },
	acfButtonGroup: {
		label: "ACF Button Group",
		value: "acfButtonGroup",
	},
	acfDateTime: {
		label: "ACF Date Time",
		value: "acfDateTime",
	},
	// acfBoolen: { label: 'ACF Boolen', value: 'acfBoolen',  },
	// acfTimePicker: { label: 'ACF TimePicker', value: 'acfTimePicker',  },
	// acfDatePicker: { label: 'ACF DatePicker', value: 'acfDatePicker',  },
	// acfDateTimePicker: { label: 'ACF DateTimePicker', value: 'acfDateTimePicker',  },
	// acfColorPicker: { label: 'ACF ColorPicker', value: 'acfColorPicker',  },
	// acfGoogleMap: { label: 'ACF Google Map', value: 'acfGoogleMap',  },
	// podsText: {
	// 	label: "Pods Text",
	// 	value: "podsText",
	// },
	podsFile: {
		label: "Pods File",
		value: "podsFile",
	},
	podsImage: {
		label: "Pods Image",
		value: "podsImage",
	},
	podsSelect: {
		label: "Pods Select",
		value: "podsSelect",
	},
	podsCheckbox: {
		label: "Pods Checkbox",
		value: "podsCheckbox",
	},
	podsRadio: {
		label: "Pods Radio",
		value: "podsRadio",
	},
	podsButtonGroup: {
		label: "Pods Button Group",
		value: "podsButtonGroup",
	},
	podsLink: {
		label: "Pods Link",
		value: "podsLink",
	},
	podsTaxonomy: {
		label: "Pods Taxonomy",
		value: "podsTaxonomy",
	},
	podsUser: {
		label: "Pods User",
		value: "podsUser",
	},
	podsDatePicker: {
		label: "Pods DatePicker",
		value: "podsDatePicker",
	},
	podsTimePicker: {
		label: "Pods TimePicker",
		value: "podsTimePicker",
	},
	podsDateTimePicker: {
		label: "Pods DateTimePicker",
		value: "podsDateTimePicker",
	},
	// podsGoogleMap: {
	// 	label: "Pods GoogleMap",
	// 	value: "podsGoogleMap",
	//
	// },
	// podsColorPicker: {
	// 	label: "Pods ColorPicker",
	// 	value: "podsColorPicker",
	//
	// },
	podsPostObject: {
		label: "Pods Post Object",
		value: "podsPostObject",
	},
	// podsOEmbed: {
	// 	label: "Pods OEmbed",
	// 	value: "podsOEmbed",
	//
	// },
	// podsPassword: {
	// 	label: "Pods Password",
	// 	value: "podsPassword",
	//
	// },
	podsRelationship: {
		label: "Pods Relationship",
		value: "podsRelationship",
	},
	podsTrueFalse: {
		label: "Pods True False",
		value: "podsTrueFalse",
	},
	mbTaxonomy: {
		label: "MB Taxonomy",
		value: "mbTaxonomy",
	},
	mbButton: {
		label: "MB Button",
		value: "mbButton",
	},
	mbSelect: {
		label: "MB Select",
		value: "mbSelect",
	},
	mbSelectAdvanced: {
		label: "MB Select Advanced",
		value: "mbSelectAdvanced",
	},
	mbCheckbox: {
		label: "MB Checkbox",
		value: "mbCheckbox",
	},
	mbCheckboxList: {
		label: "MB Checkbox List",
		value: "mbCheckboxList",
	},
	mbRadio: {
		label: "MB Radio",
		value: "mbRadio",
	},
	mbDate: {
		label: "MB Date",
		value: "mbDate",
	},
	mbDateTime: {
		label: "MB Date Time",
		value: "mbDateTime",
	},
	mbTime: {
		label: "MB Time",
		value: "mbTime",
	},
	mbPost: {
		label: "MB Post",
		value: "mbPost",
	},
	mbWPTaxonomy: {
		label: "MB WPTaxonomy",
		value: "mbWPTaxonomy",
	},
	mbWPTaxonomyAdvanced: {
		label: "MB WPTaxonomy Advanced",
		value: "mbWPTaxonomyAdvanced",
	},
	mbUser: {
		label: "MB User",
		value: "mbUser",
	},
	cfsTaxonomy: {
		label: "CFS Taxonomy",
		value: "cfsTaxonomy",
	},
	cfsSelect: {
		label: "CFS Select",
		value: "cfsSelect",
	},
	cfsFileUpload: {
		label: "CFS File Upload",
		value: "cfsFileUpload",
	},
	cfsRelationship: {
		label: "CFS Relationship",
		value: "cfsRelationship",
	},
	cfsTerm: {
		label: "CFS Term",
		value: "cfsTerm",
	},
	cfsUser: {
		label: "CFS User",
		value: "cfsUser",
	},
};

addFilter(
	"metaKeyTypeArgsFilter",
	"combo-blocks/metaKeyTypeArgs",
	function (options) {
		return metaKeyTypeArgsPro;
	}
);

/*

link To Arguments
*/

const limitByArgsPro = {
	none: { label: "Choose..", value: "" },
	word: { label: "Word", value: "word" },
	character: { label: "Character", value: "character" },
};

addFilter(
	"limitByArgs",
	"combo-blocks/post-title/limitByArgs",
	function (options) {
		return limitByArgsPro;
	}
);



let imageFilterArgsPro = [

	{ label: 'Blur', value: 'blur', val: '', unit: 'px' },
	{ label: 'Brightness', value: 'brightness', val: '10', unit: '%' },
	{ label: 'Contrast', value: 'contrast', val: '10', unit: '%' },
	{ label: 'Grayscale', value: 'grayscale', val: '10', unit: '%' },
	{ label: 'Hue-rotate', value: 'hue-rotate', val: '10', unit: 'deg' },
	{ label: 'Invert', value: 'invert', val: '10', unit: '%' },
	{ label: 'Opacity', value: 'opacity', val: '10', unit: '%' },
	{ label: 'Saturate', value: 'saturate', val: '10', unit: '%' },
	{ label: 'Sepia', value: 'sepia', val: '10', unit: '%' },

];

addFilter('imageFilterArgs', 'combo-blocks/imageFilterArgs', function (options) {

	return imageFilterArgsPro;
});



const excerptSourceArgsPro = {
	auto: { label: 'Auto', value: 'auto' },
	excerpt: { label: 'Excerpt', value: 'excerpt' },
	content: { label: 'Content', value: 'content' },
	meta: { label: 'Custom Fields', value: 'meta' },
};

addFilter('excerptSourceArgs', 'combo-blocks/post-title/excerptSourceArgs', function (options) {

	return excerptSourceArgsPro;
});


const paginationTypesPro = {
	none: { label: "None", value: "none" },
	normal: { label: "Normal Pagination", value: "normal" },
	ajax: { label: "Ajax Pagination", value: "ajax" },
	next_previous: { label: "Next-Previous", value: "next_previous" },
	loadmore: { label: "Load More", value: "loadmore" },
	infinite: { label: "Infinite Load", value: "infinite" },
	filterable: { label: "Filterable", value: "filterable" },
};

addFilter("paginationTypes", "combo-blocks/paginationTypes", function (options) {
	return paginationTypesPro;
});



const gridLayoutsPro = [
	{
		thumb: "",
		title: "3 Col, 0 Gap",
		data: {
			options: {
				gridTemplateColumns: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				gridTemplateRows: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				colGap: { val: 1, unit: "em" },
				rowGap: { val: 1, unit: "em" },
				itemCss: [],
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: "1", unit: "fr" },
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: "0", unit: "em" },
					Mobile: { val: "0", unit: "em" },
					Tablet: { val: "0", unit: "em" },
				},
				rowGap: {
					Desktop: { val: "0", unit: "em" },
					Mobile: { val: "0", unit: "em" },
					Tablet: { val: "0", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},
		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect x="11.5" y="14.5" width="73.3231" height="91" stroke="black" />
				<path
					d="M25.0611 73.9162C25.0611 72.5868 26.1387 71.5092 27.468 71.5092H69.1885C70.5178 71.5092 71.5954 72.5868 71.5954 73.9162V73.9162C71.5954 75.2455 70.5178 76.3231 69.1885 76.3231H27.468C26.1387 76.3231 25.0611 75.2455 25.0611 73.9162V73.9162Z"
					fill="black"
				/>
				<path
					d="M25.0611 81.6184C25.0611 80.2891 26.1387 79.2115 27.468 79.2115H69.1885C70.5178 79.2115 71.5954 80.2891 71.5954 81.6184V81.6184C71.5954 82.9477 70.5178 84.0254 69.1885 84.0254H27.468C26.1387 84.0254 25.0611 82.9477 25.0611 81.6184V81.6184Z"
					fill="black"
				/>
				<path
					d="M25.0611 89.3206C25.0611 87.9913 26.1387 86.9137 27.468 86.9137H55.7663C57.0956 86.9137 58.1732 87.9913 58.1732 89.3206V89.3206C58.1732 90.65 57.0956 91.7276 55.7663 91.7276H27.468C26.1387 91.7276 25.0611 90.65 25.0611 89.3206V89.3206Z"
					fill="black"
				/>
				<path
					d="M20.2402 21.2314V65.1079H76.083V21.2314H20.2402ZM24.2289 25.2202H72.0942V52.9546L61.5613 42.3595L60.1279 40.926L51.0908 49.9631L39.6231 38.3707L38.1896 36.9372L24.2289 50.8979V25.2202ZM64.1167 29.209C61.9119 29.209 60.1279 30.993 60.1279 33.1978C60.1279 35.4025 61.9119 37.1865 64.1167 37.1865C66.3214 37.1865 68.1054 35.4025 68.1054 33.1978C68.1054 30.993 66.3214 29.209 64.1167 29.209ZM38.1896 42.6088L56.5131 61.1192H24.2289V56.5695L38.1896 42.6088ZM60.1279 46.5975L72.0942 58.5638V61.1192H62.1846L53.8954 52.7677L60.1279 46.5975Z"
					fill="black"
				/>
				<rect x="85.4359" y="14.5" width="73.3231" height="91" stroke="black" />
				<path
					d="M98.9971 73.9162C98.9971 72.5868 100.075 71.5092 101.404 71.5092H143.124C144.454 71.5092 145.531 72.5868 145.531 73.9162V73.9162C145.531 75.2455 144.454 76.3231 143.124 76.3231H101.404C100.075 76.3231 98.9971 75.2455 98.9971 73.9162V73.9162Z"
					fill="black"
				/>
				<path
					d="M98.9971 81.6184C98.9971 80.2891 100.075 79.2115 101.404 79.2115H143.124C144.454 79.2115 145.531 80.2891 145.531 81.6184V81.6184C145.531 82.9477 144.454 84.0254 143.124 84.0254H101.404C100.075 84.0254 98.9971 82.9477 98.9971 81.6184V81.6184Z"
					fill="black"
				/>
				<path
					d="M98.9971 89.3206C98.9971 87.9913 100.075 86.9137 101.404 86.9137H129.702C131.032 86.9137 132.109 87.9913 132.109 89.3206V89.3206C132.109 90.65 131.032 91.7276 129.702 91.7276H101.404C100.075 91.7276 98.9971 90.65 98.9971 89.3206V89.3206Z"
					fill="black"
				/>
				<path
					d="M94.1761 21.2314V65.1079H150.019V21.2314H94.1761ZM98.1649 25.2202H146.03V52.9546L135.497 42.3595L134.064 40.926L125.027 49.9631L113.559 38.3707L112.126 36.9372L98.1649 50.8979V25.2202ZM138.053 29.209C135.848 29.209 134.064 30.993 134.064 33.1978C134.064 35.4025 135.848 37.1865 138.053 37.1865C140.257 37.1865 142.041 35.4025 142.041 33.1978C142.041 30.993 140.257 29.209 138.053 29.209ZM112.126 42.6088L130.449 61.1192H98.1649V56.5695L112.126 42.6088ZM134.064 46.5975L146.03 58.5638V61.1192H136.121L127.831 52.7677L134.064 46.5975Z"
					fill="black"
				/>
				<rect x="159.372" y="14.5" width="73.3231" height="91" stroke="black" />
				<path
					d="M172.933 73.9162C172.933 72.5868 174.01 71.5092 175.34 71.5092H217.06C218.39 71.5092 219.467 72.5868 219.467 73.9162V73.9162C219.467 75.2455 218.39 76.3231 217.06 76.3231H175.34C174.01 76.3231 172.933 75.2455 172.933 73.9162V73.9162Z"
					fill="black"
				/>
				<path
					d="M172.933 81.6184C172.933 80.2891 174.01 79.2115 175.34 79.2115H217.06C218.39 79.2115 219.467 80.2891 219.467 81.6184V81.6184C219.467 82.9477 218.39 84.0254 217.06 84.0254H175.34C174.01 84.0254 172.933 82.9477 172.933 81.6184V81.6184Z"
					fill="black"
				/>
				<path
					d="M172.933 89.3206C172.933 87.9913 174.01 86.9137 175.34 86.9137H203.638C204.967 86.9137 206.045 87.9913 206.045 89.3206V89.3206C206.045 90.65 204.967 91.7276 203.638 91.7276H175.34C174.01 91.7276 172.933 90.65 172.933 89.3206V89.3206Z"
					fill="black"
				/>
				<path
					d="M168.112 21.2314V65.1079H223.955V21.2314H168.112ZM172.101 25.2202H219.966V52.9546L209.433 42.3595L208 40.926L198.963 49.9631L187.495 38.3707L186.061 36.9372L172.101 50.8979V25.2202ZM211.988 29.209C209.784 29.209 208 30.993 208 33.1978C208 35.4025 209.784 37.1865 211.988 37.1865C214.193 37.1865 215.977 35.4025 215.977 33.1978C215.977 30.993 214.193 29.209 211.988 29.209ZM186.061 42.6088L204.385 61.1192H172.101V56.5695L186.061 42.6088ZM208 46.5975L219.966 58.5638V61.1192H210.056L201.767 52.7677L208 46.5975Z"
					fill="black"
				/>
			</svg>
		),
	},

	{
		title: "3 Col 1 Gap",
		data: {
			options: {
				gridTemplateColumns: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				gridTemplateRows: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				colGap: { val: 1, unit: "em" },
				rowGap: { val: 1, unit: "em" },
				itemCss: [],
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: "1", unit: "fr" },
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: "1", unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				rowGap: {
					Desktop: { val: "1", unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},

		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect x="12.5" y="16.5" width="70.0917" height="87" stroke="black" />
				<path
					d="M25.4498 73.3111C25.4498 72.0396 26.4805 71.0089 27.7521 71.0089H67.6586C68.9301 71.0089 69.9608 72.0396 69.9608 73.3111V73.3111C69.9608 74.5827 68.9301 75.6134 67.6585 75.6134H27.7521C26.4805 75.6134 25.4498 74.5827 25.4498 73.3111V73.3111Z"
					fill="black"
				/>
				<path
					d="M25.4498 80.6785C25.4498 79.407 26.4805 78.3762 27.7521 78.3762H67.6586C68.9301 78.3762 69.9608 79.407 69.9608 80.6785V80.6785C69.9608 81.95 68.9301 82.9808 67.6585 82.9808H27.7521C26.4805 82.9808 25.4498 81.95 25.4498 80.6785V80.6785Z"
					fill="black"
				/>
				<path
					d="M25.4498 88.0458C25.4498 86.7743 26.4805 85.7435 27.7521 85.7435H54.8199C56.0915 85.7435 57.1222 86.7743 57.1222 88.0458V88.0458C57.1222 89.3174 56.0915 90.3481 54.8199 90.3481H27.7521C26.4805 90.3481 25.4498 89.3174 25.4498 88.0458V88.0458Z"
					fill="black"
				/>
				<path
					d="M20.8384 22.917V64.8858H74.2533V22.917H20.8384ZM24.6538 26.7324H70.4379V53.2609L60.363 43.1264L58.9919 41.7553L50.3478 50.3994L39.3786 39.3111L38.0075 37.9399L24.6538 51.2937V26.7324ZM62.8072 30.5477C60.6984 30.5477 58.9919 32.2542 58.9919 34.3631C58.9919 36.4719 60.6984 38.1784 62.8072 38.1784C64.9161 38.1784 66.6226 36.4719 66.6226 34.3631C66.6226 32.2542 64.9161 30.5477 62.8072 30.5477ZM38.0075 43.3649L55.5342 61.0705H24.6538V56.7186L38.0075 43.3649ZM58.9919 47.1802L70.4379 58.6263V61.0705H60.9592L53.0304 53.0821L58.9919 47.1802Z"
					fill="black"
				/>
				<rect x="87.4345" y="16.5" width="70.0917" height="87" stroke="black" />
				<path
					d="M100.384 73.3111C100.384 72.0396 101.415 71.0089 102.687 71.0089H142.593C143.865 71.0089 144.895 72.0396 144.895 73.3111V73.3111C144.895 74.5827 143.865 75.6134 142.593 75.6134H102.687C101.415 75.6134 100.384 74.5827 100.384 73.3111V73.3111Z"
					fill="black"
				/>
				<path
					d="M100.384 80.6785C100.384 79.407 101.415 78.3762 102.687 78.3762H142.593C143.865 78.3762 144.895 79.407 144.895 80.6785V80.6785C144.895 81.95 143.865 82.9808 142.593 82.9808H102.687C101.415 82.9808 100.384 81.95 100.384 80.6785V80.6785Z"
					fill="black"
				/>
				<path
					d="M100.384 88.0458C100.384 86.7743 101.415 85.7435 102.687 85.7435H129.754C131.026 85.7435 132.057 86.7743 132.057 88.0458V88.0458C132.057 89.3174 131.026 90.3481 129.754 90.3481H102.687C101.415 90.3481 100.384 89.3174 100.384 88.0458V88.0458Z"
					fill="black"
				/>
				<path
					d="M95.7729 22.917V64.8858H149.188V22.917H95.7729ZM99.5883 26.7324H145.372V53.2609L135.298 43.1264L133.926 41.7553L125.282 50.3994L114.313 39.3111L112.942 37.9399L99.5883 51.2937V26.7324ZM137.742 30.5477C135.633 30.5477 133.926 32.2542 133.926 34.3631C133.926 36.4719 135.633 38.1784 137.742 38.1784C139.851 38.1784 141.557 36.4719 141.557 34.3631C141.557 32.2542 139.851 30.5477 137.742 30.5477ZM112.942 43.3649L130.469 61.0705H99.5883V56.7186L112.942 43.3649ZM133.926 47.1802L145.372 58.6263V61.0705H135.894L127.965 53.0821L133.926 47.1802Z"
					fill="black"
				/>
				<rect x="162.369" y="16.5" width="70.0917" height="87" stroke="black" />
				<path
					d="M175.319 73.3111C175.319 72.0396 176.35 71.0089 177.621 71.0089H217.528C218.799 71.0089 219.83 72.0396 219.83 73.3111V73.3111C219.83 74.5827 218.799 75.6134 217.528 75.6134H177.621C176.35 75.6134 175.319 74.5827 175.319 73.3111V73.3111Z"
					fill="black"
				/>
				<path
					d="M175.319 80.6785C175.319 79.407 176.35 78.3762 177.621 78.3762H217.528C218.799 78.3762 219.83 79.407 219.83 80.6785V80.6785C219.83 81.95 218.799 82.9808 217.528 82.9808H177.621C176.35 82.9808 175.319 81.95 175.319 80.6785V80.6785Z"
					fill="black"
				/>
				<path
					d="M175.319 88.0458C175.319 86.7743 176.35 85.7435 177.621 85.7435H204.689C205.96 85.7435 206.991 86.7743 206.991 88.0458V88.0458C206.991 89.3174 205.96 90.3481 204.689 90.3481H177.621C176.35 90.3481 175.319 89.3174 175.319 88.0458V88.0458Z"
					fill="black"
				/>
				<path
					d="M170.707 22.917V64.8858H224.122V22.917H170.707ZM174.523 26.7324H220.307V53.2609L210.232 43.1264L208.861 41.7553L200.217 50.3994L189.248 39.3111L187.877 37.9399L174.523 51.2937V26.7324ZM212.676 30.5477C210.567 30.5477 208.861 32.2542 208.861 34.3631C208.861 36.4719 210.567 38.1784 212.676 38.1784C214.785 38.1784 216.492 36.4719 216.492 34.3631C216.492 32.2542 214.785 30.5477 212.676 30.5477ZM187.877 43.3649L205.403 61.0705H174.523V56.7186L187.877 43.3649ZM208.861 47.1802L220.307 58.6263V61.0705H210.828L202.899 53.0821L208.861 47.1802Z"
					fill="black"
				/>
			</svg>
		),
	},

	{
		title: "3 Col 2 Gap",
		data: {
			options: {
				gridTemplateColumns: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				gridTemplateRows: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				colGap: { val: 1, unit: "em" },
				rowGap: { val: 1, unit: "em" },
				itemCss: [],
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: "1", unit: "fr" },
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: "2", unit: "em" },
					Tablet: { val: "2", unit: "em" },
					Mobile: { val: "2", unit: "em" },
				},
				rowGap: {
					Desktop: { val: "2", unit: "em" },
					Tablet: { val: "2", unit: "em" },
					Mobile: { val: "2", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},

		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect x="13.5" y="19.5" width="66.0524" height="82" stroke="black" />
				<path
					d="M25.6855 73.0548C25.6855 71.8555 26.6578 70.8833 27.857 70.8833H65.4961C66.6954 70.8833 67.6676 71.8555 67.6676 73.0548V73.0548C67.6676 74.2541 66.6954 75.2263 65.4961 75.2263H27.857C26.6578 75.2263 25.6855 74.2541 25.6855 73.0548V73.0548Z"
					fill="black"
				/>
				<path
					d="M25.6855 80.0035C25.6855 78.8043 26.6578 77.8321 27.857 77.8321H65.4961C66.6954 77.8321 67.6676 78.8043 67.6676 80.0035V80.0035C67.6676 81.2028 66.6954 82.175 65.4961 82.175H27.857C26.6578 82.175 25.6855 81.2028 25.6855 80.0035V80.0035Z"
					fill="black"
				/>
				<path
					d="M25.6855 86.9523C25.6855 85.7531 26.6578 84.7809 27.857 84.7809H53.387C54.5862 84.7809 55.5584 85.7531 55.5584 86.9523V86.9523C55.5584 88.1516 54.5862 89.1238 53.387 89.1238H27.857C26.6578 89.1238 25.6855 88.1516 25.6855 86.9523V86.9523Z"
					fill="black"
				/>
				<path
					d="M21.3362 25.524V65.1083H71.7162V25.524H21.3362ZM24.9348 29.1226H68.1176V54.1439L58.6151 44.5852L57.3219 43.292L49.1689 51.445L38.823 40.9866L37.5298 39.6934L24.9348 52.2884V29.1226ZM60.9205 32.7212C58.9314 32.7212 57.3219 34.3307 57.3219 36.3197C57.3219 38.3088 58.9314 39.9183 60.9205 39.9183C62.9095 39.9183 64.519 38.3088 64.519 36.3197C64.519 34.3307 62.9095 32.7212 60.9205 32.7212ZM37.5298 44.8101L54.0607 61.5097H24.9348V57.4051L37.5298 44.8101ZM57.3219 48.4087L68.1176 59.2044V61.5097H59.1774L51.6991 53.9752L57.3219 48.4087Z"
					fill="black"
				/>
				<rect x="89.4753" y="19.5" width="66.0524" height="82" stroke="black" />
				<path
					d="M101.661 73.0548C101.661 71.8555 102.633 70.8833 103.832 70.8833H141.471C142.671 70.8833 143.643 71.8555 143.643 73.0548V73.0548C143.643 74.2541 142.671 75.2263 141.471 75.2263H103.832C102.633 75.2263 101.661 74.2541 101.661 73.0548V73.0548Z"
					fill="black"
				/>
				<path
					d="M101.661 80.0035C101.661 78.8043 102.633 77.8321 103.832 77.8321H141.471C142.671 77.8321 143.643 78.8043 143.643 80.0035V80.0035C143.643 81.2028 142.671 82.175 141.471 82.175H103.832C102.633 82.175 101.661 81.2028 101.661 80.0035V80.0035Z"
					fill="black"
				/>
				<path
					d="M101.661 86.9523C101.661 85.7531 102.633 84.7809 103.832 84.7809H129.362C130.562 84.7809 131.534 85.7531 131.534 86.9523V86.9523C131.534 88.1516 130.562 89.1238 129.362 89.1238H103.832C102.633 89.1238 101.661 88.1516 101.661 86.9523V86.9523Z"
					fill="black"
				/>
				<path
					d="M97.3116 25.524V65.1083H147.692V25.524H97.3116ZM100.91 29.1226H144.093V54.1439L134.59 44.5852L133.297 43.292L125.144 51.445L114.798 40.9866L113.505 39.6934L100.91 52.2884V29.1226ZM136.896 32.7212C134.907 32.7212 133.297 34.3307 133.297 36.3197C133.297 38.3088 134.907 39.9183 136.896 39.9183C138.885 39.9183 140.494 38.3088 140.494 36.3197C140.494 34.3307 138.885 32.7212 136.896 32.7212ZM113.505 44.8101L130.036 61.5097H100.91V57.4051L113.505 44.8101ZM133.297 48.4087L144.093 59.2044V61.5097H135.153L127.674 53.9752L133.297 48.4087Z"
					fill="black"
				/>
				<rect x="165.389" y="19.5" width="66.0524" height="82" stroke="black" />
				<path
					d="M177.575 73.0548C177.575 71.8555 178.547 70.8833 179.746 70.8833H217.385C218.585 70.8833 219.557 71.8555 219.557 73.0548V73.0548C219.557 74.2541 218.585 75.2263 217.385 75.2263H179.746C178.547 75.2263 177.575 74.2541 177.575 73.0548V73.0548Z"
					fill="black"
				/>
				<path
					d="M177.575 80.0035C177.575 78.8043 178.547 77.8321 179.746 77.8321H217.385C218.585 77.8321 219.557 78.8043 219.557 80.0035V80.0035C219.557 81.2028 218.585 82.175 217.385 82.175H179.746C178.547 82.175 177.575 81.2028 177.575 80.0035V80.0035Z"
					fill="black"
				/>
				<path
					d="M177.575 86.9523C177.575 85.7531 178.547 84.7809 179.746 84.7809H205.276C206.476 84.7809 207.448 85.7531 207.448 86.9523V86.9523C207.448 88.1516 206.476 89.1238 205.276 89.1238H179.746C178.547 89.1238 177.575 88.1516 177.575 86.9523V86.9523Z"
					fill="black"
				/>
				<path
					d="M173.225 25.524V65.1083H223.605V25.524H173.225ZM176.824 29.1226H220.007V54.1439L210.504 44.5852L209.211 43.292L201.058 51.445L190.712 40.9866L189.419 39.6934L176.824 52.2884V29.1226ZM212.81 32.7212C210.821 32.7212 209.211 34.3307 209.211 36.3197C209.211 38.3088 210.821 39.9183 212.81 39.9183C214.799 39.9183 216.408 38.3088 216.408 36.3197C216.408 34.3307 214.799 32.7212 212.81 32.7212ZM189.419 44.8101L205.95 61.5097H176.824V57.4051L189.419 44.8101ZM209.211 48.4087L220.007 59.2044V61.5097H211.067L203.588 53.9752L209.211 48.4087Z"
					fill="black"
				/>
			</svg>
		),
	},

	{
		title: "2 Col 0 Gap",
		data: {
			options: {
				gridTemplateColumns: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				gridTemplateRows: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				colGap: { val: 1, unit: "em" },
				rowGap: { val: 1, unit: "em" },
				itemCss: [],
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: "1", unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: "0", unit: "em" },
					Tablet: { val: "0", unit: "em" },
					Mobile: { val: "0", unit: "em" },
				},
				rowGap: {
					Desktop: { val: "0", unit: "em" },
					Tablet: { val: "0", unit: "em" },
					Mobile: { val: "0", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},
		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect x="38.5" y="8.5" width="83.0175" height="103" stroke="black" />
				<path
					d="M53.8952 75.7313C53.8952 74.2286 55.1134 73.0104 56.6161 73.0104H103.778C105.281 73.0104 106.499 74.2286 106.499 75.7313C106.499 77.234 105.281 78.4522 103.778 78.4522H56.6161C55.1134 78.4522 53.8952 77.234 53.8952 75.7313Z"
					fill="black"
				/>
				<path
					d="M53.8952 84.4382C53.8952 82.9355 55.1134 81.7173 56.6161 81.7173H103.778C105.281 81.7173 106.499 82.9355 106.499 84.4382C106.499 85.9409 105.281 87.1591 103.778 87.1591H56.6161C55.1134 87.1591 53.8952 85.9409 53.8952 84.4382Z"
					fill="black"
				/>
				<path
					d="M53.8952 93.1451C53.8952 91.6424 55.1134 90.4242 56.6161 90.4242H88.6054C90.1081 90.4242 91.3263 91.6424 91.3263 93.1451C91.3263 94.6478 90.1081 95.866 88.6054 95.866H56.6161C55.1134 95.866 53.8952 94.6478 53.8952 93.1451Z"
					fill="black"
				/>
				<path
					d="M48.4454 16.1747V65.7742H111.572V16.1747H48.4454ZM52.9545 20.6837H107.063V52.0357L95.1563 40.0585L93.5359 38.4381L83.3201 48.6539L70.3566 35.5495L68.7361 33.929L52.9545 49.7107V20.6837ZM98.0449 25.1928C95.5526 25.1928 93.5359 27.2095 93.5359 29.7018C93.5359 32.1941 95.5526 34.2109 98.0449 34.2109C100.537 34.2109 102.554 32.1941 102.554 29.7018C102.554 27.2095 100.537 25.1928 98.0449 25.1928ZM68.7361 40.3403L89.4496 61.2651H52.9545V56.122L68.7361 40.3403ZM93.5359 44.8494L107.063 58.3765V61.2651H95.8609L86.4905 51.8243L93.5359 44.8494Z"
					fill="black"
				/>
				<rect x="122.08" y="8.5" width="83.0175" height="103" stroke="black" />
				<path
					d="M137.475 75.7313C137.475 74.2286 138.693 73.0104 140.196 73.0104H187.358C188.861 73.0104 190.079 74.2286 190.079 75.7313C190.079 77.234 188.861 78.4522 187.358 78.4522H140.196C138.693 78.4522 137.475 77.234 137.475 75.7313Z"
					fill="black"
				/>
				<path
					d="M137.475 84.4382C137.475 82.9355 138.693 81.7173 140.196 81.7173H187.358C188.861 81.7173 190.079 82.9355 190.079 84.4382C190.079 85.9409 188.861 87.1591 187.358 87.1591H140.196C138.693 87.1591 137.475 85.9409 137.475 84.4382Z"
					fill="black"
				/>
				<path
					d="M137.475 93.1451C137.475 91.6424 138.693 90.4242 140.196 90.4242H172.185C173.688 90.4242 174.906 91.6424 174.906 93.1451C174.906 94.6478 173.688 95.866 172.185 95.866H140.196C138.693 95.866 137.475 94.6478 137.475 93.1451Z"
					fill="black"
				/>
				<path
					d="M132.025 16.1747V65.7742H195.152V16.1747H132.025ZM136.534 20.6837H190.643V52.0357L178.736 40.0585L177.116 38.4381L166.9 48.6539L153.936 35.5495L152.316 33.929L136.534 49.7107V20.6837ZM181.625 25.1928C179.132 25.1928 177.116 27.2095 177.116 29.7018C177.116 32.1941 179.132 34.2109 181.625 34.2109C184.117 34.2109 186.134 32.1941 186.134 29.7018C186.134 27.2095 184.117 25.1928 181.625 25.1928ZM152.316 40.3403L173.029 61.2651H136.534V56.122L152.316 40.3403ZM177.116 44.8494L190.643 58.3765V61.2651H179.441L170.07 51.8243L177.116 44.8494Z"
					fill="black"
				/>
			</svg>
		),
	},

	{
		title: "2 Col 1 Gap",
		data: {
			options: {
				gridTemplateColumns: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				gridTemplateRows: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				colGap: { val: 1, unit: "em" },
				rowGap: { val: 1, unit: "em" },
				itemCss: [],
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: "1", unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: "1", unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				rowGap: {
					Desktop: { val: "1", unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},
		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect
					x="37.5"
					y="9.5"
					width="81.7632"
					height="101.447"
					stroke="black"
				/>
				<path
					d="M52.6579 75.7202C52.6579 74.2399 53.8579 73.0399 55.3382 73.0399H101.796C103.277 73.0399 104.477 74.2399 104.477 75.7202V75.7202C104.477 77.2005 103.277 78.4005 101.796 78.4005H55.3382C53.8579 78.4005 52.6579 77.2005 52.6579 75.7202V75.7202Z"
					fill="black"
				/>
				<path
					d="M52.6579 84.297C52.6579 82.8168 53.8579 81.6168 55.3382 81.6168H101.796C103.277 81.6168 104.477 82.8168 104.477 84.297V84.297C104.477 85.7773 103.277 86.9773 101.796 86.9773H55.3382C53.8579 86.9773 52.6579 85.7773 52.6579 84.297V84.297Z"
					fill="black"
				/>
				<path
					d="M52.6579 92.8739C52.6579 91.3936 53.8579 90.1936 55.3382 90.1936H86.8499C88.3302 90.1936 89.5302 91.3936 89.5302 92.8739V92.8739C89.5302 94.3542 88.3302 95.5542 86.8499 95.5542H55.3382C53.8579 95.5542 52.6579 94.3542 52.6579 92.8739V92.8739Z"
					fill="black"
				/>
				<path
					d="M47.2895 17.0526V65.9117H109.474V17.0526H47.2895ZM51.7312 21.4944H105.032V52.3783L93.303 40.5799L91.7068 38.9837L81.6435 49.047L68.8735 36.1382L67.2773 34.542L51.7312 50.088V21.4944ZM96.1485 25.9361C93.6934 25.9361 91.7068 27.9227 91.7068 30.3778C91.7068 32.8329 93.6934 34.8196 96.1485 34.8196C98.6036 34.8196 100.59 32.8329 100.59 30.3778C100.59 27.9227 98.6036 25.9361 96.1485 25.9361ZM67.2773 40.8575L87.6815 61.4699H51.7312V56.4036L67.2773 40.8575ZM91.7068 45.2993L105.032 58.6245V61.4699H93.997L84.7666 52.1701L91.7068 45.2993Z"
					fill="black"
				/>
				<rect
					x="124.737"
					y="9.5"
					width="81.7632"
					height="101.447"
					stroke="black"
				/>
				<path
					d="M139.895 75.7202C139.895 74.2399 141.095 73.0399 142.575 73.0399H189.033C190.513 73.0399 191.713 74.2399 191.713 75.7202V75.7202C191.713 77.2005 190.513 78.4005 189.033 78.4005H142.575C141.095 78.4005 139.895 77.2005 139.895 75.7202V75.7202Z"
					fill="black"
				/>
				<path
					d="M139.895 84.297C139.895 82.8168 141.095 81.6168 142.575 81.6168H189.033C190.513 81.6168 191.713 82.8168 191.713 84.297V84.297C191.713 85.7773 190.513 86.9773 189.033 86.9773H142.575C141.095 86.9773 139.895 85.7773 139.895 84.297V84.297Z"
					fill="black"
				/>
				<path
					d="M139.895 92.8739C139.895 91.3936 141.095 90.1936 142.575 90.1936H174.087C175.567 90.1936 176.767 91.3936 176.767 92.8739V92.8739C176.767 94.3542 175.567 95.5542 174.087 95.5542H142.575C141.095 95.5542 139.895 94.3542 139.895 92.8739V92.8739Z"
					fill="black"
				/>
				<path
					d="M134.526 17.0526V65.9117H196.711V17.0526H134.526ZM138.968 21.4944H192.269V52.3783L180.54 40.5799L178.944 38.9837L168.88 49.047L156.11 36.1382L154.514 34.542L138.968 50.088V21.4944ZM183.385 25.9361C180.93 25.9361 178.944 27.9227 178.944 30.3778C178.944 32.8329 180.93 34.8196 183.385 34.8196C185.84 34.8196 187.827 32.8329 187.827 30.3778C187.827 27.9227 185.84 25.9361 183.385 25.9361ZM154.514 40.8575L174.918 61.4699H138.968V56.4036L154.514 40.8575ZM178.944 45.2993L192.269 58.6245V61.4699H181.234L172.003 52.1701L178.944 45.2993Z"
					fill="black"
				/>
			</svg>
		),
	},

	{
		title: "2 Col 2 Gap",
		data: {
			options: {
				gridTemplateColumns: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				gridTemplateRows: [
					{ val: 1, unit: "fr" },
					{ val: 1, unit: "fr" },
				],
				colGap: { val: 1, unit: "em" },
				rowGap: { val: 1, unit: "em" },
				itemCss: [],
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: "1", unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: "2", unit: "em" },
					Tablet: { val: "2", unit: "em" },
					Mobile: { val: "2", unit: "em" },
				},
				rowGap: {
					Desktop: { val: "2", unit: "em" },
					Tablet: { val: "2", unit: "em" },
					Mobile: { val: "2", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},
		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect x="34.5" y="9.5" width="81.4017" height="101" stroke="black" />
				<path
					d="M49.5895 75.4288C49.5895 73.955 50.7842 72.7603 52.258 72.7603H98.5133C99.9871 72.7603 101.182 73.955 101.182 75.4288V75.4288C101.182 76.9026 99.9871 78.0974 98.5133 78.0974H52.258C50.7842 78.0974 49.5895 76.9026 49.5895 75.4288V75.4288Z"
					fill="black"
				/>
				<path
					d="M49.5895 83.9683C49.5895 82.4944 50.7842 81.2997 52.258 81.2997H98.5133C99.9871 81.2997 101.182 82.4944 101.182 83.9683V83.9683C101.182 85.4421 99.9871 86.6368 98.5133 86.6368H52.258C50.7842 86.6368 49.5895 85.4421 49.5895 83.9683V83.9683Z"
					fill="black"
				/>
				<path
					d="M49.5895 92.5077C49.5895 91.0338 50.7842 89.8391 52.258 89.8391H83.6322C85.106 89.8391 86.3007 91.0338 86.3007 92.5077V92.5077C86.3007 93.9815 85.106 95.1762 83.6322 95.1762H52.258C50.7842 95.1762 49.5895 93.9815 49.5895 92.5077V92.5077Z"
					fill="black"
				/>
				<path
					d="M44.2446 17.0175V65.6632H106.157V17.0175H44.2446ZM48.6669 21.4398H101.735V52.1889L90.0572 40.442L88.4679 38.8528L78.4486 48.8721L65.7343 36.0197L64.1451 34.4304L48.6669 49.9086V21.4398ZM92.8902 25.8622C90.4459 25.8622 88.4679 27.8401 88.4679 30.2845C88.4679 32.7289 90.4459 34.7068 92.8902 34.7068C95.3346 34.7068 97.3126 32.7289 97.3126 30.2845C97.3126 27.8401 95.3346 25.8622 92.8902 25.8622ZM64.1451 40.7184L84.4602 61.2408H48.6669V56.1966L64.1451 40.7184ZM88.4679 45.1408L101.735 58.4078V61.2408H90.7482L81.558 51.9816L88.4679 45.1408Z"
					fill="black"
				/>
				<rect x="127.867" y="9.5" width="81.4017" height="101" stroke="black" />
				<path
					d="M142.957 75.4288C142.957 73.955 144.152 72.7603 145.625 72.7603H191.881C193.354 72.7603 194.549 73.955 194.549 75.4288V75.4288C194.549 76.9026 193.354 78.0974 191.881 78.0974H145.625C144.152 78.0974 142.957 76.9026 142.957 75.4288V75.4288Z"
					fill="black"
				/>
				<path
					d="M142.957 83.9683C142.957 82.4944 144.152 81.2997 145.625 81.2997H191.881C193.354 81.2997 194.549 82.4944 194.549 83.9683V83.9683C194.549 85.4421 193.354 86.6368 191.881 86.6368H145.625C144.152 86.6368 142.957 85.4421 142.957 83.9683V83.9683Z"
					fill="black"
				/>
				<path
					d="M142.957 92.5077C142.957 91.0338 144.152 89.8391 145.625 89.8391H177C178.473 89.8391 179.668 91.0338 179.668 92.5077V92.5077C179.668 93.9815 178.473 95.1762 177 95.1762H145.625C144.152 95.1762 142.957 93.9815 142.957 92.5077V92.5077Z"
					fill="black"
				/>
				<path
					d="M137.612 17.0175V65.6632H199.525V17.0175H137.612ZM142.034 21.4398H195.102V52.1889L183.424 40.442L181.835 38.8528L171.816 48.8721L159.102 36.0197L157.512 34.4304L142.034 49.9086V21.4398ZM186.258 25.8622C183.813 25.8622 181.835 27.8401 181.835 30.2845C181.835 32.7289 183.813 34.7068 186.258 34.7068C188.702 34.7068 190.68 32.7289 190.68 30.2845C190.68 27.8401 188.702 25.8622 186.258 25.8622ZM157.512 40.7184L177.827 61.2408H142.034V56.1966L157.512 40.7184ZM181.835 45.1408L195.102 58.4078V61.2408H184.115L174.925 51.9816L181.835 45.1408Z"
					fill="black"
				/>
			</svg>
		),
	},
	{
		title: "3 Col, nth(1)-2 Offset 1 Gap",
		data: {
			options: {
				itemCss: {
					Desktop: [
						{
							"grid-column-start": "1",
							"grid-column-end": "3",
							"grid-row-start": "",
							"grid-row-end": "",
						},
					],
				},
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: 1, unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				rowGap: {
					Desktop: { val: 1, unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},

		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect x="12.5" y="16.5" width="145" height="87" stroke="black" />
				<path
					d="M24 73.3111C24 72.0396 25.0308 71.0089 26.3023 71.0089H138.698C139.969 71.0089 141 72.0396 141 73.3111V73.3111C141 74.5827 139.969 75.6134 138.698 75.6134H26.3023C25.0308 75.6134 24 74.5827 24 73.3111V73.3111Z"
					fill="black"
				/>
				<path
					d="M24 80.6785C24 79.407 25.0308 78.3762 26.3023 78.3762H138.698C139.969 78.3762 141 79.407 141 80.6785V80.6785C141 81.95 139.969 82.9808 138.698 82.9808H26.3023C25.0308 82.9808 24 81.95 24 80.6785V80.6785Z"
					fill="black"
				/>
				<path
					d="M24 88.0458C24 86.7743 25.0308 85.7435 26.3023 85.7435H104.951C106.222 85.7435 107.253 86.7743 107.253 88.0458V88.0458C107.253 89.3174 106.222 90.3481 104.951 90.3481H26.3023C25.0308 90.3481 24 89.3174 24 88.0458V88.0458Z"
					fill="black"
				/>
				<path
					d="M58 22.9171V64.8859H111.415V22.9171H58ZM61.8153 26.7324H107.6V53.261L97.5246 43.1265L96.1535 41.7553L87.5093 50.3995L76.5402 39.3111L75.1691 37.94L61.8153 51.2937V26.7324ZM99.9688 30.5477C97.8599 30.5477 96.1535 32.2542 96.1535 34.3631C96.1535 36.472 97.8599 38.1784 99.9688 38.1784C102.078 38.1784 103.784 36.472 103.784 34.3631C103.784 32.2542 102.078 30.5477 99.9688 30.5477ZM75.1691 43.3649L92.6958 61.0705H61.8153V56.7186L75.1691 43.3649ZM96.1535 47.1803L107.6 58.6263V61.0705H98.1208L90.192 53.0821L96.1535 47.1803Z"
					fill="black"
				/>
				<rect x="162.369" y="16.5" width="70.0917" height="87" stroke="black" />
				<path
					d="M175.319 73.3111C175.319 72.0396 176.35 71.0089 177.621 71.0089H217.528C218.799 71.0089 219.83 72.0396 219.83 73.3111C219.83 74.5827 218.799 75.6134 217.528 75.6134H177.621C176.35 75.6134 175.319 74.5827 175.319 73.3111Z"
					fill="black"
				/>
				<path
					d="M175.319 80.6785C175.319 79.407 176.35 78.3762 177.621 78.3762H217.528C218.799 78.3762 219.83 79.407 219.83 80.6785C219.83 81.95 218.799 82.9808 217.528 82.9808H177.621C176.35 82.9808 175.319 81.95 175.319 80.6785Z"
					fill="black"
				/>
				<path
					d="M175.319 88.0458C175.319 86.7743 176.35 85.7435 177.621 85.7435H204.689C205.96 85.7435 206.991 86.7743 206.991 88.0458C206.991 89.3174 205.96 90.3481 204.689 90.3481H177.621C176.35 90.3481 175.319 89.3174 175.319 88.0458Z"
					fill="black"
				/>
				<path
					d="M170.707 22.917V64.8858H224.122V22.917H170.707ZM174.523 26.7324H220.307V53.2609L210.232 43.1264L208.861 41.7553L200.217 50.3994L189.248 39.3111L187.877 37.9399L174.523 51.2937V26.7324ZM212.676 30.5477C210.567 30.5477 208.861 32.2542 208.861 34.3631C208.861 36.4719 210.567 38.1784 212.676 38.1784C214.785 38.1784 216.492 36.4719 216.492 34.3631C216.492 32.2542 214.785 30.5477 212.676 30.5477ZM187.877 43.3649L205.403 61.0705H174.523V56.7186L187.877 43.3649ZM208.861 47.1802L220.307 58.6263V61.0705H210.828L202.899 53.0821L208.861 47.1802Z"
					fill="black"
				/>
			</svg>
		),
	},

	{
		title: "3 Col, nth(2)-2 Offset 1 Gap",
		data: {
			options: {
				itemCss: {
					Desktop: [
						{
							"grid-column-start": "",
							"grid-column-end": "",
							"grid-row-start": "",
							"grid-row-end": "",
						},
						{
							"grid-column-start": "2",
							"grid-column-end": "4",
							"grid-row-start": "",
							"grid-row-end": "",
						},
					],
				},
			},
			styles: {
				gridTemplateColumns: {
					Desktop: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Tablet: [
						{ val: 1, unit: "fr" },
						{ val: 1, unit: "fr" },
					],
					Mobile: [{ val: 1, unit: "fr" }],
				},
				gridTemplateRows: {},
				colGap: {
					Desktop: { val: 1, unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				rowGap: {
					Desktop: { val: 1, unit: "em" },
					Tablet: { val: "1", unit: "em" },
					Mobile: { val: "1", unit: "em" },
				},
				textAlign: {},
				color: {},
				bgColor: {},
				padding: {},
				margin: {},
			},
		},
		icon: (
			<svg
				width="245"
				height="120"
				viewBox="0 0 245 120"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<rect x="88.5" y="16.5" width="145" height="87" stroke="black" />
				<path
					d="M100 73.3111C100 72.0396 101.031 71.0089 102.302 71.0089H214.698C215.969 71.0089 217 72.0396 217 73.3111C217 74.5827 215.969 75.6134 214.698 75.6134H102.302C101.031 75.6134 100 74.5827 100 73.3111Z"
					fill="black"
				/>
				<path
					d="M100 80.6785C100 79.407 101.031 78.3762 102.302 78.3762H214.698C215.969 78.3762 217 79.407 217 80.6785C217 81.95 215.969 82.9808 214.698 82.9808H102.302C101.031 82.9808 100 81.95 100 80.6785Z"
					fill="black"
				/>
				<path
					d="M100 88.0458C100 86.7743 101.031 85.7435 102.302 85.7435H180.951C182.222 85.7435 183.253 86.7743 183.253 88.0458C183.253 89.3174 182.222 90.3481 180.951 90.3481H102.302C101.031 90.3481 100 89.3174 100 88.0458Z"
					fill="black"
				/>
				<path
					d="M134 22.9171V64.8859H187.415V22.9171H134ZM137.815 26.7324H183.6V53.261L173.525 43.1265L172.153 41.7553L163.509 50.3995L152.54 39.3111L151.169 37.94L137.815 51.2937V26.7324ZM175.969 30.5477C173.86 30.5477 172.153 32.2542 172.153 34.3631C172.153 36.472 173.86 38.1784 175.969 38.1784C178.078 38.1784 179.784 36.472 179.784 34.3631C179.784 32.2542 178.078 30.5477 175.969 30.5477ZM151.169 43.3649L168.696 61.0705H137.815V56.7186L151.169 43.3649ZM172.153 47.1803L183.6 58.6263V61.0705H174.121L166.192 53.0821L172.153 47.1803Z"
					fill="black"
				/>
				<rect x="12.5" y="16.5" width="70.0917" height="87" stroke="black" />
				<path
					d="M25.4498 73.3111C25.4498 72.0396 26.4805 71.0089 27.7521 71.0089H67.6586C68.9301 71.0089 69.9608 72.0396 69.9608 73.3111C69.9608 74.5827 68.9301 75.6134 67.6586 75.6134H27.7521C26.4805 75.6134 25.4498 74.5827 25.4498 73.3111Z"
					fill="black"
				/>
				<path
					d="M25.4498 80.6785C25.4498 79.407 26.4805 78.3762 27.7521 78.3762H67.6586C68.9301 78.3762 69.9608 79.407 69.9608 80.6785C69.9608 81.95 68.9301 82.9808 67.6586 82.9808H27.7521C26.4805 82.9808 25.4498 81.95 25.4498 80.6785Z"
					fill="black"
				/>
				<path
					d="M25.4498 88.0458C25.4498 86.7743 26.4805 85.7435 27.7521 85.7435H54.8199C56.0915 85.7435 57.1222 86.7743 57.1222 88.0458C57.1222 89.3174 56.0915 90.3481 54.8199 90.3481H27.7521C26.4805 90.3481 25.4498 89.3174 25.4498 88.0458Z"
					fill="black"
				/>
				<path
					d="M20.8384 22.917V64.8858H74.2533V22.917H20.8384ZM24.6538 26.7324H70.4379V53.2609L60.363 43.1264L58.9919 41.7553L50.3478 50.3994L39.3786 39.3111L38.0075 37.9399L24.6538 51.2937V26.7324ZM62.8072 30.5477C60.6984 30.5477 58.9919 32.2542 58.9919 34.3631C58.9919 36.4719 60.6984 38.1784 62.8072 38.1784C64.9161 38.1784 66.6226 36.4719 66.6226 34.3631C66.6226 32.2542 64.9161 30.5477 62.8072 30.5477ZM38.0075 43.3649L55.5342 61.0705H24.6538V56.7186L38.0075 43.3649ZM58.9919 47.1802L70.4379 58.6263V61.0705H60.9592L53.0304 53.0821L58.9919 47.1802Z"
					fill="black"
				/>
			</svg>
		),
	},
];

addFilter("gridLayouts", "combo-blocks/gridLayouts", function (options) {
	return gridLayoutsPro;
});

const queryPresetsPro = [
	{
		label: "Latest Posts by Publish Date",
		key: "preset1",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "DESC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["date"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
	{
		label: "Oldest Posts by Publish Date",
		key: "preset2",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "ASC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["date"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
	{
		label: "Latest Posts by Modified Date",
		key: "preset3",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "DESC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["modified"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
	{
		label: "Oldest Posts by Modified Date",
		key: "preset4",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "ASC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["modified"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
	{
		label: "Alphabetical Order A-Z",
		key: "preset5",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "ASC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["name"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
	{
		label: "Alphabetical Order Z-A",
		key: "preset6",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "DESC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["name"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
	{
		label: "Most Commented Posts",
		key: "preset7",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "DESC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["name"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
	{
		label: "Random 10 Posts",
		key: "preset8",
		value: {
			items: [
				{
					val: ["post"],
					multiple: false,
					id: "postType",
					label: "Post Types",
					description: "Select Post Types to Query",
				},
				{
					val: ["publish"],
					multiple: false,
					id: "postStatus",
					label: "Post status",
					description: "Query post by post status",
				},
				{
					val: "DESC",
					multiple: false,
					id: "order",
					label: "Order",
					description: "Post query order",
				},
				{
					val: ["rand"],
					multiple: false,
					id: "orderby",
					label: "Orderby",
					description: "Post query orderby",
				},
				{
					val: "10",
					multiple: false,
					id: "postsPerPage",
					label: "Posts Per Page",
					description: "",
				},
			],
		},
	},
];

addFilter("queryPresets", "combo-blocks/queryPresets", function (options) {
	return queryPresetsPro;
});